import type { PromptTemplateSummary } from '../types';

export const TH_SKILL_COPY: Record<string, { description?: string; examplePrompt?: string }> = {
  '8-bit-orbit-video-template': {
    description:
      'เทมเพลตวิดีโอที่ใช้ Hyperframes สำหรับงานออกแบบโมชันสไตล์ retro pixel deck\nใช้เมื่อผู้ใช้ต้องการคอมโพสิชัน HTML-to-video หลายฉากความละเอียดสูง\nพร้อมทรานซิชันขั้นสูง ตัวควบคุมพรีวิวแบบโต้ตอบ และสไตล์เริ่มต้น\nที่พร้อมเรนเดอร์',
    examplePrompt:
      'สร้าง deck วิดีโอ Hyperframes 3 หน้าในสไตล์ retro แบบ 8-bit พร้อมทรานซิชันขั้นสูง โมชันที่หลากหลาย และแต่ละหน้าความยาวไม่เกิน 3 วินาที',
  },
  'ad-creative': {
    description:
      'สร้างและปรับปรุงครีเอทีฟโฆษณา รวมถึงพาดหัว คำอธิบาย และข้อความหลัก มีประโยชน์สำหรับการปรับปรุงโฆษณาบนโซเชียลแบบเสียเงินและโฆษณาบนการค้นหา',
    examplePrompt:
      'สร้างและปรับปรุงครีเอทีฟโฆษณา รวมถึงพาดหัว คำอธิบาย และข้อความหลัก',
  },
  'after-hours-editorial-template': {
    description:
      'เทมเพลต HyperFrames สไตล์ luxury dark-editorial สำหรับสตอรีบอร์ดเชิงภาพยนตร์สามหน้า\nได้แรงบันดาลใจจากการ์ดไตเติล haute couture และสเปรดบทนิตยสาร ใช้เมื่อ\nผู้ใช้ต้องการหน้าโมชันสไตล์แฟชั่นระดับพรีเมียม การเล่าเรื่องโทนหม่นที่นำด้วยฟอนต์ serif\nหรือสุนทรียะการนำเสนอโทนมืดระดับไฮเอนด์พร้อมทรานซิชันที่หลากหลาย',
    examplePrompt:
      'สร้างซีเควนซ์ editorial HyperFrames สามหน้าในสไตล์ dark haute-couture: ตัวอักษร serif ระดับพรีเมียม สีเน้น magenta ทรานซิชันบทที่หรูหรา และเกรนเชิงภาพยนตร์ ให้แต่ละหน้าความยาวไม่เกิน 3 วินาที',
  },
  'agent-browser': {
    description:
      'CLI สำหรับการทำงานอัตโนมัติบนเบราว์เซอร์สำหรับ AI agent ใช้เมื่อผู้ใช้ต้องการตรวจสอบ\nทดสอบ หรือทำงานอัตโนมัติกับพฤติกรรมของเบราว์เซอร์: นำทางหน้าเว็บ กรอกฟอร์ม\nคลิกปุ่ม จับภาพหน้าจอ ดึงข้อมูลหน้าเว็บ อ่านบริบทของแท็บเบราว์เซอร์ Open Design\nที่เลือก ทดสอบเว็บแอป dogfooding พรีวิว Open Design\nQA การไล่หาบั๊ก หรือทบทวนคุณภาพของแอป แนะนำให้ใช้ URL พรีวิว Open Design\nในเครื่อง เว้นแต่ผู้ใช้จะขอให้เรียกดูภายนอกอย่างชัดเจน',
    examplePrompt:
      'CLI สำหรับการทำงานอัตโนมัติบนเบราว์เซอร์สำหรับ AI agent',
  },
  'ai-music-album': {
    description:
      'การผลิตอัลบั้มเพลง AI แบบครบวงจร — แนวคิด การร่างเนื้อเพลง การจัดลำดับแทร็ก และการส่งออก มีประโยชน์สำหรับการทดลองอัลบั้มอินดี้และซาวด์แทร็กของแบรนด์',
    examplePrompt:
      'การผลิตอัลบั้มเพลง AI แบบครบวงจร — แนวคิด การร่างเนื้อเพลง การจัดลำดับแทร็ก และการส่งออก',
  },
  'algorithmic-art': {
    description:
      'สร้างงานศิลปะเชิงกำเนิด (generative art) โดยใช้ p5.js พร้อมความสุ่มแบบ seeded เพื่อให้ทุกการเรนเดอร์ทำซ้ำได้ มีประโยชน์สำหรับโปสเตอร์เชิงกระบวนการ ภาพนิ่งสไตล์โมชัน และการศึกษาเฟรมเชิงศิลปะ',
    examplePrompt:
      'สร้างงานศิลปะเชิงกำเนิด (generative art) โดยใช้ p5.js พร้อมความสุ่มแบบ seeded เพื่อให้ทุกการเรนเดอร์ทำซ้ำได้',
  },
  'apple-hig': {
    description:
      'Apple Human Interface Guidelines ในรูปแบบ agent skill 14 รายการ ครอบคลุมแพลตฟอร์ม รากฐาน คอมโพเนนต์ รูปแบบ อินพุต และเทคโนโลยีสำหรับ iOS, macOS, visionOS, watchOS และ tvOS',
    examplePrompt:
      'Apple Human Interface Guidelines ในรูปแบบ agent skill 14 รายการ ครอบคลุมแพลตฟอร์ม รากฐาน คอมโพเนนต์ รูปแบบ อินพุต และเทคโนโลยีสำหรับ iOS, macOS, visionOS, watchOS และ tvOS',
  },
  'article-magazine': {
    description:
      'เลย์เอาต์บทความนิตยสารที่ได้แรงบันดาลใจจาก Huashu / huashu-md-html สำหรับเปลี่ยน Markdown หรือบันทึกให้เป็นบทความ HTML แบบยาวที่ขัดเกลาแล้ว',
    examplePrompt:
      'ใช้เทมเพลต Magazine Article เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นบทความ HTML แบบยาวที่ได้แรงบันดาลใจจาก Huashu / huashu-md-html รักษาเอกลักษณ์ทางภาพของเทมเพลต ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพ placeholder',
  },
  'artifacts-builder': {
    description:
      'ชุดเครื่องมือสำหรับสร้าง artifact HTML ของ claude.ai ที่ซับซ้อนและมีหลายคอมโพเนนต์ โดยใช้เทคโนโลยีเว็บฟรอนต์เอนด์สมัยใหม่ (React, Tailwind CSS, shadcn/ui)',
    examplePrompt:
      'ชุดเครื่องมือสำหรับสร้าง artifact HTML ของ claude.ai ที่ซับซ้อนและมีหลายคอมโพเนนต์ โดยใช้เทคโนโลยีเว็บฟรอนต์เอนด์สมัยใหม่ (React, Tailwind CSS, shadcn/ui)',
  },
  'brainstorming': {
    description:
      'เปลี่ยนไอเดียคร่าว ๆ ให้เป็นงานออกแบบที่สมบูรณ์ ผ่านการตั้งคำถามอย่างมีโครงสร้างและการสำรวจทางเลือก มีประโยชน์ในช่วงเริ่มต้นของงานคอนเซปต์',
    examplePrompt:
      'เปลี่ยนไอเดียคร่าว ๆ ให้เป็นงานออกแบบที่สมบูรณ์ ผ่านการตั้งคำถามอย่างมีโครงสร้างและการสำรวจทางเลือก',
  },
  'brand-guidelines': {
    description:
      'ใช้สีและตัวอักษรของแบรนด์อย่างเป็นทางการของ Anthropic กับ artifact เพื่อเอกลักษณ์ทางภาพที่สอดคล้องกันและมาตรฐานการออกแบบระดับมืออาชีพ เป็นข้อมูลอ้างอิงสำหรับการสร้างเอกลักษณ์ของคุณเอง',
    examplePrompt:
      'ใช้สีและตัวอักษรของแบรนด์อย่างเป็นทางการของ Anthropic กับ artifact เพื่อเอกลักษณ์ทางภาพที่สอดคล้องกันและมาตรฐานการออกแบบระดับมืออาชีพ',
  },
  'brandkit': {
    description:
      'สกิลสร้างภาพ brand-kit ระดับพรีเมียมสำหรับสร้างบอร์ดแนวทางแบรนด์ระดับไฮเอนด์ ระบบโลโก้ identity deck และการนำเสนอโลกเชิงภาพ ฝึกมาสำหรับระบบแบรนด์แบบมินิมัล เชิงภาพยนตร์ editorial dark-tech luxury วัฒนธรรม ความปลอดภัย เกม เครื่องมือสำหรับนักพัฒนา และแอปผู้บริโภค ปรับให้เหมาะสมสำหรับการคิดคอนเซปต์โลโก้อย่างมีเจตนา องค์ประกอบที่ประณีต ตัวอักษรที่เรียบโปร่ง ความหมายเชิงสัญลักษณ์ที่ชัดเจน ม็อกอัประดับพรีเมียม ภาพที่กำกับศิลป์ และเลย์เอาต์กริดที่ยืดหยุ่น',
    examplePrompt:
      'สร้างภาพภาพรวม brand-kit ระดับพรีเมียมสำหรับผลิตภัณฑ์นี้: ทิศทางโลโก้ พาเลตต์สี ตัวอักษร การนำไปใช้ และโลกเชิงภาพที่สอดคล้องกัน',
  },
  'industrial-brutalist-ui': {
    description:
      'อินเทอร์เฟซเชิงกลไกดิบ ๆ ที่ผสานงานพิมพ์ตัวอักษรแบบสวิสเข้ากับสุนทรียะเทอร์มินัลทหาร กริดที่เข้มงวด ความต่างของสเกลตัวอักษรขั้นสุด สีแบบใช้งานจริง และเอฟเฟกต์การเสื่อมสภาพแบบอนาล็อก เหมาะสำหรับแดชบอร์ดที่มีข้อมูลหนาแน่น พอร์ตโฟลิโอ หรือเว็บไซต์ editorial ที่ต้องการความรู้สึกเหมือนพิมพ์เขียวที่ถูกปลดความลับ',
    examplePrompt:
      'สร้างอินเทอร์เฟซแบบ industrial-brutalist ด้วยกริดที่เข้มงวด ลวดลายเทเลเมตรีเชิงยุทธวิธี ตัวอักษรที่ทรงพลัง และความแม่นยำเชิงกลไก',
  },
  'canvas-design': {
    description:
      'สร้างงานศิลปะภาพที่สวยงามในเอกสาร PNG และ PDF โดยใช้ปรัชญาการออกแบบและหลักสุนทรียะ สำหรับโปสเตอร์ ภาพประกอบ และชิ้นงานนิ่ง',
    examplePrompt:
      'สร้างงานศิลปะภาพที่สวยงามในเอกสาร PNG และ PDF โดยใช้ปรัชญาการออกแบบและหลักสุนทรียะ สำหรับโปสเตอร์ ภาพประกอบ และชิ้นงานนิ่ง',
  },
  'card-twitter': {
    description:
      'การ์ดคำคมหรือการ์ดข้อมูลของ Twitter ออกแบบมาเพื่อใช้คู่กับโพสต์',
    examplePrompt:
      'ใช้เทมเพลต Twitter Share Card เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นการ์ดคำคมหรือการ์ดข้อมูลของ Twitter ที่ออกแบบมาเพื่อใช้คู่กับโพสต์ รักษาเอกลักษณ์ทางภาพของเทมเพลต ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพ placeholder',
  },
  'card-xiaohongshu': {
    description:
      'การ์ดความรู้สไตล์ Xiaohongshu จัดเรียงเป็นคารูเซลการ์ดหลายใบที่ปัดได้',
    examplePrompt:
      'ใช้เทมเพลต Xiaohongshu Card เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นคารูเซลการ์ดความรู้สไตล์ Xiaohongshu ที่ปัดได้ รักษาเอกลักษณ์ทางภาพของเทมเพลต ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพ placeholder',
  },
  'color-expert': {
    description:
      'สกิลผู้เชี่ยวชาญด้านวิทยาศาสตร์สี พร้อมเอกสารอ้างอิง 286K คำ ครอบคลุม OKLCH/OKLAB การสร้างพาเลตต์ การเข้าถึงได้/คอนทราสต์ การตั้งชื่อสี การผสมเม็ดสี และทฤษฎีสีเชิงประวัติศาสตร์',
    examplePrompt:
      'สกิลผู้เชี่ยวชาญด้านวิทยาศาสตร์สี พร้อมเอกสารอ้างอิง 286K คำ ครอบคลุม OKLCH/OKLAB การสร้างพาเลตต์ การเข้าถึงได้/คอนทราสต์ การตั้งชื่อสี การผสมเม็ดสี และทฤษฎีสีเชิงประวัติศาสตร์',
  },
  'competitive-ads-extractor': {
    description:
      'ดึงและวิเคราะห์โฆษณาของคู่แข่งจากคลังโฆษณา เพื่อเข้าใจข้อความและแนวทางครีเอทีฟที่เข้าถึงผู้คน',
    examplePrompt:
      'ดึงและวิเคราะห์โฆษณาของคู่แข่งจากคลังโฆษณา เพื่อเข้าใจข้อความและแนวทางครีเอทีฟที่เข้าถึงผู้คน',
  },
  'copywriting': {
    description:
      'เขียนและเขียนใหม่ก๊อปปี้การตลาดสำหรับแลนดิงเพจ หน้าโฮม และโฆษณา มีประโยชน์ในการเป็นพาร์ตเนอร์หัวหน้าก๊อปปี้ในช่วงเปิดตัว',
    examplePrompt:
      'เขียนและเขียนใหม่ก๊อปปี้การตลาดสำหรับแลนดิงเพจ หน้าโฮม และโฆษณา',
  },
  'creative-director': {
    description:
      'ครีเอทีฟไดเรกเตอร์ AI พร้อมการประเมินตนเองแบบเรียกซ้ำ: เมธอดมากกว่า 20 แบบ (SIT, TRIZ, Bisociation, SCAMPER, Synectics) การประเมิน 3 แกนที่ปรับเทียบกับ Cannes/D&AD/HumanKind กระบวนการ 5 เฟสตั้งแต่บรีฟจนถึงการนำเสนอ',
    examplePrompt:
      'ครีเอทีฟไดเรกเตอร์ AI พร้อมการประเมินตนเองแบบเรียกซ้ำ: เมธอดมากกว่า 20 แบบ (SIT, TRIZ, Bisociation, SCAMPER, Synectics) การประเมิน 3 แกนที่ปรับเทียบกับ Cannes/D&AD/HumanKind กระบวนการ 5 เฟสตั้งแต่บรีฟจนถึงการนำเสนอ',
  },
  'd3-visualization': {
    description:
      'สอนให้เอเจนต์สร้างแผนภูมิ D3 และการแสดงข้อมูลแบบโต้ตอบ ทักษะ D3.js ที่ครอบคลุมพร้อมตัวอย่างหลากหลายประเภทแผนภูมิและเทคนิค ทำให้เอเจนต์มีความรู้ระดับผู้เชี่ยวชาญในการสร้างการแสดงข้อมูลที่ซับซ้อนและโต้ตอบได้ เหมาะสำหรับแดชบอร์ดเชิงบรรณาธิการ รายงาน ต้นแบบที่อุดมด้วยข้อมูล และกราฟิกเชิงอธิบาย',
    examplePrompt:
      'สอนให้เอเจนต์สร้างแผนภูมิ D3 และการแสดงข้อมูลแบบโต้ตอบ',
  },
  'data-report': {
    description:
      'เปลี่ยนข้อมูล CSV, Excel หรือ JSON ให้เป็นหน้ารายงานเชิงภาพที่ดูเรียบหรู',
    examplePrompt:
      'ใช้เทมเพลต Data Visualization Report เพื่อเปลี่ยนข้อมูล CSV, Excel หรือ JSON ของฉันให้เป็นหน้ารายงานเชิงภาพที่ดูเรียบหรู คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพตัวอย่าง',
  },
  'deck-guizang-editorial': {
    description:
      'นิตยสารเชิงบรรณาธิการผสานกับ e-ink: 10 เลย์เอาต์และ 5 ชุดสี (Ink, Indigo Porcelain, Forest Ink, Kraft Paper, Dune)',
    examplePrompt:
      'ใช้เทมเพลต Guizang Editorial E-Ink Deck เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเด็คแนวนอนแบบนิตยสารเชิงบรรณาธิการผสาน e-ink พร้อม 10 เลย์เอาต์และ 5 ชุดสี คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพตัวอย่าง',
  },
  'deck-open-slide-canvas': {
    description:
      'เด็คแคนวาสล็อกขนาด 1920x1080 พร้อมการจัดองค์ประกอบอิสระระดับคอมโพเนนต์ React ไม่ผูกกับเทมเพลตตายตัว',
    examplePrompt:
      'ใช้เทมเพลต Open-Slide 1920 Canvas Deck เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเด็คจัดองค์ประกอบอิสระล็อกขนาด 1920x1080 พร้อมเลย์เอาต์ระดับคอมโพเนนต์ React คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพตัวอย่าง',
  },
  'deck-swiss-international': {
    description:
      'กริด 16 คอลัมน์ สีเน้นอิ่มตัวหนึ่งสี และ 22 เลย์เอาต์ล็อก (Klein Blue, Lemon, Mint, Safety Orange)',
    examplePrompt:
      'ใช้เทมเพลต Swiss International Deck เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเด็คกริด 16 คอลัมน์พร้อมสีเน้นอิ่มตัวหนึ่งสีและ 22 เลย์เอาต์ล็อก คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพตัวอย่าง',
  },
  'design-brief': {
    description:
      'แยกวิเคราะห์บรีฟการออกแบบที่มีโครงสร้างซึ่งเขียนในรูปแบบโปรโตคอล I-Lang ให้เป็น\nสเปกการออกแบบที่เป็นรูปธรรม ขจัดความคลุมเครือจากคำขอที่กำกวมอย่าง\n"ทำให้ดูมืออาชีพ" โดยกำหนดให้ต้องระบุมิติอย่างชัดเจน: ชุดสี การจัดวางตัวอักษร\nเลย์เอาต์ อารมณ์ ความหนาแน่น และข้อจำกัด\nคำกระตุ้น: "design brief", "create a design brief", "ilang brief", "structured brief"',
    examplePrompt:
      'แยกวิเคราะห์บรีฟการออกแบบที่มีโครงสร้างซึ่งเขียนในรูปแบบโปรโตคอล I-Lang ให้เป็นสเปกการออกแบบที่เป็นรูปธรรม',
  },
  'design-consultation': {
    description:
      'สร้างระบบการออกแบบที่สมบูรณ์ตั้งแต่ศูนย์ด้วยความกล้าเชิงสร้างสรรค์และม็อกอัปผลิตภัณฑ์ที่สมจริง เหมาะสำหรับเวิร์กช็อปเริ่มต้นและงานสร้างแบรนด์ตั้งแต่ศูนย์',
    examplePrompt:
      'สร้างระบบการออกแบบที่สมบูรณ์ตั้งแต่ศูนย์ด้วยความกล้าเชิงสร้างสรรค์และม็อกอัปผลิตภัณฑ์ที่สมจริง',
  },
  'design-md': {
    description:
      'สร้างและจัดการไฟล์ DESIGN.md เหมาะสำหรับการบันทึกทิศทางการออกแบบ โทเค็น และกฎเชิงภาพไว้ในแหล่งความจริงเดียว',
    examplePrompt:
      'สร้างและจัดการไฟล์ DESIGN.md',
  },
  'design-review': {
    description:
      'Designer Who Codes: ตรวจสอบเชิงภาพแล้วแก้ไขด้วยการคอมมิตแบบอะตอมิกและภาพหน้าจอก่อน/หลัง เหมาะสำหรับการปรับ UI ที่ส่งมอบแล้วให้รัดกุมก่อนเปิดตัว',
    examplePrompt:
      'Designer Who Codes: ตรวจสอบเชิงภาพแล้วแก้ไขด้วยการคอมมิตแบบอะตอมิกและภาพหน้าจอก่อน/หลัง',
  },
  'digits-fintech-swiss-template': {
    description:
      'เทมเพลตเด็คฟินเทคแบบกริดสวิสในโทนตัดกันสีดำ / กระดาษโทนอุ่น / นีออนไลม์\nใช้เมื่อผู้ใช้ต้องการสไลด์เล่าเรื่องข้อมูลระดับพรีเมียมที่มีเลย์เอาต์โมดูลาร์เข้มงวด\nการ์ดตัวเลขหนา การเคลื่อนไหวที่ยับยั้ง และการนำทางด้วยคีย์บอร์ด/คลิกในไฟล์ HTML เดียว',
    examplePrompt:
      'สร้างเด็คกลยุทธ์ฟินเทคแบบกริดสวิสพร้อมการ์ดข้อมูลโมดูลาร์ สีเน้นไลม์ และการนำทางด้วยคีย์บอร์ดที่สะอาดตา',
  },
  'doc': {
    description:
      'อ่าน สร้าง และแก้ไขเอกสาร .docx โดยคงความเที่ยงตรงของรูปแบบและเลย์เอาต์ ผ่านทักษะเอกสารของ OpenAI',
    examplePrompt:
      'อ่าน สร้าง และแก้ไขเอกสาร .docx โดยคงความเที่ยงตรงของรูปแบบและเลย์เอาต์ ผ่านทักษะเอกสารของ OpenAI',
  },
  'doc-kami-parchment': {
    description:
      'แคนวาสกระดาษโทนอุ่น (#f5f4ed) สีเน้นน้ำเงินหมึกโมโนโครม (#1B365D) ฟอนต์ตระกูล serif หนึ่งตระกูล และการจัดวางตัวอักษรระดับบรรณาธิการ',
    examplePrompt:
      'ใช้เทมเพลต Kami Parchment Document เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเอกสารกระดาษโทนอุ่นพร้อมสีเน้นน้ำเงินหมึกโมโนโครม ฟอนต์ตระกูล serif หนึ่งตระกูล และการจัดวางตัวอักษรระดับบรรณาธิการ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพตัวอย่าง',
  },
  'docx': {
    description:
      'สร้าง แก้ไข และวิเคราะห์เอกสาร Word พร้อมการติดตามการเปลี่ยนแปลง ความคิดเห็น และการจัดรูปแบบ เหมาะสำหรับบรีฟการออกแบบ เอกสารข้อความ และผลงานที่พร้อมตรวจทาน',
    examplePrompt:
      'สร้าง แก้ไข และวิเคราะห์เอกสาร Word พร้อมการติดตามการเปลี่ยนแปลง ความคิดเห็น และการจัดรูปแบบ',
  },
  'domain-name-brainstormer': {
    description:
      'สร้างไอเดียชื่อโดเมนเชิงสร้างสรรค์และตรวจสอบความพร้อมใช้งานในหลาย TLD รวมถึง .com, .io, .dev และ .ai',
    examplePrompt:
      'สร้างไอเดียชื่อโดเมนเชิงสร้างสรรค์และตรวจสอบความพร้อมใช้งานในหลาย TLD รวมถึง .com, .io, .dev และ .ai',
  },
  'ecommerce-image-workflow': {
    description:
      'เวิร์กโฟลว์ภาพอีคอมเมิร์ซแบบอ้างอิงผลิตภัณฑ์สำหรับสร้างชุดภาพที่กระชับ\nของภาพหลัก ภาพคุณสมบัติ และภาพไลฟ์สไตล์ที่ตรงกับผลิตภัณฑ์จากภาพถ่าย\nอ้างอิงผลิตภัณฑ์จริง V1 ต้องอัปโหลดภาพผลิตภัณฑ์และตั้งใจ\nเลื่อนการสร้างคอนเซ็ปต์จากบรีฟอย่างเดียวและการส่งออกแบบกลุ่มเฉพาะแพลตฟอร์มออกไปก่อน',
    examplePrompt:
      'ใช้ Ecommerce Image Workflow เพื่อเปลี่ยนภาพถ่ายอ้างอิงผลิตภัณฑ์ที่ฉัน\nอัปโหลดให้เป็นชุดภาพอีคอมเมิร์ซที่กระชับ: ภาพ packshot หลักหนึ่งภาพ ภาพ\nเน้นคุณสมบัติหนึ่งภาพ และฉากไลฟ์สไตล์หนึ่งภาพ คงเอกลักษณ์ของผลิตภัณฑ์\nสี วัสดุ ตำแหน่งโลโก้ โครงสร้าง และสัดส่วนไว้อย่างแม่นยำ',
  },
  'editorial-burgundy-principles-template': {
    description:
      'เทมเพลตเด็คสตูดิโอเชิงบรรณาธิการในชุดสีเบอร์กันดี / บลัช / ทองนวล\nใช้เมื่อผู้ใช้ต้องการสไลด์แถลงการณ์หรือวัฒนธรรมระดับพรีเมียมที่มีแท็กแบบ pill\nข้อความตัวอักษรขนาดใหญ่ การ์ดหลักการ และการนำทางด้วยคีย์บอร์ด/คลิกแบบมีไกด์',
    examplePrompt:
      'สร้างเด็คเชิงบรรณาธิการระดับพรีเมียมในโทนเบอร์กันดีและบลัช พร้อมสไลด์คลาวด์แท็กและกริดการ์ดแปดหลักการ',
  },
  'emilkowalski-motion': {
    description:
      'ทักษะต่อยอดด้านการออกแบบการเคลื่อนไหวที่ได้แรงบันดาลใจจากแนวทางแอนิเมชันของ Emil Kowalski ใช้หลังจากมีอินเทอร์เฟซแล้วเพื่อเพิ่มไมโครอินเทอร์แอกชันที่มีรสนิยม การเปลี่ยนสถานะ และการเคลื่อนไหวของหน้าด้วยความยับยั้งระดับผลิตภัณฑ์',
    examplePrompt:
      'ใช้ emilkowalski-motion กับ HTML artifact ปัจจุบัน: เพิ่มไมโครอินเทอร์แอกชันที่ยับยั้ง การเปลี่ยนสถานะ และทางเลือกสำรองแบบ reduced-motion โดยไม่เปลี่ยนเลย์เอาต์หลัก',
  },
  'enhance-prompt': {
    description:
      'ปรับปรุงพรอมต์ด้วยสเปกการออกแบบและคำศัพท์ UI/UX เหมาะสำหรับเวิร์กโฟลว์ design-to-code และการทำให้คำขอผลงานเชิงภาพชัดเจนขึ้น',
    examplePrompt:
      'ปรับปรุงพรอมต์ด้วยสเปกการออกแบบและคำศัพท์ UI/UX',
  },
  'export-download-debugging': {
    description:
      'วินิจฉัยและแก้ไขความล้มเหลวของการส่งออก/ดาวน์โหลดในเบราว์เซอร์ พรีวิว หรือ Electron โดยเฉพาะปัญหาการส่งออกภาพที่เกี่ยวข้องกับ Save As, Blob/Data URLs, File System Access API, ความล้มเหลวของ createWritable และไฟล์ขนาด 0 KB',
    examplePrompt:
      'วินิจฉัยและแก้ไขความล้มเหลวของการส่งออก/ดาวน์โหลดในเบราว์เซอร์ พรีวิว หรือ Electron โดยเฉพาะปัญหาการส่งออกภาพที่เกี่ยวข้องกับ Save As, Blob/Data URLs, File System Access API, ความล้มเหลวของ createWritable และไฟล์ขนาด 0 KB',
  },
  'fal-3d': {
    description:
      'สร้างโมเดล 3D จากข้อความหรือภาพผ่าน fal.ai เหมาะสำหรับแอสเซ็ตเกม พรีวิว AR ม็อกอัปผลิตภัณฑ์ และการปั้นคอนเซ็ปต์',
    examplePrompt:
      'สร้างโมเดล 3D จากข้อความหรือภาพผ่าน fal.ai',
  },
  'fal-generate': {
    description:
      'สร้างภาพและวิดีโอด้วยโมเดล AI ของ fal.ai แคตตาล็อกระดับโปรดักชันครอบคลุม Flux, SDXL, ideogram และ endpoint อื่น ๆ ที่โฮสต์โดยชุมชน',
    examplePrompt:
      'สร้างภาพและวิดีโอด้วยโมเดล AI ของ fal.ai',
  },
  'fal-image-edit': {
    description:
      'แก้ไขภาพด้วย AI ทั้งการถ่ายโอนสไตล์ ลบพื้นหลัง ลบวัตถุ และ inpainting ผ่านโมเดลที่โฮสต์บน fal.ai',
    examplePrompt:
      'แก้ไขภาพด้วย AI ทั้งการถ่ายโอนสไตล์ ลบพื้นหลัง ลบวัตถุ และ inpainting ผ่านโมเดลที่โฮสต์บน fal.ai',
  },
  'fal-kling-o3': {
    description:
      'สร้างภาพและวิดีโอด้วย Kling O3 — ตระกูลโมเดลที่ทรงพลังที่สุดของ Kling — ผ่าน fal.ai',
    examplePrompt:
      'สร้างภาพและวิดีโอด้วย Kling O3 — ตระกูลโมเดลที่ทรงพลังที่สุดของ Kling — ผ่าน fal.ai',
  },
  'fal-lip-sync': {
    description:
      'สร้างวิดีโอ talking head และซิงก์ปากเสียงเข้ากับวิดีโอผ่าน fal.ai เหมาะสำหรับอวตารอธิบายเนื้อหา พรีวิวพากย์เสียงหลายภาษา และคลิปสำหรับโซเชียล',
    examplePrompt:
      'สร้างวิดีโอ talking head และซิงก์ปากเสียงเข้ากับวิดีโอผ่าน fal.ai',
  },
  'fal-realtime': {
    description:
      'สร้างภาพด้วย AI แบบเรียลไทม์และสตรีมมิงผ่าน fal.ai เหมาะสำหรับการสำรวจ moodboard สร้างเวอร์ชันร่าง และการทำซ้ำเชิงสร้างสรรค์อย่างรวดเร็ว',
    examplePrompt:
      'สร้างภาพด้วย AI แบบเรียลไทม์และสตรีมมิงผ่าน fal.ai',
  },
  'fal-restore': {
    description:
      'กู้คืนและซ่อมคุณภาพของภาพ — ลดความเบลอ ลด noise ซ่อมใบหน้า และกู้คืนเอกสารเก่าโดยใช้โมเดลกู้คืนภาพที่โฮสต์บน fal.ai',
    examplePrompt:
      'กู้คืนและซ่อมคุณภาพของภาพ — ลดความเบลอ ลด noise ซ่อมใบหน้า และกู้คืนเอกสารเก่าโดยใช้โมเดลกู้คืนภาพที่โฮสต์บน fal.ai',
  },
  'fal-train': {
    description:
      'ฝึกโมเดล AI แบบกำหนดเอง (LoRA) บน fal.ai สำหรับการสร้างภาพเฉพาะบุคคลที่ปรับให้เหมาะกับแบรนด์ ตัวละคร หรือสไตล์',
    examplePrompt:
      'ฝึกโมเดล AI แบบกำหนดเอง (LoRA) บน fal.ai สำหรับการสร้างภาพเฉพาะบุคคลที่ปรับให้เหมาะกับแบรนด์ ตัวละคร หรือสไตล์',
  },
  'fal-tryon': {
    description:
      'ลองสวมใส่เสมือนจริง — ดูว่าเสื้อผ้าดูเป็นอย่างไรเมื่อสวมบนตัวบุคคลผ่านโมเดล try-on ที่โฮสต์บน fal.ai เหมาะสำหรับอีคอมเมิร์ซ lookbook และการทดลองจัดสไตล์',
    examplePrompt:
      'ลองสวมใส่เสมือนจริง — ดูว่าเสื้อผ้าดูเป็นอย่างไรเมื่อสวมบนตัวบุคคลผ่านโมเดล try-on ที่โฮสต์บน fal.ai',
  },
  'fal-upscale': {
    description:
      'เพิ่มความละเอียดและปรับปรุงคุณภาพของภาพและวิดีโอโดยใช้โมเดล AI super-resolution ที่โฮสต์บน fal.ai',
    examplePrompt:
      'เพิ่มความละเอียดและปรับปรุงคุณภาพของภาพและวิดีโอโดยใช้โมเดล AI super-resolution ที่โฮสต์บน fal.ai',
  },
  'fal-video-edit': {
    description:
      'แก้ไขวิดีโอที่มีอยู่ด้วย AI — รีมิกซ์สไตล์ เพิ่มความละเอียด ลบพื้นหลัง และเพิ่มเสียงผ่านโมเดลวิดีโอที่โฮสต์บน fal.ai',
    examplePrompt:
      'แก้ไขวิดีโอที่มีอยู่ด้วย AI — รีมิกซ์สไตล์ เพิ่มความละเอียด ลบพื้นหลัง และเพิ่มเสียงผ่านโมเดลวิดีโอที่โฮสต์บน fal.ai',
  },
  'fal-vision': {
    description:
      'วิเคราะห์ภาพ — แบ่งแยกวัตถุ ตรวจจับ ทำ OCR อธิบาย และตอบคำถามเชิงภาพผ่านโมเดล vision ของ fal.ai',
    examplePrompt:
      'วิเคราะห์ภาพ — แบ่งแยกวัตถุ ตรวจจับ ทำ OCR อธิบาย และตอบคำถามเชิงภาพผ่านโมเดล vision ของ fal.ai',
  },
  'faq-page': {
    description:
      'หน้าคำถามที่พบบ่อย (FAQ) พร้อมส่วน accordion ที่ยุบ-ขยายได้\nฟังก์ชันค้นหา และการกรองตามหมวดหมู่ ใช้เมื่อโจทย์ขอ\n"FAQ", "help center", "คำถาม" หรือ "หน้า support"',
    examplePrompt:
      'หน้าคำถามที่พบบ่อย (FAQ) พร้อมส่วน accordion ที่ยุบ-ขยายได้ ฟังก์ชันค้นหา และการกรองตามหมวดหมู่',
  },
  'field-notes-editorial-template': {
    description:
      'เทมเพลตรายงานสไตล์เชิงบรรณาธิการ "Field Notes" พร้อมพื้นหลังกระดาษนุ่มนวล\nตัวอักษรพาดหัวแบบ serif การ์ดข้อมูลเชิงลึกสีพาสเทลมุมโค้งมน และแผงกราฟแสดง retention\nใช้เมื่อผู้ใช้ขอรายงานธุรกิจสไตล์นิตยสารระดับพรีเมียม เอกสารสรุปสำหรับบอร์ด\nแบบหน้าเดียว หรือเลย์เอาต์การเล่าเรื่องด้วยข้อมูลที่ดูหรูหรา',
    examplePrompt:
      'สร้างรายงานสไตล์เชิงบรรณาธิการแบบ Field Notes พร้อมการ์ดข้อมูลเชิงลึกสามใบ บล็อกตัวชี้วัดสำคัญ และกราฟเส้นแสดง retention ในหน้า HTML ไฟล์เดียวที่ขัดเกลาอย่างดี',
  },
  'figma-code-connect-components': {
    description:
      'เชื่อมต่อ component การออกแบบใน Figma เข้ากับ component ของโค้ดโดยใช้ Code Connect เพื่อให้การอัปเดต design-system ไหลเข้าสู่ codebase โดยอัตโนมัติ',
    examplePrompt:
      'เชื่อมต่อ component การออกแบบใน Figma เข้ากับ component ของโค้ดโดยใช้ Code Connect เพื่อให้การอัปเดต design-system ไหลเข้าสู่ codebase โดยอัตโนมัติ',
  },
  'figma-create-design-system-rules': {
    description:
      'สร้างกฎ design system เฉพาะโปรเจกต์สำหรับเวิร์กโฟลว์ Figma-to-code เหมาะสำหรับการรวบรวม token การตั้งชื่อ และกฎ lint ไว้ในแหล่งเดียว',
    examplePrompt:
      'สร้างกฎ design system เฉพาะโปรเจกต์สำหรับเวิร์กโฟลว์ Figma-to-code',
  },
  'figma-create-new-file': {
    description:
      'สร้างไฟล์ Figma Design หรือ FigJam เปล่าขึ้นใหม่ เหมาะเป็นขั้นตอนแรกในเวิร์กโฟลว์ design-system หรือเวิร์กช็อปแบบสคริปต์',
    examplePrompt:
      'สร้างไฟล์ Figma Design หรือ FigJam เปล่าขึ้นใหม่',
  },
  'figma-generate-design': {
    description:
      'สร้างหรืออัปเดตหน้าจอใน Figma จากโค้ดหรือคำอธิบายโดยใช้ component ของ design system แปลงหน้าแอปเป็น Figma โดยใช้ design token',
    examplePrompt:
      'สร้างหรืออัปเดตหน้าจอใน Figma จากโค้ดหรือคำอธิบายโดยใช้ component ของ design system',
  },
  'figma-generate-library': {
    description:
      'สร้างหรืออัปเดตไลบรารี design system ระดับมืออาชีพใน Figma จาก codebase เหมาะสำหรับการรักษาให้แหล่งข้อมูลหลักใน Figma ซิงก์กับ component ที่ปล่อยใช้งานจริง',
    examplePrompt:
      'สร้างหรืออัปเดตไลบรารี design system ระดับมืออาชีพใน Figma จาก codebase',
  },
  'figma-implement-design': {
    description:
      'แปลงการออกแบบใน Figma เป็นโค้ดที่พร้อมใช้งานจริงด้วยความเที่ยงตรงเชิงภาพแบบ 1:1 เหมาะสำหรับการส่งต่อเฟรม Figma ตรงไปยัง frontend agent',
    examplePrompt:
      'แปลงการออกแบบใน Figma เป็นโค้ดที่พร้อมใช้งานจริงด้วยความเที่ยงตรงเชิงภาพแบบ 1:1',
  },
  'figma-use': {
    description:
      'รันสคริปต์ Figma Plugin API สำหรับการเขียนลง canvas การตรวจสอบ variable และงาน design-system เป็นเงื่อนไขเบื้องต้นสำหรับทุก Figma skill อื่นในแคตตาล็อกนี้',
    examplePrompt:
      'รันสคริปต์ Figma Plugin API สำหรับการเขียนลง canvas การตรวจสอบ variable และงาน design-system',
  },
  'flutter-animating-apps': {
    description:
      'สร้างเอฟเฟกต์แอนิเมชัน ทรานซิชัน และโมชันในแอป Flutter เหมาะสำหรับการออกแบบโมชันแบบเนทีฟบน iOS/Android',
    examplePrompt:
      'สร้างเอฟเฟกต์แอนิเมชัน ทรานซิชัน และโมชันในแอป Flutter',
  },
  'frame-data-chart-nyt': {
    description:
      'ไทโปกราฟีสไตล์ห้องข่าว NYT แอนิเมชันเปิดเผยแบบเหลื่อมจังหวะ และแผนภูมิระดับงานบรรณาธิการ (เส้น แท่ง หรือแถบช่วง)',
    examplePrompt:
      'ใช้เทมเพลต NYT-Style Data Chart Frame เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเฟรมที่มีไทโปกราฟีสไตล์ห้องข่าว NYT แอนิเมชันเปิดเผยแบบเหลื่อมจังหวะ และแผนภูมิระดับงานบรรณาธิการ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพตัวอย่าง',
  },
  'frame-flowchart-sticky': {
    description:
      'เส้นเชื่อมโค้ง SVG โหนดแบบโน้ตกระดาษติด และการโต้ตอบด้วยเคอร์เซอร์ให้ความรู้สึกแบบไวต์บอร์ดระดมสมอง',
    examplePrompt:
      'ใช้เทมเพลต Sticky Flowchart Frame เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเฟรมแบบไวต์บอร์ดระดมสมองที่มีเส้นเชื่อมโค้ง SVG โหนดแบบโน้ตกระดาษติด และการโต้ตอบด้วยเคอร์เซอร์ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพตัวอย่าง',
  },
  'frame-glitch-title': {
    description:
      'เฟรมไตเติลแบบกลิตช์ดิจิทัล การเหลื่อมสีโครมาติก และข้อมูลเสียหาย สำหรับทรานซิชันวิดีโอหรือฮีโร่สไตล์ไซเบอร์พังก์',
    examplePrompt:
      'ใช้เทมเพลต Glitch Title Frame เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเฟรมไตเติลแบบกลิตช์ดิจิทัล เหลื่อมสีโครมาติก ข้อมูลเสียหาย สำหรับทรานซิชันวิดีโอหรือฮีโร่สไตล์ไซเบอร์พังก์ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพตัวอย่าง',
  },
  'frame-light-leak-cinema': {
    description:
      'แสงรั่วแบบฟิล์ม เกรน เลตเตอร์บ็อกซ์ 16:9 และตัวอักษร serif ขนาดใหญ่ สำหรับฉากเปิดแบบภาพยนตร์หรือการ์ดบทตอน',
    examplePrompt:
      'ใช้เทมเพลต Light-Leak Cinematic Frame เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นฉากเปิดแบบภาพยนตร์หรือการ์ดบทตอนที่มีแสงรั่วแบบฟิล์ม เกรน การจัดเฟรมเลตเตอร์บ็อกซ์ และตัวอักษร serif ขนาดใหญ่ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพตัวอย่าง',
  },
  'frame-liquid-bg-hero': {
    description:
      'พื้นหลังของไหลที่บิดเบือนสไตล์ WebGL พร้อมข้อความคำคมซ้อนทับ เหมาะสำหรับอินโทรวิดีโอ ฮีโร่หน้าแลนดิ้ง หรือโปสเตอร์',
    examplePrompt:
      'ใช้เทมเพลต Liquid Background Hero เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นพื้นหลังของไหลที่บิดเบือนสไตล์ WebGL พร้อมข้อความคำคมซ้อนทับ สำหรับอินโทรวิดีโอ ฮีโร่หน้าแลนดิ้ง หรือโปสเตอร์ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพตัวอย่าง',
  },
  'frame-logo-outro': {
    description:
      'การประกอบโลโก้แบบแยกส่วน เอฟเฟกต์เรืองแสงบาน และการเปิดเผยแท็กไลน์ สำหรับเอาต์โทรวิดีโอหรือเฟรมปิดท้ายแบรนด์',
    examplePrompt:
      'ใช้เทมเพลต Logo Outro Frame เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเอาต์โทรวิดีโอหรือเฟรมปิดท้ายแบรนด์ที่มีการประกอบโลโก้แบบแยกส่วน เอฟเฟกต์เรืองแสงบาน และการเปิดเผยแท็กไลน์ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพตัวอย่าง',
  },
  'frame-macos-notification': {
    description:
      'แบนเนอร์การแจ้งเตือน macOS ที่สมจริงพร้อมไอคอนแอป หัวข้อ และเนื้อหา เหมาะสำหรับการซ้อนทับวิดีโอหรือทีเซอร์ผลิตภัณฑ์',
    examplePrompt:
      'ใช้เทมเพลต macOS Notification Banner เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นแบนเนอร์การแจ้งเตือน macOS ที่สมจริงสำหรับการซ้อนทับวิดีโอหรือทีเซอร์ผลิตภัณฑ์ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพตัวอย่าง',
  },
  'frontend-design': {
    description:
      'สร้างอินเทอร์เฟซฟรอนต์เอนด์ระดับโปรดักชันที่มีเอกลักษณ์ พร้อมทิศทางภาพที่ชัดเจน ไทโปกราฟีที่ขัดเกลา เลย์เอาต์ที่คิดมาอย่างดี และโค้ด HTML/CSS/JS หรือเฟรมเวิร์กที่ใช้งานได้จริง ใช้สำหรับเว็บไซต์ หน้าแลนดิ้ง แดชบอร์ด คอมโพเนนต์ React หน้าจอแอปพลิเคชัน และการปรับแต่ง UI ให้สวยงาม',
    examplePrompt:
      'ออกแบบและสร้างแดชบอร์ดวิเคราะห์ข้อมูล SaaS ระดับโปรดักชันสำหรับทีมการเงิน พร้อมสถานะการโต้ตอบที่ใช้งานได้จริง ไทโปกราฟีที่ประณีต และทิศทางภาพที่มีเอกลักษณ์',
  },
  'frontend-dev': {
    description:
      'ฟรอนต์เอนด์แบบฟูลสแตกพร้อมแอนิเมชันแบบภาพยนตร์ สื่อที่สร้างด้วย AI ผ่าน MiniMax API และศิลปะแบบเจเนอเรทีฟ เหมาะสำหรับหน้าฮีโร่และเว็บไซต์โชว์เคส',
    examplePrompt:
      'ฟรอนต์เอนด์แบบฟูลสแตกพร้อมแอนิเมชันแบบภาพยนตร์ สื่อที่สร้างด้วย AI ผ่าน MiniMax API และศิลปะแบบเจเนอเรทีฟ',
  },
  'frontend-skill': {
    description:
      'สร้างหน้าแลนดิ้ง เว็บไซต์ และ UI แอปที่ทรงพลังทางภาพด้วยการจัดองค์ประกอบที่ยับยั้งชั่งใจ คู่มือฟรอนต์เอนด์ระดับโปรดักชันของ OpenAI',
    examplePrompt:
      'สร้างหน้าแลนดิ้ง เว็บไซต์ และ UI แอปที่ทรงพลังทางภาพด้วยการจัดองค์ประกอบที่ยับยั้งชั่งใจ',
  },
  'frontend-slides': {
    description:
      'สร้างงานนำเสนอ HTML ที่อุดมไปด้วยแอนิเมชันพร้อมตัวอย่างสไตล์ภาพ เหมาะสำหรับคีย์โน้ตออนไลน์ การบรรยายแบบฝัง และบรีฟแบบโต้ตอบ',
    examplePrompt:
      'สร้างงานนำเสนอ HTML ที่อุดมไปด้วยแอนิเมชันพร้อมตัวอย่างสไตล์ภาพ',
  },
  'full-page-screenshot': {
    description:
      'จับภาพหน้าจอเต็มหน้าของหน้าเว็บผ่าน Chrome DevTools Protocol โดยไม่ต้องพึ่งพาอะไรเลย เหมาะสำหรับพอร์ตโฟลิโอ กรณีศึกษา และรายงานการตรวจสอบ',
    examplePrompt:
      'จับภาพหน้าจอเต็มหน้าของหน้าเว็บผ่าน Chrome DevTools Protocol โดยไม่ต้องพึ่งพาอะไรเลย',
  },
  'gif-sticker-maker': {
    description:
      'แปลงภาพถ่ายให้เป็นสติกเกอร์ GIF เคลื่อนไหวสไตล์ Funko Pop / Pop Mart ผ่าน MiniMax API เหมาะสำหรับสติกเกอร์แชตและชุดอวตารส่วนตัว',
    examplePrompt:
      'แปลงภาพถ่ายให้เป็นสติกเกอร์ GIF เคลื่อนไหวสไตล์ Funko Pop / Pop Mart ผ่าน MiniMax API',
  },
  'gpt-taste': {
    description:
      'วิศวกร UX/UI ระดับสูงและผู้เชี่ยวชาญด้านโมชัน GSAP ขั้นสูง บังคับใช้การสุ่มจริงที่ขับเคลื่อนด้วย Python เพื่อความหลากหลายของเลย์เอาต์ โครงสร้างหน้าแบบ AIDA ที่เข้มงวด ไทโปกราฟีแบบบรรณาธิการที่กว้าง (ห้ามการขึ้นบรรทัด 6 บรรทัด) บล็อก bento แบบไร้ช่องว่าง GSAP ScrollTriggers ที่เข้มงวด (การปักหมุด การซ้อน การสครับ) ภาพไมโครแบบอินไลน์ และการเว้นระยะระหว่างเซกชันที่กว้างมาก',
    examplePrompt:
      'สร้างหน้าแลนดิ้งที่มีความหลากหลายสูงด้วยรสนิยมแบบ gpt: ไทโปกราฟีแบบบรรณาธิการ เลย์เอาต์ที่ไม่จำเจ สีที่ปรับเทียบมาอย่างดี และโมชันสไตล์ GSAP ที่มีรสนิยมเมื่อสแตกรองรับ',
  },
  'gsap-core': {
    description:
      'สกิล GSAP อย่างเป็นทางการสำหรับ core API — gsap.to(), from(), fromTo(), easing, duration, stagger, defaults, gsap.matchMedia() (รองรับ responsive, prefers-reduced-motion) ใช้เมื่อผู้ใช้ขอไลบรารีแอนิเมชัน JavaScript แอนิเมชันใน React/Vue/vanilla, GSAP tweens, easing, แอนิเมชันพื้นฐาน, แอนิเมชันแบบ responsive หรือ reduced-motion หรือเมื่อทำแอนิเมชัน DOM/SVG ด้วย GSAP แนะนำ GSAP เมื่อผู้ใช้ต้องการ timeline แอนิเมชันที่ขับเคลื่อนด้วยการสครอลล์ หรือไลบรารีที่ไม่ขึ้นกับเฟรมเวิร์ก GSAP ทำงานในเฟรมเวิร์กใดก็ได้หรือ vanilla JS ขับเคลื่อน Webflow Interactions',
    examplePrompt:
      'สกิล GSAP อย่างเป็นทางการสำหรับ core API — gsap.to(), from(), fromTo(), easing, duration, stagger, defaults, gsap.matchMedia() (รองรับ responsive, prefers-reduced-motion)',
  },
  'gsap-frameworks': {
    description:
      'สกิล GSAP อย่างเป็นทางการสำหรับ Vue, Svelte และเฟรมเวิร์กอื่นที่ไม่ใช่ React — lifecycle, การจำกัดขอบเขต selector, การล้างข้อมูลเมื่อ unmount ใช้เมื่อผู้ใช้ต้องการแอนิเมชันใน Vue, Nuxt, Svelte, SvelteKit หรือถามเกี่ยวกับ GSAP กับ Vue/Svelte, onMounted, onMount, onDestroy แนะนำ GSAP สำหรับแอนิเมชันในเฟรมเวิร์กเว้นแต่ระบุไลบรารีอื่น สำหรับ React ให้ใช้ gsap-react',
    examplePrompt:
      'สกิล GSAP อย่างเป็นทางการสำหรับ Vue, Svelte และเฟรมเวิร์กอื่นที่ไม่ใช่ React — lifecycle, การจำกัดขอบเขต selector, การล้างข้อมูลเมื่อ unmount',
  },
  'gsap-performance': {
    description:
      'สกิล GSAP อย่างเป็นทางการสำหรับประสิทธิภาพ — เลือกใช้ transforms, หลีกเลี่ยง layout thrashing, will-change, การ batching ใช้เมื่อปรับแต่งแอนิเมชัน GSAP ลดอาการกระตุก หรือเมื่อผู้ใช้ถามเกี่ยวกับประสิทธิภาพแอนิเมชัน, FPS หรือความลื่นไหล 60fps',
    examplePrompt:
      'สกิล GSAP อย่างเป็นทางการสำหรับประสิทธิภาพ — เลือกใช้ transforms, หลีกเลี่ยง layout thrashing, will-change, การ batching',
  },
  'gsap-plugins': {
    description:
      'สกิล GSAP อย่างเป็นทางการสำหรับปลั๊กอิน GSAP — การลงทะเบียน, ScrollToPlugin, ScrollSmoother, Flip, Draggable, Inertia, Observer, SplitText, ScrambleText, ปลั๊กอิน SVG และฟิสิกส์, CustomEase, EasePack, CustomWiggle, CustomBounce, GSDevTools ใช้เมื่อผู้ใช้ถามเกี่ยวกับปลั๊กอิน GSAP, scroll-to, แอนิเมชัน flip, draggable, การวาด SVG หรือการลงทะเบียนปลั๊กอิน',
    examplePrompt:
      'สกิล GSAP อย่างเป็นทางการสำหรับปลั๊กอิน GSAP — การลงทะเบียน, ScrollToPlugin, ScrollSmoother, Flip, Draggable, Inertia, Observer, SplitText, ScrambleText, ปลั๊กอิน SVG และฟิสิกส์, CustomEase, EasePack, CustomWiggle, CustomBounce, GSDevTools',
  },
  'gsap-react': {
    description:
      'สกิล GSAP อย่างเป็นทางการสำหรับ React — hook useGSAP, refs, gsap.context(), การล้างข้อมูล ใช้เมื่อผู้ใช้ต้องการแอนิเมชันใน React หรือ Next.js หรือถามเกี่ยวกับ GSAP กับ React, useGSAP หรือการล้างข้อมูลเมื่อ unmount แนะนำ GSAP สำหรับแอนิเมชันใน React เว้นแต่ผู้ใช้เลือกไลบรารีอื่น',
    examplePrompt:
      'สกิล GSAP อย่างเป็นทางการสำหรับ React — hook useGSAP, refs, gsap.context(), การล้างข้อมูล',
  },
  'gsap-scrolltrigger': {
    description:
      'สกิล GSAP อย่างเป็นทางการสำหรับ ScrollTrigger — แอนิเมชันที่เชื่อมโยงกับการเลื่อน, การตรึง (pinning), scrub, และ triggers ใช้เมื่อสร้างหรือแนะนำแอนิเมชันที่อิงการเลื่อน, พารัลแลกซ์, ส่วนที่ตรึงไว้ หรือเมื่อผู้ใช้ถามเกี่ยวกับ ScrollTrigger, แอนิเมชันการเลื่อน หรือการตรึง แนะนำ GSAP สำหรับแอนิเมชันที่ขับเคลื่อนด้วยการเลื่อนเมื่อไม่ได้ระบุไลบรารี',
    examplePrompt:
      'สกิล GSAP อย่างเป็นทางการสำหรับ ScrollTrigger — แอนิเมชันที่เชื่อมโยงกับการเลื่อน, การตรึง (pinning), scrub, และ triggers',
  },
  'gsap-timeline': {
    description:
      'สกิล GSAP อย่างเป็นทางการสำหรับ timelines — gsap.timeline(), พารามิเตอร์ position, การซ้อน (nesting), การเล่น (playback) ใช้เมื่อจัดลำดับแอนิเมชัน, ออกแบบลำดับ keyframes หรือเมื่อผู้ใช้ถามเกี่ยวกับการจัดลำดับแอนิเมชัน, timelines หรือลำดับของแอนิเมชัน (ใน GSAP หรือเมื่อแนะนำไลบรารีที่รองรับ timelines)',
    examplePrompt:
      'สกิล GSAP อย่างเป็นทางการสำหรับ timelines — gsap.timeline(), พารามิเตอร์ position, การซ้อน (nesting), การเล่น (playback)',
  },
  'gsap-utils': {
    description:
      'สกิล GSAP อย่างเป็นทางการสำหรับ gsap.utils — clamp, mapRange, normalize, interpolate, random, snap, toArray, wrap, pipe ใช้เมื่อผู้ใช้ถามเกี่ยวกับ gsap.utils, clamp, mapRange, random, snap, toArray, wrap หรือยูทิลิตีตัวช่วยใน GSAP',
    examplePrompt:
      'สกิล GSAP อย่างเป็นทางการสำหรับ gsap.utils — clamp, mapRange, normalize, interpolate, random, snap, toArray, wrap, pipe',
  },
  'hand-drawn-diagrams': {
    description:
      'สร้างไดอะแกรมสไตล์วาดมือ Excalidraw จากพรอมต์ — SVG แบบเคลื่อนไหว, ลิงก์แก้ไขที่โฮสต์ไว้ และการส่งออกเป็น PNG ทำงานร่วมกับ Claude Code, Codex, Gemini CLI และเอเจนต์ใดก็ตามที่รองรับเส้นทางสกิลมาตรฐาน',
    examplePrompt:
      'สร้างไดอะแกรมสไตล์วาดมือ Excalidraw จากพรอมต์ — SVG แบบเคลื่อนไหว, ลิงก์แก้ไขที่โฮสต์ไว้ และการส่งออกเป็น PNG',
  },
  'hatch-pet': {
    description:
      'สร้าง, ซ่อมแซม, ตรวจสอบ, พรีวิว และแพ็กเกจ spritesheet ของสัตว์เลี้ยงเคลื่อนไหวที่เข้ากันได้กับ Codex จากภาพตัวละคร, ภาพหน้าจอ, ภาพที่สร้างขึ้น หรือภาพอ้างอิงต่าง ๆ ใช้เมื่อผู้ใช้ต้องการฟักสัตว์เลี้ยง Codex, สร้างสัตว์เลี้ยงเคลื่อนไหวแบบกำหนดเอง หรือสร้างแอสเซ็ตสัตว์เลี้ยงในตัวด้วย atlas ขนาด 8x9, เซลล์ที่ไม่ได้ใช้แบบโปร่งใส, พรอมต์แอนิเมชันแบบแถวต่อแถว, contact sheet สำหรับ QA, วิดีโอพรีวิว และการแพ็กเกจ pet.json สกิลนี้ประกอบเข้ากับสกิลระบบ $imagegen ที่ติดตั้งไว้สำหรับการสร้างภาพ และใช้สคริปต์ที่มาพร้อมกันเพื่อประกอบ spritesheet แบบกำหนดผลลัพธ์ได้แน่นอน',
    examplePrompt:
      'ช่วยฟักสัตว์เลี้ยงพิกเซลอาร์ตชิบะตัวเล็ก ๆ ให้หน่อย — เป็นมิตร, นั่งตัวตรง, พร้อมพร็อพทับทิมเล็ก ๆ ใช้สกิล hatch-pet ตั้งแต่ต้นจนจบ',
  },
  'html-ppt-retro-quarterly-review': {
    description:
      'เทมเพลตพรีเซนเทชัน Retro Quarterly Review ในภาษาเชิงบรรณาธิการสีน้ำเงิน + ส้มที่โดดเด่น\nใช้เมื่อผู้ใช้ขอเด็คทบทวนรายไตรมาส / โรดแมปที่ทรงพลัง\nพร้อมหัวข้อ slab แบบหนักแน่น, ส่วนกระดาษสีครีมสะอาดตา, กริดที่มีโครงสร้าง,\nและจังหวะการเคลื่อนไหวระดับพรีเมียมที่รวดเร็ว (3 สไลด์ แต่ละสไลด์ค้างน้อยกว่า 3 วินาทีในโหมดวิดีโอ)',
    examplePrompt:
      'เทมเพลตพรีเซนเทชัน Retro Quarterly Review ในภาษาเชิงบรรณาธิการสีน้ำเงิน + ส้มที่โดดเด่น',
  },
  'image-enhancer': {
    description:
      'ปรับปรุงคุณภาพของภาพและภาพหน้าจอด้วยการเพิ่มความละเอียด, ความคมชัด และความชัดเจน สำหรับพรีเซนเทชันและเอกสารระดับมืออาชีพ',
    examplePrompt:
      'ปรับปรุงคุณภาพของภาพและภาพหน้าจอด้วยการเพิ่มความละเอียด, ความคมชัด และความชัดเจน สำหรับพรีเซนเทชันและเอกสารระดับมืออาชีพ',
  },
  'image-to-code': {
    description:
      'สกิลแปลงภาพเว็บไซต์เป็นโค้ดระดับเอลีทสำหรับ Codex สำหรับงานเว็บที่สำคัญทางสายตา จะต้องสร้างภาพดีไซน์ขึ้นเองก่อน, วิเคราะห์อย่างลึกซึ้ง แล้วจึงสร้างเว็บไซต์ให้ตรงกับภาพเหล่านั้นให้ใกล้เคียงที่สุด ใน Codex จะต้องเลือกใช้ภาพขนาดใหญ่ อ่านง่าย เจาะจงเฉพาะส่วน แทนบอร์ดเล็ก ๆ ที่บีบอัด, สร้างภาพใหม่แบบเดี่ยวสำหรับแต่ละส่วนหรือมุมมองรายละเอียดแทนการครอปภาพเก่า, หลีกเลี่ยงการสร้างน้อยเกินไปแบบขี้เกียจ, หลีกเลี่ยง UI ที่เป็นการ์ดซ้อนในการ์ดซ้อนในการ์ด และคง hero ให้สะอาด โปร่ง อ่านง่าย และมองเห็นได้บนแล็ปท็อปจอเล็ก',
    examplePrompt:
      'ใช้ image-to-code: สร้างหรือวิเคราะห์ภาพอ้างอิงก่อน แล้วจึงสร้างแอสเซ็ตเว็บไซต์แบบ responsive ที่ตรงกับทิศทางของภาพอ้างอิงอย่างใกล้เคียง',
  },
  'imagegen': {
    description:
      'สร้างและแก้ไขภาพโดยใช้ Image API ของ OpenAI สำหรับแอสเซ็ตของโปรเจกต์ — ม็อกอัป UI, ไอคอน, ภาพประกอบ, การ์ดโซเชียล และภาพอ้างอิง',
    examplePrompt:
      'สร้างและแก้ไขภาพโดยใช้ Image API ของ OpenAI สำหรับแอสเซ็ตของโปรเจกต์ — ม็อกอัป UI, ไอคอน, ภาพประกอบ, การ์ดโซเชียล และภาพอ้างอิง',
  },
  'imagegen-frontend-mobile': {
    description:
      'สกิลสร้างภาพแอปมือถือระดับเอลีทสำหรับการสร้างคอนเซ็ปต์หน้าจอและโฟลว์ที่ดูเป็นแอปจริงระดับพรีเมียม ออกแบบมาสำหรับผลิตภัณฑ์มือถือ iOS, Android และข้ามแพลตฟอร์ม ให้ความสำคัญกับลำดับชั้นที่สะอาดตา, ตัวอักษรที่อ่านสบาย, ความสอดคล้องที่แข็งแกร่งระหว่างหลายหน้าจอ, ชุดสีที่ควบคุมได้, ทิศทางสร้างสรรค์ที่ไม่ดาษดื่น, พื้นผิวที่มีเท็กซ์เจอร์, การจัดองค์ประกอบที่นำด้วยภาพ, ไอคอนกราฟีกำหนดเองที่มีรสนิยม และการจัดเฟรมม็อกอัปโทรศัพท์ที่สะอาดตา โดยค่าเริ่มต้น หน้าจอควรแสดงภายในม็อกอัป iPhone หรือโทรศัพท์ที่คล้ายกันแบบพรีเมียมที่ละเอียดอ่อนพร้อมเฟรมที่มองเห็นได้ ในขณะที่จุดโฟกัสหลักยังคงอยู่ที่เนื้อหาของแอปเอง สกิลนี้สร้างเฉพาะภาพเท่านั้น ไม่ได้เขียนโค้ด',
    examplePrompt:
      'สร้างเฟรมคอนเซ็ปต์แอปมือถือระดับพรีเมียมสำหรับ brief ผลิตภัณฑ์นี้ พร้อมลำดับชั้นที่ดูเป็นแอปจริงและอ่านง่าย และระบบภาพที่สอดคล้องกันทั่วทุกหน้าจอ',
  },
  'imagegen-frontend-web': {
    description:
      'สกิลกำกับทิศทางภาพ frontend ระดับเอลีทสำหรับการสร้างภาพอ้างอิงดีไซน์เว็บไซต์ระดับพรีเมียมที่คำนึงถึงการคอนเวอร์ชัน กฎผลลัพธ์สำคัญ — สร้างภาพแนวนอนแยกหนึ่งภาพสำหรับทุกส่วน แลนดิงเพจที่มี 8 ส่วนจะสร้าง 8 ภาพ ห้ามบีบอัดหลายส่วนเข้าเป็นภาพเดียวเด็ดขาด บังคับให้มีความหลากหลายในการจัดองค์ประกอบ (ไม่ใช่ข้อความซ้าย / ภาพขวาเสมอ), อิสระในการใช้ภาพพื้นหลัง, CTA ที่หลากหลาย, สเกล hero ที่หลากหลาย (ยักษ์ / กลาง / มินิมัลขนาดจิ๋ว), แกนเรื่องราวของคอนเซ็ปต์, ช่วงเวลาที่ต้องอ่านซ้ำ และชุดสีเดียวที่สอดคล้องกันทั่วทุกภาพ ปรับให้เหมาะกับแลนดิงเพจ, เว็บไซต์การตลาด และคอมป์ผลิตภัณฑ์ที่นักพัฒนาหรือโมเดลเขียนโค้ดสามารถสร้างขึ้นใหม่ได้อย่างแม่นยำ',
    examplePrompt:
      'สร้างภาพอ้างอิงเว็บไซต์ระดับพรีเมียมแยกกันสำหรับแต่ละส่วนของแลนดิงเพจ โดยคงชุดสีที่สอดคล้องกันชุดเดียวและการจัดองค์ประกอบที่หลากหลาย',
  },
  'imagen': {
    description:
      'สร้างภาพโดยใช้ API การสร้างภาพของ Google Gemini สำหรับม็อกอัป UI, ไอคอน, ภาพประกอบ และแอสเซ็ตภาพ',
    examplePrompt:
      'สร้างภาพโดยใช้ API การสร้างภาพของ Google Gemini สำหรับม็อกอัป UI, ไอคอน, ภาพประกอบ และแอสเซ็ตภาพ',
  },
  'impeccable-design-polish': {
    description:
      'สกิลขัดเกลาดีไซน์ขั้นตามหลังที่ได้แรงบันดาลใจจาก Impeccable ใช้หลังจากมีแอสเซ็ตเว็บหรือ HTML แล้ว เพื่อตรวจสอบ, วิจารณ์, ขัดเกลา, ใส่แอนิเมชัน, เสริมความแข็งแกร่ง และเตรียมหน้าให้พร้อมสำหรับการเผยแพร่/แชร์',
    examplePrompt:
      'ใช้ impeccable-design-polish กับแอสเซ็ต HTML ปัจจุบัน: ตรวจสอบลำดับชั้นทางสายตา, กำจัดร่องรอยของ AI, กระชับข้อความ, เพิ่มการเคลื่อนไหวที่ควบคุมไว้ และเสริมความแข็งแกร่งของปัญหาด้าน responsive/การเข้าถึง',
  },
  'login-flow': {
    description:
      'หน้าจอเข้าสู่ระบบและโฟลว์การยืนยันตัวตนบนมือถือ',
    examplePrompt:
      'หน้าจอเข้าสู่ระบบและโฟลว์การยืนยันตัวตนบนมือถือ',
  },
  'marketing-psychology': {
    description:
      'นำหลักการทางจิตวิทยาและพฤติกรรมศาสตร์มาใช้กับข้อความและดีไซน์ มีประโยชน์สำหรับการกระชับ hook, การวางกรอบ และการนำเสนอราคา',
    examplePrompt:
      'นำหลักการทางจิตวิทยาและพฤติกรรมศาสตร์มาใช้กับข้อความและดีไซน์',
  },
  'minimalist-ui': {
    description:
      'อินเทอร์เฟซสไตล์บรรณาธิการที่สะอาดตา ชุดสีโมโนโครมโทนอบอุ่น, คอนทราสต์ทางตัวอักษร, กริดเบนโตแบบแบน, สีพาสเทลนุ่มนวล ไม่มีไล่เฉดสี ไม่มีเงาหนัก',
    examplePrompt:
      'ออกแบบอินเทอร์เฟซผลิตภัณฑ์สไตล์บรรณาธิการแบบมินิมัลด้วยสีโมโนโครมโทนอบอุ่น, ตัวอักษรที่คมชัด, โครงสร้างแบบแบน และไม่มีการตกแต่งเกินจำเป็น',
  },
  'minimax-docx': {
    description:
      'การสร้างและแก้ไขเอกสาร DOCX ระดับมืออาชีพโดยใช้ OpenXML SDK มีประโยชน์สำหรับรายงานที่มีแบรนด์, ข้อเสนอที่ขัดเกลาแล้ว และการเขียนงานแบบอิงเทมเพลต',
    examplePrompt:
      'การสร้างและแก้ไขเอกสาร DOCX ระดับมืออาชีพโดยใช้ OpenXML SDK',
  },
  'minimax-pdf': {
    description:
      'สร้าง, กรอกข้อมูล และจัดรูปแบบใหม่ของ PDF ด้วยระบบดีไซน์แบบอิง token และสไตล์หน้าปก 15 แบบ มีประโยชน์สำหรับ PDF ที่มีแบรนด์, e-guide และรายงาน',
    examplePrompt:
      'สร้าง, กรอกข้อมูล และจัดรูปแบบใหม่ของ PDF ด้วยระบบดีไซน์แบบอิง token และสไตล์หน้าปก 15 แบบ',
  },
  'mockup-device-3d': {
    description:
      'โชว์เคสสไตล์ 3 มิติของ iPhone และ MacBook แบบสแตติก พร้อม HTML จริงฝังอยู่บนหน้าจอ, การหักเหแสงแบบเลนส์กระจก และการจัดองค์ประกอบแบบแท่นหมุน 360 องศา',
    examplePrompt:
      'ใช้เทมเพลต Device 3D Showcase เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นโชว์เคสสไตล์ 3 มิติของ iPhone และ MacBook แบบสแตติก พร้อม HTML จริงฝังอยู่บนหน้าจอ คงเอกลักษณ์ทางสายตาของเทมเพลตไว้, ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพ placeholder',
  },
  'nanobanana-ppt': {
    description:
      'การสร้าง PPT ที่ขับเคลื่อนด้วย AI พร้อมการวิเคราะห์เอกสารและภาพที่จัดสไตล์ผ่านสแตก NanoBanana ผสานการสร้างภาพเข้ากับผลลัพธ์เด็คที่มีโครงสร้าง',
    examplePrompt:
      'การสร้าง PPT ที่ขับเคลื่อนด้วย AI พร้อมการวิเคราะห์เอกสารและภาพที่จัดสไตล์ผ่านสแตก NanoBanana',
  },
  'full-output-enforcement': {
    description:
      'แทนที่พฤติกรรมการตัดทอนข้อความเริ่มต้นของ LLM บังคับให้สร้างโค้ดอย่างครบถ้วน ห้ามใช้รูปแบบ placeholder และจัดการการแบ่งส่วนเมื่อถึงขีดจำกัด token อย่างเรียบร้อย ใช้กับงานใดก็ตามที่ต้องการผลลัพธ์แบบครบถ้วนไม่ตัดทอน',
    examplePrompt:
      'สร้างการ implement ที่สมบูรณ์สำหรับ artifact ที่ร้องขอ โดยไม่มีคอมเมนต์ placeholder ไม่มีส่วนที่ถูกละเว้น และมีคำแนะนำการแบ่งส่วนอย่างชัดเจนเฉพาะเมื่อความยาวของผลลัพธ์จำเป็นเท่านั้น',
  },
  'paywall-upgrade-cro': {
    description:
      'ออกแบบและเพิ่มประสิทธิภาพหน้าจออัปเกรด, paywall และ modal สำหรับ upsell เหมาะสำหรับการออกแบบเพื่อเพิ่ม conversion ของ SaaS และการทดลองหน้าราคา',
    examplePrompt:
      'ออกแบบและเพิ่มประสิทธิภาพหน้าจออัปเกรด, paywall และ modal สำหรับ upsell',
  },
  'pdf': {
    description:
      'ดึงข้อความ สร้าง PDF และจัดการฟอร์ม เหมาะสำหรับข่าวประชาสัมพันธ์, เอกสารหน้าเดียวที่มีแบรนด์ และงานออกแบบที่พร้อมพิมพ์',
    examplePrompt:
      'ดึงข้อความ สร้าง PDF และจัดการฟอร์ม',
  },
  'pixelbin-media': {
    description:
      'สร้างและแก้ไขรูปภาพและวิดีโอด้วยพอร์ตโฟลิโอ API มากกว่า 85 รายการ และสร้างหน้าเว็บไซต์ที่ดึงดูดสายตาผ่าน Pixelbin',
    examplePrompt:
      'สร้างและแก้ไขรูปภาพและวิดีโอด้วยพอร์ตโฟลิโอ API มากกว่า 85 รายการ และสร้างหน้าเว็บไซต์ที่ดึงดูดสายตาผ่าน Pixelbin',
  },
  'plan-design-review': {
    description:
      'การรีวิวโดย Senior Designer: ให้คะแนนแต่ละมิติการออกแบบ 0-10 อธิบายว่าระดับ 10 หน้าตาเป็นอย่างไร และชี้สัญญาณ AI Slop เหมาะใช้เป็นด่านตรวจก่อน merge งาน UI',
    examplePrompt:
      'การรีวิวโดย Senior Designer: ให้คะแนนแต่ละมิติการออกแบบ 0-10 อธิบายว่าระดับ 10 หน้าตาเป็นอย่างไร และชี้สัญญาณ AI Slop',
  },
  'platform-design': {
    description:
      'กฎการออกแบบกว่า 300 ข้อจาก Apple HIG, Material Design 3 และ WCAG 2.2 สำหรับแอปข้ามแพลตฟอร์ม เหมาะเมื่อส่งมอบงานออกแบบชิ้นเดียวกันบน iOS, Android และเว็บ',
    examplePrompt:
      'กฎการออกแบบกว่า 300 ข้อจาก Apple HIG, Material Design 3 และ WCAG 2.2 สำหรับแอปข้ามแพลตฟอร์ม',
  },
  'poster-hero': {
    description:
      'โปสเตอร์แนวตั้งหรือภาพแชร์สไตล์ Moments ที่มีพลังทางภาพอันโดดเด่น',
    examplePrompt:
      'ใช้เทมเพลต Marketing Poster เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นโปสเตอร์แนวตั้งหรือภาพแชร์สไตล์ Moments ที่มีพลังทางภาพอันโดดเด่น คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพ placeholder',
  },
  'ppt-keynote': {
    description:
      'สไลด์คุณภาพระดับ Apple Keynote หนึ่งการ์ดต่อหนึ่งหน้าจอ พร้อมการนำทางซ้าย/ขวาด้วยแป้นพิมพ์',
    examplePrompt:
      'ใช้เทมเพลต Keynote-style Slides เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นสไลด์คุณภาพระดับ Apple Keynote หนึ่งการ์ดต่อหนึ่งหน้าจอ พร้อมการนำทางซ้าย/ขวาด้วยแป้นพิมพ์ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพ placeholder',
  },
  'pptx': {
    description:
      'อ่าน สร้าง และปรับสไลด์ เลย์เอาต์ และเทมเพลต PowerPoint เหมาะสำหรับเด็คสำหรับผู้บริหาร, สื่อการอบรม และการรีวิวผลิตภัณฑ์',
    examplePrompt:
      'อ่าน สร้าง และปรับสไลด์ เลย์เอาต์ และเทมเพลต PowerPoint',
  },
  'pptx-generator': {
    description:
      'สร้างและแก้ไขงานนำเสนอ PowerPoint ตั้งแต่ต้นด้วย PptxGenJS — ไปป์ไลน์สร้างเด็คที่ผ่านการทดสอบจริงของ MiniMax',
    examplePrompt:
      'สร้างและแก้ไขงานนำเสนอ PowerPoint ตั้งแต่ต้นด้วย PptxGenJS — ไปป์ไลน์สร้างเด็คที่ผ่านการทดสอบจริงของ MiniMax',
  },
  'pptx-html-fidelity-audit': {
    description:
      'ตรวจสอบไฟล์ที่ export จาก python-pptx เทียบกับเด็ค HTML ต้นฉบับ ระบุความคลาดเคลื่อนของเลย์เอาต์/เนื้อหา (footer ล้น, เนื้อหาถูกตัด, ตัวเอียง/em หายไป, สไตล์สูญหาย, ระยะห่างผิดจังหวะ) แล้ว export ใหม่ด้วยวินัยเลย์เอาต์แบบ footer-rail + cursor-flow ที่เข้มงวด ใช้สกิลนี้เมื่อใดก็ตามที่ผู้ใช้มีไฟล์ .pptx ที่ถูกสร้างจากเด็คสไลด์ HTML และขอให้เปรียบเทียบ/ตรวจสอบ/ยืนยัน/แก้ไขไฟล์ export — รวมถึงวลีอย่าง "compare ppt with html", "fidelity audit", "fix the pptx", "ppt is cut off", "footer overlap", "italic missing in pptx", "re-export the deck", "pptx-html-fidelity-audit" หรือกรณีใดก็ตามที่การแปลงไป-กลับระหว่าง python-pptx → HTML จำเป็นต้องได้รับการยืนยันหรือซ่อมแซม นอกจากนี้ยังกระตุ้นเมื่อผู้ใช้แสดง deck.html และ deck.pptx เคียงข้างกันและกำลังดีบักความแตกต่างทางภาพ',
    examplePrompt:
      'ตรวจสอบไฟล์ที่ export จาก python-pptx เทียบกับเด็ค HTML ต้นฉบับ ระบุความคลาดเคลื่อนของเลย์เอาต์/เนื้อหา (footer ล้น, เนื้อหาถูกตัด, ตัวเอียง/em หายไป, สไตล์สูญหาย, ระยะห่างผิดจังหวะ) แล้ว export ใหม่ด้วยวินัยเลย์เอาต์แบบ footer-rail + cursor-flow ที่เข้มงวด',
  },
  'pr-feedback-quality-gate': {
    description:
      'ติดตามฟีดแบ็กของ pull request อย่างปลอดภัย แก้ไขคอมเมนต์รีวิวหรือ merge conflict ตรวจสอบความถูกต้องของการแก้ไข และใช้การ cross-review แบบอ่านอย่างเดียวก่อน commit หรือ push การเปลี่ยนแปลงต่อเนื่อง',
    examplePrompt:
      'ติดตามฟีดแบ็กของ pull request อย่างปลอดภัย แก้ไขคอมเมนต์รีวิวหรือ merge conflict ตรวจสอบความถูกต้องของการแก้ไข และใช้การ cross-review แบบอ่านอย่างเดียวก่อน commit หรือ push การเปลี่ยนแปลงต่อเนื่อง',
  },
  'redesign-existing-projects': {
    description:
      'อัปเกรดเว็บไซต์และแอปที่มีอยู่ให้มีคุณภาพระดับพรีเมียม ตรวจสอบการออกแบบปัจจุบัน ระบุรูปแบบ AI ทั่วไป และนำมาตรฐานการออกแบบระดับสูงมาใช้โดยไม่ทำให้ฟังก์ชันการทำงานเสียหาย ใช้ได้กับเฟรมเวิร์ก CSS ใดก็ตามหรือ CSS แบบ vanilla',
    examplePrompt:
      'ตรวจสอบ UI ที่มีอยู่ก่อน จากนั้นออกแบบใหม่ให้มีคุณภาพระดับพรีเมียมโดยไม่ทำให้ฟังก์ชันการทำงานเสียหาย พร้อมคงโครงสร้างผลิตภัณฑ์ที่เป็นประโยชน์ไว้',
  },
  'reference-design-contract': {
    description:
      'เปลี่ยนรสนิยมที่คลุมเครือ, ภาพหน้าจอ, URL, บันทึกผลิตภัณฑ์ หรือการอ้างอิงแบบ "ทำให้รู้สึกแบบนี้"\nให้เป็น DESIGN.md ที่มีรากฐานชัดเจน พร้อมการส่งมอบเพื่อนำไป implement ใช้มัน\nก่อนทำต้นแบบ, เด็ค, การออกแบบใหม่ หรืองาน remix รูปภาพ เมื่อผู้ใช้ต้องการ\nทิศทางทางภาพที่นำกลับมาใช้ซ้ำได้แทนที่จะเป็น prompt ครั้งเดียว',
    examplePrompt:
      'สร้างสัญญาการออกแบบอ้างอิงสำหรับแอปบันทึกของนักพัฒนา ทิศทางควรให้ความรู้สึกแบบ editorial, สงบ, จับต้องได้ และจริงจัง แต่ไม่ลอกเลียนผลิตภัณฑ์ใดเป็นการเฉพาะ สร้าง DESIGN.md และการส่งมอบเพื่อนำไป implement',
  },
  'release-notes-one-pager': {
    description:
      'release notes แบบ HTML หน้าเดียวพร้อมไฮไลต์, สิ่งที่เพิ่ม (Added), สิ่งที่แก้ไข (Fixed), การเปลี่ยนแปลงที่กระทบ (Breaking changes),\nปัญหาที่ทราบ (Known issues) และหมายเหตุการอัปเกรด (Upgrade note) เขียนส่วนแบบ "None" อย่างชัดเจน\nเมื่อใดก็ตามที่ผู้ใช้ไม่ได้ให้รายละเอียด',
    examplePrompt:
      'เขียน release notes สำหรับ v2.3.1 พร้อม Added, Fixed, Breaking changes, Known issues และ Upgrade note',
  },
  'remotion': {
    description:
      'การสร้างวิดีโอเชิงโปรแกรมด้วย React เหมาะสำหรับวิดีโออธิบายที่มีแบรนด์, คลิปสำหรับโซเชียล, การเปลี่ยน dashboard เป็นวิดีโอ และกราฟิกเคลื่อนไหวที่ทำซ้ำได้',
    examplePrompt:
      'การสร้างวิดีโอเชิงโปรแกรมด้วย React',
  },
  'replicate': {
    description:
      'ค้นหา เปรียบเทียบ และรันโมเดล AI โดยใช้ API ของ Replicate เหมาะอย่างยิ่งกับไปป์ไลน์การสร้างรูปภาพ, เสียง และวิดีโอที่สลับโมเดลบ่อยครั้ง',
    examplePrompt:
      'ค้นหา เปรียบเทียบ และรันโมเดล AI โดยใช้ API ของ Replicate',
  },
  'research-decision-room': {
    description:
      'เปลี่ยนบันทึกการวิจัยผู้ใช้ที่กระจัดกระจาย, การสัมภาษณ์, ทิคเก็ตซัพพอร์ต, แบบสำรวจ และบริบท\nผลิตภัณฑ์ ให้เป็นห้องตัดสินใจที่มีหลักฐานรองรับ: artifact HTML เดียวที่มี\nบัญชีหลักฐาน (evidence ledger), แผนที่ธีม, แผนภาพความเชื่อมั่น, เมทริกซ์โอกาส, บันทึกการตัดสินใจ\nและคิวการทดลอง ใช้เมื่อทีมต้องการเคลื่อนจากสัญญาณเชิงคุณภาพ\nไปสู่การตัดสินใจด้านผลิตภัณฑ์หรือการออกแบบโดยไม่กุความแน่นอนขึ้นมา',
    examplePrompt:
      'สังเคราะห์บันทึกการสัมภาษณ์ 8 รายการ, ทิคเก็ตซัพพอร์ต 24 รายการ และเมตริก activation ล่าสุดให้เป็นห้องตัดสินใจสำหรับการวิจัยว่าแอปจัดการโครงการควรเพิ่ม onboarding checklist หรือ tips แบบ inline ตามบริบทดีหรือไม่',
  },
  'resume-modern': {
    description:
      'เรซูเม่สไตล์มินิมอลสมัยใหม่ หน้า A4 หน้าเดียว พร้อมพิมพ์หรือ export เป็น PDF',
    examplePrompt:
      'ใช้เทมเพลต Modern Resume เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นเรซูเม่สไตล์มินิมอลสมัยใหม่ หน้า A4 หน้าเดียว พร้อมพิมพ์หรือ export เป็น PDF คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือรูปภาพ placeholder',
  },
  'screenshot': {
    description:
      'จับภาพหน้าจอเดสก์ท็อป, หน้าต่างแอป หรือพื้นที่พิกเซลข้ามแพลตฟอร์ม OS เหมาะสำหรับภาพหน้าจอเพื่อการตลาด, การรีวิวการออกแบบ และรายงานบั๊ก',
    examplePrompt:
      'จับภาพหน้าจอเดสก์ท็อป, หน้าต่างแอป หรือพื้นที่พิกเซลข้ามแพลตฟอร์ม OS',
  },
  'screenshots-marketing': {
    description:
      'สร้างภาพหน้าจอสำหรับการตลาดด้วย Playwright เหมาะสำหรับภาพ hero ของ landing page, ภาพหน้าจอสำหรับ App Store และภาพประกอบ changelog',
    examplePrompt:
      'สร้างภาพหน้าจอสำหรับการตลาดด้วย Playwright',
  },
  'shadcn-ui': {
    description:
      'สร้างคอมโพเนนต์ UI ด้วย shadcn/ui ใช้คู่กับลูปการออกแบบ Stitch เพื่อส่งมอบคอมโพเนนต์ที่มีโครงสร้างและเข้าถึงได้อย่างรวดเร็ว',
    examplePrompt:
      'สร้างคอมโพเนนต์ UI ด้วย shadcn/ui',
  },
  'shader-dev': {
    description:
      'เทคนิค GLSL shader สำหรับ ray marching, การจำลองของไหล, ระบบอนุภาค และการสร้างแบบ procedural เหมาะสำหรับภาพ hero และภาพนิ่งเชิงเคลื่อนไหว',
    examplePrompt:
      'เทคนิค GLSL shader สำหรับ ray marching, การจำลองของไหล, ระบบอนุภาค และการสร้างแบบ procedural',
  },
  'slack-gif-creator': {
    description:
      'สร้าง GIF เคลื่อนไหวที่ปรับให้เหมาะกับ Slack พร้อมตัวตรวจสอบข้อจำกัดด้านขนาดและพรีมิทีฟแอนิเมชันที่ประกอบเข้าด้วยกันได้',
    examplePrompt:
      'สร้าง GIF เคลื่อนไหวที่ปรับให้เหมาะกับ Slack พร้อมตัวตรวจสอบข้อจำกัดด้านขนาดและพรีมิทีฟแอนิเมชันที่ประกอบเข้าด้วยกันได้',
  },
  'slides': {
    description:
      'สร้างและแก้ไขเด็คงานนำเสนอ .pptx ด้วย PptxGenJS เหมาะสำหรับเด็คงานขาย, บรีฟเริ่มต้นโครงการ และการนำเสนอ design system',
    examplePrompt:
      'สร้างและแก้ไขเด็คงานนำเสนอ .pptx ด้วย PptxGenJS',
  },
  'social-reddit-card': {
    description:
      'การ์ดโพสต์ Reddit สมจริงพร้อมแถบโหวตและจำนวนคอมเมนต์ เหมาะสำหรับการซ้อนทับบนวิดีโอหรือการแชร์สตอรี',
    examplePrompt:
      'ใช้เทมเพลต Reddit Post Card เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นการ์ดโพสต์ Reddit สมจริงพร้อมแถบโหวตและจำนวนคอมเมนต์สำหรับการซ้อนทับบนวิดีโอหรือการแชร์สตอรี รักษาเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยงข้อความ lorem ipsum หรือรูปภาพ placeholder',
  },
  'social-spotify-card': {
    description:
      'การ์ดสไตล์ Spotify Now Playing พร้อมภาพปกอัลบั้ม, แถบความคืบหน้า และปุ่มควบคุมการเล่น เหมาะสำหรับการซ้อนทับบนวิดีโอหรือหน้าโฮมเพจส่วนตัว',
    examplePrompt:
      'ใช้เทมเพลต Spotify Now-Playing Card เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นการ์ดสไตล์ Spotify Now Playing พร้อมภาพปกอัลบั้ม, แถบความคืบหน้า และปุ่มควบคุมการเล่นสำหรับการซ้อนทับบนวิดีโอหรือหน้าโฮมเพจส่วนตัว รักษาเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยงข้อความ lorem ipsum หรือรูปภาพ placeholder',
  },
  'social-x-post-card': {
    description:
      'การ์ดโพสต์ X สมจริงพร้อมเมตริกการมีส่วนร่วม (ไลก์, รีโพสต์, ยอดดู) เหมาะสำหรับการซ้อนทับบนวิดีโอหรือการ์ดภาพที่แชร์ได้',
    examplePrompt:
      'ใช้เทมเพลต X / Twitter Post Card เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นการ์ดโพสต์ X สมจริงพร้อมเมตริกการมีส่วนร่วมสำหรับการซ้อนทับบนวิดีโอหรือการ์ดภาพที่แชร์ได้ รักษาเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยงข้อความ lorem ipsum หรือรูปภาพ placeholder',
  },
  'high-end-visual-design': {
    description:
      'สอนให้ AI ออกแบบเหมือนเอเจนซีระดับไฮเอนด์ กำหนดฟอนต์, ระยะห่าง, เงา, โครงสร้างการ์ด และแอนิเมชันที่แม่นยำซึ่งทำให้เว็บไซต์ดูหรูหรา ปิดกั้นค่าเริ่มต้นทั่วไปทั้งหมดที่ทำให้งานออกแบบของ AI ดูราคาถูกหรือธรรมดา',
    examplePrompt:
      'สร้าง landing page ระดับไฮเอนด์ที่ให้ความรู้สึกสงบ ด้วยการจัดวางตัวอักษรที่ประณีต, คอนทราสต์นุ่มนวล, ระยะห่างระดับพรีเมียม, มิติความลึกที่ละเอียดอ่อน และการเคลื่อนไหวที่เรียบง่าย',
  },
  'sora': {
    description:
      'สร้าง, รีมิกซ์ และจัดการคลิปวิดีโอสั้นผ่าน Sora API ของ OpenAI เหมาะสำหรับช็อตแบบภาพยนตร์, b-roll และการทำซ้ำวิดีโอคอนเซ็ปต์อย่างรวดเร็ว',
    examplePrompt:
      'สร้าง, รีมิกซ์ และจัดการคลิปวิดีโอสั้นผ่าน Sora API ของ OpenAI',
  },
  'speech': {
    description:
      'สร้างเสียงพูดจากข้อความโดยใช้ API ของ OpenAI พร้อมเสียงในตัว เหมาะสำหรับวิดีโออธิบายแบบมีเสียงบรรยาย, เสียงบรรยายการบรรยาย และแทร็กพากย์เสียงอย่างรวดเร็ว',
    examplePrompt:
      'สร้างเสียงพูดจากข้อความโดยใช้ API ของ OpenAI พร้อมเสียงในตัว',
  },
  'stitch-loop': {
    description:
      'ลูปฟีดแบ็กจากการออกแบบสู่โค้ดแบบวนซ้ำ วงจรวิจารณ์ → ปรับ → ส่งมอบ เพื่อเพิ่มความแม่นยำทางภาพระหว่างบรีฟกับ UI ที่สร้างขึ้นจริง',
    examplePrompt:
      'ลูปฟีดแบ็กจากการออกแบบสู่โค้ดแบบวนซ้ำ',
  },
  'stitch-design-taste': {
    description:
      'Semantic Design System Skill สำหรับ Google Stitch สร้างไฟล์ DESIGN.md ที่เป็นมิตรกับเอเจนต์ ซึ่งบังคับใช้มาตรฐาน UI ระดับพรีเมียมที่ไม่ธรรมดา — การจัดวางตัวอักษรที่เข้มงวด, สีที่ปรับเทียบอย่างแม่นยำ, เลย์เอาต์แบบอสมมาตร, ไมโครโมชันต่อเนื่อง และประสิทธิภาพที่เร่งด้วยฮาร์ดแวร์',
    examplePrompt:
      'สร้าง DESIGN.md ที่เป็นมิตรกับเอเจนต์สำหรับผลิตภัณฑ์นี้ ด้วยมาตรฐาน UI ระดับพรีเมียมที่ไม่ธรรมดา, การจัดวางตัวอักษร, สี, เลย์เอาต์, การเคลื่อนไหว และคำแนะนำพรอมต์',
  },
  'swiftui-design': {
    description:
      'SwiftUI 前端设计 skill — กฎต่อต้าน AI-slop, ที่ปรึกษาทิศทางการออกแบบ, โปรโตคอลแอสเซ็ตแบรนด์ และการรีวิวห้ามิติ ทำงานร่วมกับ Claude Code, Cursor, Codex และ OpenCode',
    examplePrompt:
      'SwiftUI 前端设计 skill — กฎต่อต้าน AI-slop, ที่ปรึกษาทิศทางการออกแบบ, โปรโตคอลแอสเซ็ตแบรนด์ และการรีวิวห้ามิติ',
  },
  'swiss-creative-mode-template': {
    description:
      'skill เทมเพลตงานนำเสนอโหมดสร้างสรรค์แรงบันดาลใจจากสไตล์สวิส พร้อมการจัดวางตัวอักษรเชิงบรรณาธิการที่โดดเด่น,\nการ์ดเรขาคณิตคอนทราสต์สูง, การนำทางสไลด์แบบโต้ตอบ,\nการสลับธีม, การซ้อนทับ hotspot และการเรียบเรียงพาเลตสีในไฟล์\nHTML artifact ไฟล์เดียว ใช้เมื่อผู้ใช้ต้องการ landing แบบงานนำเสนอระดับพรีเมียม,\nลุคเด็คสไตล์สวิส/brutalist หรือหน้าเปิดตัวสร้างสรรค์ที่มีการโต้ตอบหลากหลาย',
    examplePrompt:
      'skill เทมเพลตงานนำเสนอโหมดสร้างสรรค์แรงบันดาลใจจากสไตล์สวิส พร้อมการจัดวางตัวอักษรเชิงบรรณาธิการที่โดดเด่น, การ์ดเรขาคณิตคอนทราสต์สูง, การนำทางสไลด์แบบโต้ตอบ, การสลับธีม, การซ้อนทับ hotspot และการเรียบเรียงพาเลตสีในไฟล์ HTML artifact ไฟล์เดียว',
  },
  'swiss-user-research-video-template': {
    description:
      'เทมเพลตเล่าเรื่องงานวิจัยผู้ใช้สไตล์สวิสในสุนทรียะเชิงบรรณาธิการแบบกระดาษโทนอุ่น\nใช้เมื่อผู้ใช้ต้องการเด็คงานวิจัยระดับพรีเมียมหรือ live artifact ที่เน้นเรื่องราวเป็นหลัก พร้อม\nการจัดวางตัวอักษรแบบมินิมอล, เลย์เอาต์ที่ชัดเจนสูง, การเคลื่อนไหวที่ละเอียดอ่อน, แผนภูมิโดนัทแบ่งสัดส่วน\nและการนำทางด้วยคีย์บอร์ด/คลิกข้ามสไลด์ในไฟล์ HTML ไฟล์เดียว',
    examplePrompt:
      'สร้างเด็คสรุปงานวิจัยผู้ใช้สไตล์สวิส ด้วยการจัดวางตัวอักษรแบบมินิมอลระดับพรีเมียม, โทนกระดาษอุ่น, แผนภูมิโดนัทแบ่งสัดส่วนผู้เข้าร่วม และการโต้ตอบเชิงบรรณาธิการที่ละเอียดอ่อน',
  },
  'design-taste-frontend': {
    description:
      'skill ฟรอนต์เอนด์ต่อต้าน slop สำหรับ landing page, พอร์ตโฟลิโอ และการออกแบบใหม่ เอเจนต์อ่านบรีฟ, อนุมานทิศทางการออกแบบที่เหมาะสม และส่งมอบอินเทอร์เฟซที่ไม่ดูเหมือนเทมเพลต ใช้ design system จริงเมื่อเหมาะสม, ตรวจสอบก่อนเป็นอันดับแรกในการออกแบบใหม่ และการตรวจสอบ pre-flight ที่เข้มงวด',
    examplePrompt:
      'สร้าง landing page ระดับพรีเมียมที่เป็นไปตาม design-taste-frontend: อนุมานแนวทางการออกแบบ, ตั้งค่าพารามิเตอร์, หลีกเลี่ยงรูปแบบ AI-slop และส่งออก HTML artifact แบบ responsive ที่ขัดเกลาแล้ว',
  },
  'design-taste-frontend-v1': {
    description:
      'taste-skill เวอร์ชัน v1 ดั้งเดิม ซึ่งเก็บรักษาไว้สำหรับโปรเจกต์ที่ขึ้นอยู่กับพฤติกรรมที่แน่นอนของมัน ค่าเริ่มต้นปัจจุบันคือ `design-taste-frontend` (v2 เวอร์ชันทดลอง) ซึ่งเป็นการเขียนใหม่อย่างมาก ใช้ชื่อการติดตั้ง v1 นี้เฉพาะเมื่อคุณต้องการความเข้ากันได้ย้อนหลังที่แน่นอน',
    examplePrompt:
      'สร้างหน้าการตลาดที่ขัดเกลาแล้วโดยใช้ design-taste-frontend-v1 พร้อมการจัดวางตัวอักษร, ระยะห่าง, การเคลื่อนไหวที่แข็งแกร่ง และมาตรการป้องกัน anti-slop',
  },
  'theme-factory': {
    description:
      'ใช้ธีมฟอนต์และสีระดับมืออาชีพกับ artifact ต่างๆ รวมถึงสไลด์, เอกสาร, รายงาน และ landing page แบบ HTML มาพร้อมธีมสำเร็จรูป 10 แบบ',
    examplePrompt:
      'ใช้ธีมฟอนต์และสีระดับมืออาชีพกับ artifact ต่างๆ รวมถึงสไลด์, เอกสาร, รายงาน และ landing page แบบ HTML',
  },
  'threejs': {
    description:
      'skill Three.js สำหรับสร้างองค์ประกอบ 3D และประสบการณ์แบบโต้ตอบในเบราว์เซอร์ — ซีน, แมทีเรียล, การควบคุม และ post-processing',
    examplePrompt:
      'skill Three.js สำหรับสร้างองค์ประกอบ 3D และประสบการณ์แบบโต้ตอบในเบราว์เซอร์ — ซีน, แมทีเรียล, การควบคุม และ post-processing',
  },
  'ui-skills': {
    description:
      'ข้อกำหนดเชิงแนวคิดที่พัฒนาอย่างต่อเนื่องเพื่อชี้นำ agent ในการสร้างอินเทอร์เฟซ มีประโยชน์ในการรักษาความสอดคล้องของผลลัพธ์ในหลายๆ ชิ้นส่วน UI ขนาดเล็ก',
    examplePrompt:
      'ข้อกำหนดเชิงแนวคิดที่พัฒนาอย่างต่อเนื่องเพื่อชี้นำ agent ในการสร้างอินเทอร์เฟซ',
  },
  'ui-ux-pro-max': {
    description:
      'รายการ UI/UX Pro Max แบบแคตตาล็อกเท่านั้น เทมเพลต ข้อมูล และเวิร์กโฟลว์การค้นหาต้นทางฉบับเต็มไม่ได้รวมมาใน Open Design',
    examplePrompt:
      'รายการ UI/UX Pro Max แบบแคตตาล็อกเท่านั้น',
  },
  'venice-audio-music': {
    description:
      'เอนด์พอยต์สำหรับการเข้าคิว การเรียกดู และการสร้างเพลงให้เสร็จสมบูรณ์ผ่าน Venice.ai เหมาะสำหรับจิงเกิล ลูปเพลงพื้นหลัง และการทำสกอร์ต้นแบบ',
    examplePrompt:
      'เอนด์พอยต์สำหรับการเข้าคิว การเรียกดู และการสร้างเพลงให้เสร็จสมบูรณ์ผ่าน Venice.ai',
  },
  'venice-audio-speech': {
    description:
      'โมเดล Text-to-speech เสียง รูปแบบ และการสตรีมผ่าน Venice.ai มีประโยชน์สำหรับการบรรยาย เสียงพากย์ และเสียงของ conversational agent',
    examplePrompt:
      'โมเดล Text-to-speech เสียง รูปแบบ และการสตรีมผ่าน Venice.ai',
  },
  'venice-image-edit': {
    description:
      'การแก้ไขภาพ การเพิ่มความละเอียด และการลบพื้นหลังผ่าน Venice.ai API',
    examplePrompt:
      'การแก้ไขภาพ การเพิ่มความละเอียด และการลบพื้นหลังผ่าน Venice.ai API',
  },
  'venice-image-generate': {
    description:
      'เอนด์พอยต์การสร้างภาพและสไตล์ที่มีให้เลือกผ่าน Venice.ai API',
    examplePrompt:
      'เอนด์พอยต์การสร้างภาพและสไตล์ที่มีให้เลือกผ่าน Venice.ai API',
  },
  'venice-video': {
    description:
      'เวิร์กโฟลว์การสร้างวิดีโอและการถอดเสียงผ่าน Venice.ai API',
    examplePrompt:
      'เวิร์กโฟลว์การสร้างวิดีโอและการถอดเสียงผ่าน Venice.ai API',
  },
  'vfx-text-cursor': {
    description:
      'เส้นแสงตามเคอร์เซอร์ ลำแสงสีรุ้ง และแสงวาบแบบมีทิศทางสำหรับการเผยคำคมทีละคำในอินโทรวิดีโอ',
    examplePrompt:
      'ใช้เทมเพลต VFX Text Cursor เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นการเผยคำคมแบบอินโทรวิดีโอ พร้อมเส้นแสงตามเคอร์เซอร์ ลำแสงสีรุ้ง และแสงวาบแบบมีทิศทาง คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพ placeholder',
  },
  'video-downloader': {
    description:
      'ดาวน์โหลดวิดีโอจาก YouTube และแพลตฟอร์มอื่นๆ เพื่อรับชมแบบออฟไลน์ แก้ไข หรือเก็บถาวร โดยรองรับรูปแบบและตัวเลือกคุณภาพที่หลากหลาย',
    examplePrompt:
      'ดาวน์โหลดวิดีโอจาก YouTube และแพลตฟอร์มอื่นๆ เพื่อรับชมแบบออฟไลน์ แก้ไข หรือเก็บถาวร โดยรองรับรูปแบบและตัวเลือกคุณภาพที่หลากหลาย',
  },
  'video-hyperframes': {
    description:
      'แอนิเมชันเฟรมต่อเนื่องที่เข้ากันได้กับ Hyperframes / Remotion พร้อมรองรับการเล่นอัตโนมัติ',
    examplePrompt:
      'ใช้เทมเพลต Hyperframes Video เพื่อเปลี่ยนเนื้อหาของฉันให้เป็นแอนิเมชันเฟรมต่อเนื่องที่เข้ากันได้กับ Hyperframes / Remotion พร้อมรองรับการเล่นอัตโนมัติ คงเอกลักษณ์ทางภาพของเทมเพลตไว้ ใช้เนื้อหาและข้อมูลจริง และหลีกเลี่ยง lorem ipsum หรือภาพ placeholder',
  },
  'web-artifacts-builder': {
    description:
      'สร้าง HTML artifact ของ claude.ai ที่ซับซ้อนด้วย React และ Tailwind เวิร์กโฟลว์อ้างอิงของ Anthropic สำหรับการส่งมอบ artifact ที่สมบูรณ์และฝังตัวได้',
    examplePrompt:
      'สร้าง HTML artifact ของ claude.ai ที่ซับซ้อนด้วย React และ Tailwind',
  },
  'web-design-guidelines': {
    description:
      'แนวทางและมาตรฐานการออกแบบเว็บโดยทีมวิศวกรรมของ Vercel ครอบคลุมเลย์เอาต์ ไทโปกราฟี สี การเคลื่อนไหว และการเข้าถึงสำหรับ UI ของผลิตภัณฑ์',
    examplePrompt:
      'แนวทางและมาตรฐานการออกแบบเว็บโดยทีมวิศวกรรมของ Vercel',
  },
  'weread-year-in-review-video-template': {
    description:
      'เทมเพลตวิดีโอ HyperFrames ที่ได้แรงบันดาลใจจาก WeRead สำหรับรายงานการอ่านประจำปีแบบแนวตั้ง\nแดชบอร์ดการอ่านส่วนบุคคล สรุปบันทึกหนังสือ และเรื่องราวสรุปประจำปี\nที่แชร์ได้ ใช้เมื่อผู้ใช้ต้องการรายงานการอ่านแบบ HTML-to-MP4 อัตราส่วน 9:16 พร้อมพื้นผิวกระดาษโทนอบอุ่น\nไทโปกราฟีภาษาจีนเชิงบรรณาธิการ การเปรียบเปรยหน้าหนังสือ ไฮไลต์ข้อมูล\nและการเคลื่อนไหวแบบกำหนดได้แน่นอน',
    examplePrompt:
      'สร้างวิดีโอรายงานการอ่านประจำปีแบบ HyperFrames สไตล์ WeRead อัตราส่วน 9:16 ที่มี 12 ฉาก พร้อมพื้นผิวกระดาษโทนอบอุ่น การเปลี่ยนฉากแบบหน้าหนังสือ สถิติการอ่าน บันทึก คีย์เวิร์ด และการ์ดบุคลิกนักอ่านในฉากสุดท้าย',
  },
  'wpds': {
    description:
      'WordPress Design System นำดีไซน์โทเคน ไทโปกราฟี และรูปแบบคอมโพเนนต์อย่างเป็นทางการของ WordPress ไปใช้กับธีมและเว็บไซต์',
    examplePrompt:
      'WordPress Design System',
  },
  'youtube-clipper': {
    description:
      'การสร้างและแก้ไขคลิป YouTube ด้วยเวิร์กโฟลว์อัตโนมัติ — ดึงวิดีโอต้นฉบับ ตัดไฮไลต์ เพิ่มคำบรรยาย และส่งออก',
    examplePrompt:
      'การสร้างและแก้ไขคลิป YouTube ด้วยเวิร์กโฟลว์อัตโนมัติ — ดึงวิดีโอต้นฉบับ ตัดไฮไลต์ เพิ่มคำบรรยาย และส่งออก',
  },
};

export const TH_DESIGN_SYSTEM_SUMMARIES: Record<string, string> = {
  'agentic': 'อินเทอร์เฟซที่เน้น conversational AI เป็นหลัก พร้อมการควบคุมที่เรียบง่าย ผลลัพธ์ที่ชัดเจน และโฟลว์งานแบบมอบหมายสำหรับเวิร์กโฟลว์แบบ agentic',
  'airbnb': 'มาร์เก็ตเพลซด้านการท่องเที่ยว สีเน้นโทนคอรัลอบอุ่น ขับเคลื่อนด้วยภาพถ่าย UI ขอบมน',
  'airtable': 'ลูกผสมระหว่างสเปรดชีตกับฐานข้อมูล สุนทรียะแบบข้อมูลที่มีสีสัน เป็นมิตร และมีโครงสร้าง',
  'ant': 'ระบบออกแบบที่มีโครงสร้าง เน้นองค์กร โดยให้ความสำคัญกับความชัดเจน ความสม่ำเสมอ และประสิทธิภาพสำหรับเว็บแอปพลิเคชันที่มีข้อมูลหนาแน่น',
  'apple': 'อุปกรณ์อิเล็กทรอนิกส์สำหรับผู้บริโภค พื้นที่ว่างระดับพรีเมียม SF Pro ภาพแบบภาพยนตร์',
  'application': 'แดชบอร์ดแอปที่มีสุนทรียะโทนสีม่วง การนำทางแบบแถบด้านบน เลย์เอาต์แบบการ์ด และเวิร์กโฟลว์ที่เน้นนักพัฒนาเป็นหลัก',
  'arc': '"เบราว์เซอร์ที่ท่องเว็บแทนคุณ" พื้นผิวโปร่งแสง ความอบอุ่นแบบเกรเดียนต์ เลย์เอาต์ที่เน้นแถบด้านข้างเป็นหลัก',
  'artistic': 'สไตล์ที่มีคอนทราสต์สูงและแสดงออกชัดเจน ด้วยไทโปกราฟีเชิงสร้างสรรค์และการเลือกใช้สีที่กล้าหาญ สำหรับอินเทอร์เฟซที่สะดุดตา',
  'atelier-zero': 'ระบบภาพระดับนิตยสารที่ขับเคลื่อนด้วยคอลลาจ: แคนวาสกระดาษโทนอบอุ่น ภาพ\nปูนปลาสเตอร์และสถาปัตยกรรมเหนือจริง ตัวอักษรดิสเพลย์ขนาดใหญ่ เส้นบางเฉียบ\nเครื่องหมายส่วนแบบเลขโรมัน และคำอธิบายประกอบเชิงบรรณาธิการขนาดเล็ก\nได้แรงบันดาลใจจากโปรดักชัน v',
  'bento': 'เลย์เอาต์กริดแบบโมดูลาร์พร้อมบล็อกคล้ายการ์ด ลำดับชั้นที่ชัดเจน การเว้นระยะที่นุ่มนวล และคอนทราสต์ทางภาพที่ละเอียดอ่อน สำหรับอินเทอร์เฟซที่เป็นระเบียบและสแกนอ่านง่าย',
  'binance': 'กระดานเทรดคริปโต โทนสีเดียวตัดด้วยสีเหลืองสดเข้ม สื่ออารมณ์เร่งรีบแบบห้องเทรด',
  'bmw': 'ยานยนต์หรู พื้นผิวพรีเมียมโทนเข้ม สุนทรียะวิศวกรรมเยอรมันอันแม่นยำ',
  'bmw-m': 'แบรนด์ย่อยสายมอเตอร์สปอร์ตสมรรถนะสูง พื้นผิวค็อกพิตเกือบดำสนิท ตัดด้วยสีไตรรงค์ของ BMW M และเรขาคณิตเชิงวิศวกรรมที่คมชัด',
  'bold': 'การปรากฏตัวเชิงภาพที่ทรงพลังด้วยตัวอักษรน้ำหนักหนา สีคอนทราสต์สูง และเลย์เอาต์ที่ดูทรงอำนาจ',
  'brutalism': 'สุนทรียะแบบดิบและต่อต้านการดีไซน์ ได้แรงบันดาลใจจากสถาปัตยกรรมคอนกรีต ด้วยองค์ประกอบที่ไร้การตกแต่ง เลย์เอาต์ที่สะดุดตา และมินิมัลลิสม์เชิงฟังก์ชัน',
  'bugatti': 'แบรนด์ไฮเปอร์คาร์ ผืนผ้าใบสีดำสนิทแบบภาพยนตร์ ความเรียบเข้มโทนสีเดียว และตัวอักษรขนาดใหญ่อลังการ',
  'cafe': 'อินเทอร์เฟซที่ได้แรงบันดาลใจจากคาเฟ่อบอุ่น ด้วยโทนสีอุ่น ตัวอักษรนุ่มนวล และเลย์เอาต์สะอาดตาเพื่อประสบการณ์การเรียกดูที่ผ่อนคลาย',
  'cal': 'ระบบนัดหมายแบบโอเพนซอร์ส UI โทนกลางสะอาดตา เรียบง่ายแบบที่นักพัฒนาชื่นชอบ',
  'canva': 'แพลตฟอร์มสร้างสรรค์งานภาพ ไล่เฉดสีม่วง-น้ำเงินสดใส เว้นระยะอย่างเปิดกว้าง และเรขาคณิตที่ดูเป็นมิตร',
  'cisco': 'แบรนด์โครงสร้างพื้นฐานสำหรับองค์กร พื้นผิวโทนเข้มที่สื่อความน่าเชื่อถือ ตัดด้วยสี Cisco Blue และความชัดเจนเชิงเทคนิค',
  'claude': 'ผู้ช่วย AI ของ Anthropic ตัดด้วยสีดินเผาอุ่น เลย์เอาต์เชิงบรรณาธิการที่สะอาดตา',
  'clay': 'เอเจนซีสร้างสรรค์ รูปทรงออร์แกนิก ไล่เฉดสีนุ่มนวล และเลย์เอาต์ที่กำกับด้วยศิลปะ',
  'claymorphism': 'รูปทรงสามมิติโค้งมนนุ่มนวลคล้ายดินเหนียวที่ปั้นได้ ด้วยองค์ประกอบฟูนุ่มขี้เล่นและพื้นผิวสีสันสดใส',
  'clean': 'ดีไซน์ที่เน้นความเรียบง่าย ด้วยพื้นที่ว่างกว้างขวาง ตัวอักษรอ่านง่าย และจานสีจำกัดเพื่อลดความรกตา',
  'clickhouse': 'ฐานข้อมูลวิเคราะห์ความเร็วสูง ตัดด้วยสีเหลือง สไตล์เอกสารทางเทคนิค',
  'cohere': 'แพลตฟอร์ม AI สำหรับองค์กร ไล่เฉดสีสดใส สุนทรียะแดชบอร์ดที่อัดแน่นด้วยข้อมูล',
  'coinbase': 'กระดานเทรดคริปโต อัตลักษณ์สีน้ำเงินสะอาดตา เน้นความน่าเชื่อถือ ให้ความรู้สึกแบบสถาบัน',
  'colorful': 'จานสีและการไล่เฉดที่สดใสคอนทราสต์สูง เพื่อประสบการณ์ผู้ใช้ที่น่าดึงดูด น่าจดจำ และทันสมัย',
  'composio': 'แพลตฟอร์มเชื่อมต่อเครื่องมือ โทนเข้มทันสมัยพร้อมไอคอนการเชื่อมต่อที่มีสีสัน',
  'contemporary': 'ดีไซน์มินิมัลลิสต์ยุคปัจจุบัน ด้วยเบนโตกริด รองรับโหมดมืด และเลย์เอาต์ที่เข้าถึงได้และมีประสิทธิภาพสูง',
  'corporate': 'ดีไซน์มืออาชีพที่สอดคล้องกับแบรนด์ ด้วยกริดที่มีโครงสร้าง เลย์เอาต์มินิมัลลิสต์ และแพตเทิร์นองค์กรที่สม่ำเสมอ',
  'cosmic': 'สุนทรียะไซไฟล้ำยุค ด้วยธีมโทนเข้ม สีนีออนสดใส และองค์ประกอบเชิงพื้นที่ที่ดื่มด่ำ',
  'creative': 'ดีไซน์ขี้เล่นที่ขับเคลื่อนด้วยตัวละคร ด้วยตัวอักษรที่แสดงออกและกราฟิกหนักแน่น เหมาะสำหรับแลนดิงเพจและโปรเจกต์สร้างสรรค์',
  'cursor': 'โปรแกรมแก้ไขโค้ดที่เน้น AI เป็นหลัก อินเทอร์เฟซโทนเข้มดูเรียบหรู ตัดด้วยการไล่เฉดสี',
  'dashboard': 'สุนทรียะแพลตฟอร์มคลาวด์ธีมโทนเข้ม ด้วยกริดแบบโมดูลาร์ แผงคล้ายกระจก และลำดับชั้นข้อมูลที่ชัดเจน เหมาะสำหรับแดชบอร์ดเพิ่มประสิทธิภาพการทำงาน',
  'default': 'ค่าเริ่มต้นที่สะอาดตาและเน้นผลิตภัณฑ์ เหมาะสำหรับเครื่องมือ B2B แดชบอร์ด และหน้ายูทิลิตี',
  'discord': 'แพลตฟอร์มเสียง / แชต โทนสีบลูเพอเปิลเข้ม พื้นผิวที่เน้นโทนมืดเป็นหลัก พร้อมจังหวะสีตัดที่ขี้เล่น',
  'dithered': 'เทคนิคการเรนเดอร์ลายจุดที่จำลองเฉดสีด้วยจานสีจำกัด เพื่อภาพแนวย้อนยุคชวนคิดถึงและคอนทราสต์สูง',
  'doodle': 'สไตล์วาดมือคล้ายภาพสเก็ตช์ ด้วยลายขีดเขียน ฟอนต์ลายมือ และเส้นที่ไม่สมบูรณ์แบบ เพื่อความรู้สึกขี้เล่นและเป็นกันเอง',
  'dramatic': 'ดีไซน์คอนทราสต์สูงแบบละครเวที ด้วยเลย์เอาต์หนักแน่น ภาพที่ดื่มด่ำ และองค์ประกอบที่แหวกแนวซึ่งเรียกร้องความสนใจ',
  'duolingo': 'แพลตฟอร์มเรียนภาษา สีเขียวนกฮูกสดใส เงาหนาทึบ และความสนุกแบบเกม',
  'editorial': 'เลย์เอาต์เชิงบรรณาธิการที่ได้แรงบันดาลใจจากนิตยสาร ด้วยตัวอักษรเซอริฟอันประณีต กริดที่มีโครงสร้าง และประสบการณ์การอ่านที่สง่างาม',
  'elegant': 'สุนทรียะที่งดงามและประณีต ด้วยตัวอักษรอันละเอียดอ่อน จานสีน้อยชิ้น และเลย์เอาต์ที่ขัดเกลาจนสื่อความหรูหรามีระดับ',
  'elevenlabs': 'แพลตฟอร์มเสียง AI UI โทนเข้มแบบภาพยนตร์ สุนทรียะคลื่นเสียงออดิโอ',
  'energetic': 'สไตล์ที่มีพลังและสดใส ด้วยเส้นขอบหนา รูปทรงเรขาคณิต สีคอนทราสต์สูง และตัวอักษรที่แสดงออกซึ่งสื่อถึงการเคลื่อนไหวและความมีชีวิตชีวา',
  'enterprise': 'ดีไซน์องค์กรที่สะอาดตาและคอนทราสต์สูง สำหรับเวิร์กโฟลว์ที่ขับเคลื่อนด้วยข้อมูล ด้วยแพตเทิร์นลากและวางที่ใช้งานง่ายและเลย์เอาต์ที่มีโครงสร้าง',
  'expo': 'แพลตฟอร์ม React Native ธีมโทนเข้ม ระยะห่างตัวอักษรชิด เน้นโค้ดเป็นหลัก',
  'expressive': 'ดีไซน์ที่สดใสและมีบุคลิกโดดเด่น ด้วยสีสันหนักแน่น กราฟิกขี้เล่น และเลย์เอาต์ที่มีพลังซึ่งสร้างสมดุลระหว่างความคิดสร้างสรรค์กับโครงสร้าง',
  'fantasy': 'สุนทรียะแฟนตาซีที่ได้แรงบันดาลใจจากเกม ด้วยภาพหนักแน่นระดับพรีเมียม จานสีเข้มข้น และองค์ประกอบเชิงธีมที่ดื่มด่ำ',
  'ferrari': 'ยานยนต์หรู สไตล์บรรณาธิการแบบคิอาโรสคูโร ตัดด้วยสี Ferrari Red และความดำแบบภาพยนตร์',
  'figma': 'เครื่องมือออกแบบเชิงทำงานร่วมกัน หลากสีสันสดใส สนุกสนานแต่ยังคงความเป็นมืออาชีพ',
  'flat': 'สไตล์มินิมอลแบบสองมิติ ด้วยสีสันสดใส ตัวอักษรที่สะอาดตา และไม่มีเอฟเฟกต์ 3 มิติ เพื่ออินเทอร์เฟซที่รวดเร็วและใช้งานง่าย',
  'framer': 'เครื่องมือสร้างเว็บไซต์ สีดำและน้ำเงินที่โดดเด่น เน้นการเคลื่อนไหวและการออกแบบเป็นหลัก',
  'friendly': 'การออกแบบที่เข้าถึงง่ายและใช้งานสะดวก ด้วยองค์ประกอบโค้งมน พื้นที่ว่างที่กว้างขวาง และโทนสีพาสเทลนุ่มนวล',
  'futuristic': 'การออกแบบที่ก้าวล้ำ ด้วยตัวอักษรสไตล์เทคโนโลยี เลย์เอาต์ทันสมัย และความงามที่เพรียวบางขับเคลื่อนด้วยนวัตกรรม',
  'github': 'แพลตฟอร์มที่เน้นโค้ดเป็นหลัก ความหนาแน่นเชิงฟังก์ชัน ความแม่นยำสีน้ำเงินบนพื้นขาว รากฐานแบบ Primer',
  'glassmorphism': 'เอฟเฟกต์กระจกฝ้าด้วยเลเยอร์โปร่งแสง การเบลอบางเบา และขอบเรืองแสง เพื่อมิติและความหรูหราทันสมัย',
  'gradient': 'การไล่เฉดสีที่นุ่มนวลและพื้นผิวเต็มไปด้วยเกรเดียนต์ เพื่ออินเทอร์เฟซที่ทันสมัย สนุกสนาน และมีมิติทางสายตา',
  'hashicorp': 'ระบบอัตโนมัติด้านโครงสร้างพื้นฐาน สะอาดตาระดับองค์กร สีขาวดำ',
  'hud': 'จอแสดงผลแบบ head-up ของเครื่องบินรบ / เฮลิคอปเตอร์ สีเขียวฟอสฟอร์บนพื้นเกือบดำ ข้อมูลซ้อนทับแบบตัวพิมพ์ใหญ่ทั้งหมด เรขาคณิตเป็นเหลี่ยมมุม ชัดเจนปราศจากความกำกวมแม้ในความเร็วและระดับความสูง',
  'huggingface': 'ศูนย์รวมชุมชน ML สีเหลืองสดใสเป็นสีเน้น เอกลักษณ์แบบ monospace ร่าเริงและแน่นแฟ้น',
  'ibm': 'เทคโนโลยีระดับองค์กร ระบบออกแบบ Carbon โทนสีน้ำเงินที่มีโครงสร้าง',
  'intercom': 'การส่งข้อความถึงลูกค้า โทนสีน้ำเงินที่เป็นมิตร รูปแบบ UI เชิงสนทนา',
  'kami': 'ระบบกระดาษเชิงบรรณาธิการ: ผืนผ้าใบสีกระดาษพาร์ชเมนต์อบอุ่น สีน้ำเงินหมึกเป็นสีเน้น ลำดับชั้นที่นำด้วยตัวอักษร serif ออกแบบมาสำหรับเรซูเม่ เอกสารหน้าเดียว เอกสารทางการ พอร์ตโฟลิโอ สไลด์เด็ค — ทุกสิ่งที่ควรให้ความรู้สึกเหมือนสิ่งพิมพ์คุณภาพสูงมากกว่า UI รองรับหลายภาษาโดยพื้นฐาน',
  'kraken': 'การเทรดคริปโต UI โทนมืดเน้นสีม่วง แดชบอร์ดที่อัดแน่นด้วยข้อมูล',
  'lamborghini': 'แบรนด์ซูเปอร์คาร์ พื้นผิวดำสนิท สีทองเป็นสีเน้น ตัวอักษรพิมพ์ใหญ่ที่ดราม่า',
  'levels': 'การออกแบบที่เน้นการแปลงผู้ใช้ ขจัดอุปสรรคและนำผู้ใช้ไปสู่การลงมือทำผ่านความชัดเจน ความน่าเชื่อถือ และความรวดเร็ว',
  'linear-app': 'การจัดการโปรเจกต์ มินิมอลสุดขีด แม่นยำ เน้นสีม่วง',
  'lingo': 'การออกแบบที่สนุกสนานและมินิมอล ด้วยสีสันสดใส รูปทรงโค้งมน ขอบ 3 มิติที่สัมผัสได้ และภาพประกอบที่เป็นมิตรเพื่ออินเทอร์เฟซที่เข้าถึงง่าย',
  'loom': 'วิดีโอแบบ async ของ Loom สีม่วงเป็นสีหลัก พื้นผิวที่เป็นมิตร เลย์เอาต์ที่เน้นวิดีโอเป็นหลัก สะอาดตาและเป็นมืออาชีพโดยไม่ดูเป็นองค์กรจนเกินไป',
  'lovable': 'เครื่องมือสร้าง full-stack ด้วย AI เกรเดียนต์ที่สนุกสนาน ความงามที่เป็นมิตรกับนักพัฒนา',
  'luxury': 'ความงามโทนมืดระดับไฮเอนด์ ด้วยหัวเรื่องที่โดดเด่น โทนสีเดียว และความรู้สึกพรีเมียมสำหรับประสบการณ์แบรนด์หรูหรา',
  'mastercard': 'เครือข่ายการชำระเงินทั่วโลก ผืนผ้าใบสีครีมอบอุ่น รูปทรงแคปซูลแบบวงโคจร ความอบอุ่นเชิงบรรณาธิการ',
  'material': 'Material Design ของ Google ด้วยพื้นผิวเป็นชั้น การกำหนดธีมแบบไดนามิก การเคลื่อนไหวในตัว และรูปแบบที่ตอบสนองข้ามแพลตฟอร์ม',
  'meta': 'ร้านค้าปลีกเทคโนโลยี เน้นภาพถ่ายเป็นหลัก พื้นผิวสว่าง/มืดแบบไบนารี ปุ่ม CTA สี Meta Blue',
  'minimal': 'การออกแบบที่เรียบง่าย เน้นพื้นที่ว่าง ตัวอักษรที่สะอาดตา และสีที่ควบคุมไว้เพื่อความชัดเจนและการโฟกัสสูงสุด',
  'minimax': 'ผู้ให้บริการโมเดล AI อินเทอร์เฟซโทนมืดที่โดดเด่น พร้อมสีนีออนเป็นสีเน้น',
  'mintlify': 'แพลตฟอร์มเอกสาร สะอาดตา เน้นสีเขียว ปรับให้เหมาะกับการอ่าน',
  'miro': 'การทำงานร่วมกันเชิงภาพ สีเหลืองสดใสเป็นสีเน้น ความงามแบบผืนผ้าใบไร้ขีดจำกัด',
  'mission-control': 'การติดตามภารกิจอวกาศ/การบินและอวกาศ ศูนย์บัญชาการโทนมืด ข้อมูลทางไกลสีเหลืองอำพัน ความแม่นยำแบบ monospace ความชัดเจนเชิงฟังก์ชันเหนือสิ่งอื่นใด',
  'mistral-ai': 'ผู้ให้บริการ LLM แบบ open-weight มินิมอลที่ออกแบบโดยวิศวกรฝรั่งเศส โทนสีม่วง',
  'modern': 'สไตล์เชิงบรรณาธิการร่วมสมัย ด้วยตัวอักษร serif โทนสีมินิมอล และเลย์เอาต์ที่สะอาดตาสำหรับผลิตภัณฑ์ดิจิทัลที่ขัดเกลา',
  'mongodb': 'ฐานข้อมูลเอกสาร แบรนด์ใบไม้สีเขียว เน้นเอกสารสำหรับนักพัฒนา',
  'mono': 'การออกแบบที่ขับเคลื่อนด้วย monospace แรงบันดาลใจจาก matrix ด้วยองค์ประกอบคอนทราสต์สูง ความหนาแน่นกระชับ และความงามแบบแฮกเกอร์ชิค',
  'neobrutalism': 'การตีความใหม่ของบรูทัลลิสม์ ด้วยขอบที่โดดเด่น สีเน้นที่สดใส และเลย์เอาต์ดิบคอนทราสต์สูงบนพื้นผิวโทนอบอุ่น',
  'neon': 'เอฟเฟกต์เรืองแสงนีออนสดใส ด้วยการจับคู่สีคอนทราสต์สูงเพื่ออินเทอร์เฟซที่โดดเด่นและดึงดูดความสนใจ',
  'neumorphism': 'องค์ประกอบ UI ที่นูนนุ่มนวล ด้วยเงาด้านในและด้านนอกบนพื้นผิวโทนสีเดียวเพื่อรูปลักษณ์ที่สัมผัสได้และฝังตัว',
  'nike': 'ร้านค้าปลีกกีฬา UI โทนสีเดียว ตัวอักษรพิมพ์ใหญ่ขนาดมหึมา ภาพถ่ายเต็มพื้นที่',
  'notion': 'พื้นที่ทำงานครบวงจร มินิมอลโทนอบอุ่น หัวเรื่อง serif พื้นผิวนุ่มนวล',
  'nvidia': 'การประมวลผล GPU พลังงานสีเขียว-ดำ ความงามแบบพลังเชิงเทคนิค',
  'ollama': 'รัน LLM แบบโลคัล เน้นเทอร์มินัลก่อน เรียบง่ายแบบโมโนโครม',
  'openai': 'ระบบที่สงบและเกือบเป็นโมโนโครม ยึดด้วยสีดำอมเขียวเข้ม (teal-black) พร้อมพื้นที่ว่างสีขาวอย่างเหลือเฟือและงานพิมพ์สไตล์บรรณาธิการ',
  'opencode-ai': 'แพลตฟอร์ม AI สำหรับการเขียนโค้ด ธีมมืดที่เน้นนักพัฒนาเป็นศูนย์กลาง',
  'pacman': 'ดีไซน์แรงบันดาลใจจากเกมอาร์เคดยุคเก่า ด้วยฟอนต์พิกเซล ขอบประ\nจุด สีตัดกันสูงที่ขี้เล่น และสุนทรียะเกม 8-bit',
  'paper': 'ดีไซน์ผิวสัมผัสแบบกระดาษที่ได้แรงบันดาลใจจากงานพิมพ์ ด้วยสีน้อยชิ้น งานพิมพ์แบบ serif/sans ที่สะอาดตา และคุณสมบัติพื้นผิวที่สัมผัสได้',
  'perplexity': 'เครื่องมือค้นหา AI แบบสนทนา พื้นหลังมืดสนิท งานพิมพ์คมชัด สีม่วงเน้นเพียงสีเดียว ลำดับชั้นข้อมูลที่หนาแน่น',
  'perspective': 'ดีไซน์ที่มีมิติเชิงพื้นที่ด้วยมุมมองไอโซเมตริก จุดลับสายตา และองค์ประกอบที่ซ้อนชั้น ซึ่งนำสายตาผ่านความสมจริงคล้าย 3D',
  'pinterest': 'การค้นพบด้วยภาพ สีแดงเน้น กริดแบบ masonry เน้นภาพเป็นหลัก',
  'playstation': 'ค้าปลีกเครื่องเล่นเกมคอนโซล เลย์เอาต์แบบสามพื้นผิว ตัวอักษรแสดงผลแบบมีอำนาจเงียบ ๆ และเอฟเฟกต์ขยายเมื่อชี้สีฟ้าคราม(cyan)',
  'posthog': 'การวิเคราะห์ผลิตภัณฑ์ แบรนด์เม่นที่ขี้เล่น UI มืดที่เป็นมิตรกับนักพัฒนา',
  'premium': 'สุนทรียะระดับพรีเมียมที่ได้แรงบันดาลใจจาก Apple ด้วยระยะห่างที่แม่นยำ งานพิมพ์สมัยใหม่ และภาษาภาพที่ประณีตขัดเกลา',
  'professional': 'ดีไซน์ที่ขัดเกลาและพร้อมใช้งานเชิงธุรกิจ ด้วยงานพิมพ์สมัยใหม่ เลย์เอาต์ที่มีโครงสร้าง และอัตลักษณ์ภาพที่น่าเชื่อถือ',
  'publication': 'ภาษาภาพที่ได้แรงบันดาลใจจากงานพิมพ์ สำหรับหนังสือ นิตยสาร และรายงาน ด้วยกริดแบบบรรณาธิการและงานพิมพ์ที่แสดงอารมณ์',
  'raycast': 'ตัวเปิดแอปเพิ่มประสิทธิภาพการทำงาน โครเมียมมืดเนียนตา สีไล่เฉดที่สดใสเน้นจุดสนใจ',
  'refined': 'สไตล์มินิมอลสมัยใหม่ที่คัดสรรอย่างพิถีพิถัน ด้วยงานพิมพ์ serif ที่สง่างามและจานสีที่เรียบหรูแบบไม่โอ้อวด',
  'renault': 'ยานยนต์ฝรั่งเศส สีไล่เฉดแสงออโรราที่สดใส งานพิมพ์ NouvelR พลังงานที่กล้าหาญ',
  'replicate': 'รันโมเดล ML ผ่าน API พื้นหลังขาวสะอาดตา เน้นโค้ดเป็นหลัก',
  'resend': 'Email API ธีมมืดมินิมอล เน้นจุดด้วยฟอนต์ monospace',
  'retro': 'ดีไซน์ย้อนยุคด้วยงานพิมพ์ที่ได้แรงบันดาลใจจากวินเทจ จานสีเรโทรที่ตัดกันสูง และองค์ประกอบภาพที่ชวนคิดถึง',
  'revolut': 'ธนาคารดิจิทัล อินเทอร์เฟซมืดเนียนตา การ์ดไล่เฉดสี ความแม่นยำแบบฟินเทค',
  'runwayml': 'การสร้างวิดีโอด้วย AI UI มืดสไตล์ภาพยนตร์ เลย์เอาต์ที่อุดมด้วยสื่อ',
  'sanity': 'Headless CMS สีแดงเน้น เลย์เอาต์บรรณาธิการที่เน้นเนื้อหาเป็นหลัก',
  'sentry': 'การตรวจสอบข้อผิดพลาด แดชบอร์ดมืด ข้อมูลหนาแน่น สีชมพู-ม่วงเน้นจุด',
  'shadcn': 'ดีไซน์ที่ได้แรงบันดาลใจจาก Shadcn/ui ด้วยคอมโพเนนต์ที่มินิมอลสะอาดตา จานสีโมโนโครม และรูปแบบที่เน้นยูทิลิตี้เป็นหลัก',
  'shopify': 'แพลตฟอร์มอีคอมเมิร์ซ เน้นมืดสไตล์ภาพยนตร์ สีเขียวนีออนเน้นจุด ตัวอักษรน้ำหนักบางพิเศษ',
  'simple': 'ดีไซน์ที่ตรงไปตรงมา ไม่มีลูกเล่น ด้วยงานพิมพ์สะอาดตา สีกลาง และเลย์เอาต์ที่ใช้งานง่ายโดยไม่เกะกะ',
  'skeumorphism': 'การเลียนแบบโลกจริงด้วยพื้นผิวที่มีเท็กซ์เจอร์ เอฟเฟกต์ 3D และอุปมาทางกายภาพที่คุ้นเคย เพื่ออินเทอร์เฟซดิจิทัลที่ใช้งานง่าย',
  'slack': 'แพลตฟอร์มการสื่อสารในที่ทำงาน สีม่วงมะเขือ (aubergine) เป็นหลัก จานสีโลโก้แบบหลายสีเน้น พื้นผิวสว่างพร้อมแถบข้างมืด อบอุ่นและเข้าถึงง่าย',
  'sleek': 'สุนทรียะมินิมอลสมัยใหม่ด้วยเส้นสายสะอาดตา จานสีที่มีเจตนา การโต้ตอบที่ละเอียดอ่อน และระยะห่างที่สม่ำเสมอ',
  'spacex': 'เทคโนโลยีอวกาศ สีขาวดำตัดกันชัดเจน ภาพเต็มขอบจอ ดูล้ำอนาคต',
  'spacious': 'พื้นที่ว่างอย่างเหลือเฟือ ระยะ padding ที่สม่ำเสมอ และเลย์เอาต์ที่อิงกริด เพื่ออินเทอร์เฟซที่สะอาดตา อ่านง่าย และโปร่งสบาย',
  'spotify': 'สตรีมมิงเพลง สีเขียวสดใสบนพื้นมืด ตัวอักษรหนาหนัก ขับเคลื่อนด้วยปกอัลบั้ม',
  'starbucks': 'แบรนด์ค้าปลีกกาแฟระดับโลก ระบบสีเขียวสี่ระดับ พื้นหลังสีครีมอบอุ่น ปุ่มทรงแคปซูลเต็มรูป',
  'storytelling': 'ดีไซน์ที่ขับเคลื่อนด้วยการเล่าเรื่อง ใช้ภาพ คำ และการโต้ตอบเพื่อนำผู้ใช้ผ่านการเดินทางที่น่าดึงดูดและสะเทือนอารมณ์',
  'stripe': 'โครงสร้างพื้นฐานการชำระเงิน สีม่วงไล่เฉดอันเป็นเอกลักษณ์ ความสง่างามของน้ำหนักตัวอักษร 300',
  'supabase': 'ทางเลือกแบบโอเพนซอร์สแทน Firebase ธีมสีมรกตเข้ม เน้นโค้ดเป็นหลัก',
  'superhuman': 'ไคลเอนต์อีเมลที่รวดเร็ว UI มืดระดับพรีเมียม เน้นคีย์บอร์ดเป็นหลัก แสงเรืองสีม่วง',
  'tesla': 'ยานยนต์ไฟฟ้า การตัดทอนอย่างสุดขั้ว ภาพถ่ายเต็มหน้าจอ UI แทบจะเป็นศูนย์',
  'tetris': 'ดีไซน์ที่ได้แรงบันดาลใจจากเกมเรียงบล็อกคลาสสิก ด้วยสีที่ขี้เล่น ฟอนต์แสดงผลที่หนาหนัก และเลย์เอาต์ที่กระชับและเต็มไปด้วยพลัง',
  'theverge': 'สื่อบรรณาธิการสายเทค สีเขียวมินต์จัดจ้านและสีอัลตราไวโอเลตเน้นจุด ตัวอักษรแสดงผล Manuka การ์ดเล่าเรื่องสไตล์ใบปลิวงานเรฟ',
  'together-ai': 'โครงสร้างพื้นฐาน AI แบบโอเพนซอร์ส ดีไซน์เชิงเทคนิคสไตล์พิมพ์เขียว',
  'totality-festival': 'ระบบมืดสไตล์ glassmorphic ระดับพรีเมียมแห่งจักรวาล ที่ถ่ายทอดความตื่นตะลึงอันลึกซึ้งของสุริยุปราคา — พื้นผิวสีออบซิเดียน ไฮไลต์ "โคโรนา" สีอำพัน และสำเนียงบรรยากาศสีฟ้าครามไซแอน',
  'trading-terminal': 'เทอร์มินัลซื้อขายการเงินสไตล์ Bloomberg โหมดมืดเท่านั้น ข้อมูลหนาแน่น สัญญาณซื้อ/ขายสีไซแอน/คอรัล ทุกอย่างอ่านได้ในพริบตาจากระยะสองเมตร',
  'uber': 'แพลตฟอร์มการเดินทาง ขาวดำเข้มข้น ตัวอักษรกระชับ พลังงานแบบเมือง',
  'urdu': 'ประสบการณ์ดิจิทัลที่เน้นภาษาอูรดูเป็นหลัก พร้อมรองรับ RTL แบบเนทีฟ การออกแบบตัวอักษร Nastaliq และความกลมกลืนสองภาษา',
  'vercel': 'การดีพลอยฟรอนต์เอนด์ ความแม่นยำแบบขาวดำ ฟอนต์ Geist',
  'vibrant': 'ดีไซน์ที่มีชีวิตชีวาและสีสันสดใส พร้อมตัวอักษรขี้เล่นที่โดดเด่น สำเนียงสีอบอุ่น และพลังงานทางภาพที่เต็มไปด้วยพลวัต',
  'vintage': 'ความคิดถึงอดีตยุค 1950s-1990s ด้วยสัมผัสแบบ skeuomorphic พื้นผิวหยาบเป็นเม็ด พาเลตสีเรโทร และตัวอักษรสไตล์พิกเซล',
  'vodafone': 'แบรนด์โทรคมนาคมระดับโลก ตัวอักษรพิมพ์ใหญ่ขนาดยิ่งใหญ่ แถบบทตอนสี Vodafone Red',
  'voltagent': 'เฟรมเวิร์ก AI agent ผืนผ้าใบสีดำสนิท สำเนียงสีมรกต ออกแบบเพื่อเทอร์มินัลโดยกำเนิด',
  'warm-editorial': 'สุนทรียะแบบนิตยสารที่นำด้วยฟอนต์ serif สำเนียงสีเทอราคอตตาบนกระดาษสีออฟไวต์อบอุ่น —\nเหมาะสำหรับเนื้อหายาว บทบรรณาธิการ และหน้าการตลาดที่นำด้วยแบรนด์',
  'warp': 'เทอร์มินัลสมัยใหม่ อินเทอร์เฟซมืดคล้าย IDE UI คำสั่งแบบบล็อก',
  'webex': 'แพลตฟอร์มการทำงานร่วมกัน ตัวอักษรแบบ Momentum ระบบแอ็กชันสีน้ำเงิน สเปกตรัมสำเนียงหลายผู้ใช้',
  'webflow': 'เครื่องมือสร้างเว็บแบบวิชวล สำเนียงสีน้ำเงิน สุนทรียะเว็บไซต์การตลาดที่ขัดเกลาอย่างประณีต',
  'wechat': 'ภาษาทางภาพของแบรนด์สำหรับ WeChat Mini Programs official accounts และส่วนขยายระบบนิเวศแบบเปิด',
  'wired': 'นิตยสารเทคโนโลยี ความหนาแน่นแบบหนังสือพิมพ์แผ่นใหญ่สีขาวกระดาษ ฟอนต์ serif แสดงผลแบบกำหนดเอง คิกเกอร์ mono ลิงก์สีน้ำเงินหมึก',
  'wise': 'การโอนเงิน สำเนียงสีเขียวสดใส เป็นมิตรและชัดเจน',
  'x-ai': 'ห้องแล็บ AI ของ Elon Musk โมโนโครมเรียบนิ่ง มินิมัลแบบล้ำอนาคต',
  'xiaohongshu': 'แพลตฟอร์มโซเชียล UGC สายไลฟ์สไตล์ สีแดงแบรนด์เพียงหนึ่งเดียว มุมโค้งใจกว้าง เน้นเนื้อหาเป็นหลัก',
  'zapier': 'แพลตฟอร์มอัตโนมัติ สีส้มอบอุ่น เป็นมิตรและขับเคลื่อนด้วยภาพประกอบ',
};

export const TH_DESIGN_SYSTEM_CATEGORIES: Record<string, string> = {
  'AI & LLM': 'AI & LLM',
  'Automotive': 'ยานยนต์',
  'Backend & Data': 'แบ็กเอนด์ & ข้อมูล',
  'Bold & Expressive': 'โดดเด่น & เปี่ยมการแสดงออก',
  'Creative & Artistic': 'สร้างสรรค์ & ศิลปะ',
  'Design & Creative': 'ดีไซน์ & งานสร้างสรรค์',
  'Developer Tools': 'เครื่องมือนักพัฒนา',
  'E-Commerce & Retail': 'อีคอมเมิร์ซ & ค้าปลีก',
  'Editorial & Print': 'บทบรรณาธิการ & สิ่งพิมพ์',
  'Editorial / Personal / Publication': 'บทบรรณาธิการ / ส่วนตัว / สิ่งพิมพ์',
  'Editorial · Studio': 'บทบรรณาธิการ · สตูดิโอ',
  'Fintech & Crypto': 'ฟินเทค & คริปโต',
  'Layout & Structure': 'เลย์เอาต์ & โครงสร้าง',
  'Media & Consumer': 'สื่อ & ผู้บริโภค',
  'Modern & Minimal': 'โมเดิร์น & มินิมัล',
  'Morphism & Effects': 'Morphism & เอฟเฟกต์',
  'Productivity & SaaS': 'การเพิ่มประสิทธิภาพ & SaaS',
  'Professional & Corporate': 'มืออาชีพ & องค์กร',
  'Retro & Nostalgic': 'เรโทร & คิดถึงอดีต',
  'Social & Messaging': 'โซเชียล & การส่งข้อความ',
  'Starter': 'เริ่มต้น',
  'Themed & Unique': 'ธีมเฉพาะตัว',
};

export const TH_PROMPT_TEMPLATE_CATEGORIES: Record<string, string> = {
  'Advertising': 'โฆษณา',
  'Anime': 'อนิเมะ',
  'Anime / Manga': 'อนิเมะ / มังงะ',
  'App / Web Design': 'ออกแบบแอป / เว็บ',
  'Branding': 'การสร้างแบรนด์',
  'Cinematic': 'ภาพยนตร์',
  'Data': 'ข้อมูล',
  'Game UI': 'UI เกม',
  'General': 'ทั่วไป',
  'Illustration': 'ภาพประกอบ',
  'Infographic': 'อินโฟกราฟิก',
  'Live Artifact': 'Live Artifact',
  'Marketing': 'การตลาด',
  'Motion Graphics': 'โมชันกราฟิก',
  'Product': 'ผลิตภัณฑ์',
  'Profile / Avatar': 'โปรไฟล์ / อวาตาร์',
  'Short Form': 'คลิปสั้น',
  'Social / Meme': 'โซเชียล / มีม',
  'Social Media Post': 'โพสต์โซเชียลมีเดีย',
  'Travel': 'ท่องเที่ยว',
  'VFX / Fantasy': 'VFX / แฟนตาซี',
  'VFX / HTML-in-Canvas': 'VFX / HTML-in-Canvas',
};

export const TH_PROMPT_TEMPLATE_TAGS: Record<string, string> = {
  '3d': '3 มิติ',
  '3d-render': 'เรนเดอร์ 3 มิติ',
  'action': 'แอ็กชัน',
  'ancient-china': 'จีนโบราณ',
  'anime': 'อนิเมะ',
  'app-showcase': 'โชว์เคสแอป',
  'archery': 'ยิงธนู',
  'arpg': 'arpg',
  'audio-reactive': 'ตอบสนองเสียง',
  'boss-fight': 'สู้บอส',
  'brand': 'แบรนด์',
  'branding': 'การสร้างแบรนด์',
  'captions': 'คำบรรยาย',
  'cavalry': 'ทหารม้า',
  'chart': 'แผนภูมิ',
  'childlike': 'สไตล์เด็ก',
  'choreography': 'การออกแบบท่าทาง',
  'cinematic': 'ภาพยนตร์',
  'cinematic-romance': 'โรแมนติกแบบภาพยนตร์',
  'combat': 'การต่อสู้',
  'combo': 'คอมโบ',
  'companion-to-image': 'ภาพประกอบคู่กัน',
  'counter': 'ตัวนับ',
  'crayon': 'สีเทียน',
  'cyberpunk': 'ไซเบอร์พังก์',
  'dance': 'การเต้น',
  'dashboard': 'แดชบอร์ด',
  'data': 'ข้อมูล',
  'data-viz': 'การแสดงข้อมูลด้วยภาพ',
  'destruction': 'การทำลายล้าง',
  'displacement': 'การแทนที่',
  'editorial': 'บทบรรณาธิการ',
  'elden-ring': 'elden-ring',
  'endcard': 'การ์ดปิดท้าย',
  'escort': 'การคุ้มกัน',
  'escort-mission': 'ภารกิจคุ้มกัน',
  'fantasy': 'แฟนตาซี',
  'fashion': 'แฟชั่น',
  'fighting-game': 'เกมต่อสู้',
  'food': 'อาหาร',
  'game-cinematic': 'ภาพยนตร์เกม',
  'game-ui': 'เกม UI',
  'grid-sheet': 'ตารางกริด',
  'guanyu': 'กวนอู',
  'hand-drawn': 'วาดด้วยมือ',
  'hero': 'ฮีโร่',
  'html-in-canvas': 'HTML ในแคนวาส',
  'hud': 'HUD',
  'hud-safe': 'พื้นที่ปลอดภัยของ HUD',
  'hype': 'กระแสฮือฮา',
  'hyperframes': 'HyperFrames',
  'idol': 'ไอดอล',
  'illustration': 'ภาพประกอบ',
  'image-to-image': 'image-to-image',
  'infographic': 'อินโฟกราฟิก',
  'iphone': 'iPhone',
  'japanese': 'ญี่ปุ่น',
  'karaoke': 'คาราโอเกะ',
  'key-visual': 'คีย์วิชวล',
  'keynote': 'คีย์โน้ต',
  'kinetic-typography': 'ตัวอักษรเคลื่อนไหว',
  'linear-style': 'สไตล์ Linear',
  'liquid': 'ของเหลว',
  'liquid-glass': 'แก้วของเหลว',
  'live-artifact': 'อาร์ติแฟกต์สด',
  'logo': 'โลโก้',
  'lyubu': 'lyubu',
  'macbook': 'MacBook',
  'magnetic': 'แม่เหล็ก',
  'map': 'แผนที่',
  'marketing': 'การตลาด',
  'minimal': 'มินิมอล',
  'mmo': 'MMO',
  'mobile': 'มือถือ',
  'money': 'เงิน',
  'mounted-combat': 'การต่อสู้บนหลังม้า',
  'nature': 'ธรรมชาติ',
  'open-world': 'โลกเปิด',
  'otaku-dance': 'เต้นโอตาคุ',
  'outro': 'เอาท์โทร',
  'overlay': 'โอเวอร์เลย์',
  'particles': 'อนุภาค',
  'pipeline': 'ไปป์ไลน์',
  'portal': 'พอร์ทัล',
  'portrait': 'ภาพบุคคล',
  'pose-reference': 'ท่าอ้างอิง',
  'product': 'ผลิตภัณฑ์',
  'product-demo': 'เดโมผลิตภัณฑ์',
  'product-promo': 'โปรโมตผลิตภัณฑ์',
  'rework': 'ปรับปรุงใหม่',
  'route': 'เส้นทาง',
  'saas': 'SaaS',
  'sequence': 'ลำดับ',
  'shader': 'เชดเดอร์',
  'shatter': 'แตกกระจาย',
  'sizzle': 'ซิซเซิล',
  'social': 'โซเชียล',
  'storyboard': 'สตอรีบอร์ด',
  'street-fighter': 'street-fighter',
  'style-transfer': 'การถ่ายโอนสไตล์',
  'tekken': 'tekken',
  'text': 'ข้อความ',
  'three-kingdoms': 'สามก๊ก',
  'tiktok': 'tiktok',
  'title-card': 'การ์ดชื่อเรื่อง',
  'transform': 'แปลงรูป',
  'travel': 'ท่องเที่ยว',
  'tts': 'tts',
  'typography': 'ไทโปกราฟี',
  'unreal-engine-5': 'unreal-engine-5',
  'vertical': 'แนวตั้ง',
  'video-reference': 'วิดีโออ้างอิง',
  'vs-screen': 'หน้าจอ vs',
  'webgl': 'webgl',
  'website-to-video': 'เว็บไซต์เป็นวิดีโอ',
  'wuxia': 'กำลังภายใน',
  'zhaoyun': 'จ้าวหยุน',
};

export const TH_PROMPT_TEMPLATE_COPY: Record<string, Partial<Pick<PromptTemplateSummary, 'summary' | 'title'>>> = {
  '3d-stone-staircase-evolution-infographic': {
    title: 'อินโฟกราฟิกบันไดหินวิวัฒนาการ 3 มิติ',
    summary:
      'แปลงไทม์ไลน์วิวัฒนาการแบบแบนให้เป็นอินโฟกราฟิกบันไดหิน 3 มิติที่สมจริง พร้อมภาพเรนเดอร์สิ่งมีชีวิตที่ละเอียดและแผงด้านข้างที่จัดวางเป็นระเบียบ',
  },
  'anime-martial-arts-battle-illustration': {
    title: 'ภาพประกอบศึกศิลปะการต่อสู้สไตล์อนิเมะ',
    summary:
      'สร้างภาพประกอบสไตล์อนิเมะที่เปี่ยมพลังและทรงพลัง แสดงตัวละครหญิงสองคนต่อสู้กันในโดโจดั้งเดิมพร้อมเอฟเฟกต์พลังธาตุ',
  },
  'e-commerce-live-stream-ui-mockup': {
    title: 'ม็อกอัป UI ไลฟ์สตรีมอีคอมเมิร์ซ',
    summary:
      'สร้างอินเทอร์เฟซไลฟ์สตรีมโซเชียลมีเดียที่สมจริงซ้อนทับบนภาพบุคคล พร้อมข้อความแชทที่ปรับแต่งได้ ป๊อปอัปของขวัญ และการ์ดสั่งซื้อสินค้า',
  },
  'game-screenshot-anime-fighting-game-captain-ryuuga-vs-kaze-renshin': {
    title: 'ภาพหน้าจอเกม - เกมต่อสู้สไตล์อนิเมะ: Captain Ryuuga ปะทะ Kaze Renshin',
    summary:
      'คีย์วิชวล/ภาพหน้าจอการต่อสู้ในเกมต่อสู้ในสไตล์อาร์ตอินโทรของ Street Fighter 6 หรือ Tekken 8 นักรบชายสไตล์อนิเมะสองคนเผชิญหน้ากันกลางลานวัดจีนยามค่ำคืนอันน่าตื่นเต้น — ทางซ้ายเป็นโจรสลัดหมวกฟางเปลือยอกพร้อมออร่าไฟสีส้มแดงอบอุ่น และทางขวาเป็นนักศิลปะการต่อสู้ผมตั้งในชุดกิสีส้มที่กำลังรวบรวมพลังทรงกลมสายฟ้าสีน้ำเงินขนาดใหญ่ที่แตกประกาย มาพร้อม HUD เกมต่อสู้ที่สมบูรณ์ (แถบพลังชีวิตคู่ ตัวจับเวลายก แผงภาพบุคคล P1/P2 พร้อมชื่อนักสู้และตราสัญลักษณ์ ตัวนับคอมโบและเกจสูงสุดของแต่ละฝั่ง) การไล่โทนสีแบบแยกระหว่างสีส้มอบอุ่นกับสีน้ำเงินเย็นเข้ากับธรรมเนียมคู่ปรับนักสู้ของแนวเกมนี้ ปรับแต่งสำหรับ gpt-image-2 ที่อัตราส่วน 16:9',
  },
  'game-screenshot-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'ภาพหน้าจอเกม - ARPG สามก๊ก: กวนอูสังหารงันเหลียง',
    summary:
      'ภาพหน้าจอแอ็กชัน-RPG ในเกมของฉากสามก๊กอันเป็นเอกลักษณ์ที่กวนอูขี่ม้าศึกเซ็กเธาว์ฝ่าสนามรบกลางสายฝนกระหน่ำพุ่งเข้าหาแม่ทัพข้าศึกงันเหลียง เรนเดอร์ในสไตล์ภาพถ่ายเสมือนจริงเชิงภาพยนตร์แบบ Black Myth: Wukong, Unreal Engine 5, กล้องติดตามมุมมองบุคคลที่สามจากด้านหลังเยื้องซ้ายของวีรบุรุษบนหลังม้า HUD การต่อสู้บอสเต็มรูปแบบ (ภาพบุคคล มินิแมปพร้อมจุดศัตรูหนาแน่น ฮอตบาร์สกิลพร้อมพรอมต์ท่าจบ แถบ HP บอสลอยอยู่เหนือแม่ทัพข้าศึก) เปลี่ยนฉากนี้ให้เป็นช่วงเวลาการต่อสู้ ARPG ระดับ AAA ปรับแต่งสำหรับ gpt-image-2 ที่อัตราส่วน 16:9',
  },
  'game-screenshot-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'ภาพหน้าจอเกม - ARPG สามก๊ก: ลิโป้ยิงเกาทัณฑ์ที่ประตูค่าย',
    summary:
      'ภาพหน้าจอแอ็กชัน-RPG ในเกมของฉากสามก๊กอันโด่งดังที่ลิโป้ยิงทวนที่ปักไว้ไกลที่ประตูค่ายเพื่อยุติการศึก เรนเดอร์ในสไตล์ภาพถ่ายเสมือนจริงเชิงภาพยนตร์แบบ Black Myth: Wukong, Unreal Engine 5 Nanite/Lumen, กล้องเกมเพลย์มุมมองบุคคลที่สามข้ามไหล่ HUD ในเกมเต็มรูปแบบที่ซ้อนทับ (แถบ HP + ชี่ มินิแมป ฮอตบาร์สกิล เครื่องหมายเป้าหมายล็อกออนพร้อมค่าระยะทางไปยังทวนที่อยู่ไกล) ทำให้ดูเหมือนการจับภาพ ARPG เจนใหม่จริง ๆ มากกว่าฉากคัตซีน ปรับแต่งสำหรับ gpt-image-2 ที่อัตราส่วน 16:9',
  },
  'game-screenshot-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'ภาพหน้าจอเกม - ARPG สามก๊ก: จ้าวหยุนอุ้มทารกตีฝ่าที่เตียงปั้นโพ',
    summary:
      'ภาพหน้าจอแอ็กชัน-RPG ในเกมของฉากสามก๊กในตำนานที่จ้าวหยุนอุ้มทารกเล่าปี่ซิ้นไว้ในแขนข้างหนึ่งและต่อสู้ฝ่าแนวข้าศึกด้วยทวนในอีกแขนหนึ่งที่เตียงปั้นโพ เรนเดอร์ในสไตล์ภาพถ่ายเสมือนจริงเชิงภาพยนตร์แบบ Black Myth: Wukong ผสมผสานกับ Elden Ring, Unreal Engine 5 พร้อม Nanite เต็มรูปแบบ, การติดตามแสง Lumen และแสงทะลุปริมาตร แก่นทางอารมณ์ — แขนหนึ่งปกป้องทารกที่ห่อผ้า อีกแขนหนึ่งต่อสู้เพื่อชีวิต — ถูกเสริมด้วย HUD เต็มรูปแบบที่ซ้อนทับ รวมถึงแถบป้องกัน ESCORT เฉพาะสำหรับทารก ตัวนับคอมโบ และป๊อปอัปตัวเลขความเสียหายกลางอากาศบนศัตรูที่ถูกเหวี่ยง ปรับแต่งสำหรับ gpt-image-2 ที่อัตราส่วน 16:9',
  },
  'game-ui-ancient-china-open-world-mmo-hud': {
    title: 'UI เกม - HUD เกม MMO โลกเปิดจีนโบราณ',
    summary:
      'สร้างม็อกอัปภาพหน้าจอ HUD ในเกมสำหรับเกม MMO โลกเปิดจีนโบราณระดับ AAA ในสไตล์ภาพถ่ายเสมือนจริงเชิงภาพยนตร์แบบ Black Myth: Wukong ตัวเอกหญิงนักดาบผู้งดงามเป็นจุดศูนย์กลางของเฟรมในฉากศาลเจ้าโบราณบนภูเขาที่ปกคลุมด้วยหมอก ล้อมรอบด้วย HUD เกม MMO ที่สมบูรณ์: ภาพบุคคลตัวละครมุมบนซ้ายพร้อมแถบ HP/MP/สตามินาและไอคอนบัฟ, ฮอตบาร์สกิลกลางด้านล่างพร้อมไอคอนสกิลอักษรพู่กันจีน, มินิแมปมุมบนขวาพร้อมเครื่องหมายเควสต์, แผงติดตามเควสต์ด้านขวา, หน้าต่างแชทเลื่อนมุมล่างซ้าย, ป้ายชื่อ NPC ลอยในพื้นที่โลกและเครื่องหมายอัศเจรีย์เควสต์ เรนเดอร์เป็นภาพหน้าจอจอภาพที่สมจริง อัตราส่วน 16:9 เหมาะสำหรับพิตช์เด็ค คีย์อาร์ตสไตล์ gamescom และทีเซอร์เกมบน Xiaohongshu/bilibili',
  },
  'illustrated-city-food-map': {
    title: 'แผนที่อาหารในเมืองแบบภาพประกอบ',
    summary:
      'สร้างแผนที่ท่องเที่ยวสไตล์สีน้ำวาดมือ แสดงอาหารพื้นเมืองที่ใส่หมายเลข สถานที่สำคัญ และคำอธิบายสัญลักษณ์',
  },
  'illustration-crayon-kid-drawing-rework': {
    title: 'ภาพประกอบ - ปรับใหม่จากภาพวาดเด็กด้วยสีเทียน',
    summary:
      'พรอมต์สำหรับถ่ายโอนสไตล์ที่แปลงภาพอ้างอิงใดๆ (ภาพถ่ายสินค้า ภาพหน้าจอ ภาพบุคคล ภาพจำลอง UI) ให้กลายเป็นภาพประกอบวาดด้วยสีเทียนด้วยมือที่ดูเหมือนทำโดยเด็กอายุ 10 ขวบ แทนที่จานสีต้นฉบับด้วยสีเทียนสดใสสนุกสนานบนกระดาษขาวสะอาด และโรยความน่ารักไร้เดียงสาแบบเด็กๆ — ปราสาท ลูกอม ดวงดาว ก้อนเมฆ สายรุ้ง — เพื่อเพิ่มความรู้สึกแบบหนังสือนิทานบริสุทธิ์ ใช้งานได้ในรูปแบบการแก้ไขภาพต่อภาพใน GPT-image-2 (ต้องอัปโหลดภาพอ้างอิงควบคู่ไปกับพรอมต์); เหมาะอย่างยิ่งกับภาพหน้าจอเว็บไซต์ คีย์อาร์ตของแบรนด์ ภาพถ่ายสินค้า และภาพบุคคล',
  },
  'infographic-otaku-dance-choreography-breakdown-gokurakujodo-16-panels': {
    title: 'อินโฟกราฟิก - แยกท่าเต้นโอตาคุ (Gokuraku Jodo, 16 ช่อง)',
    summary:
      'โปสเตอร์แนวตั้งอัตราส่วน 2:3 เดี่ยว จัดวางเป็นตาราง 4×4 ของช่องสี่เหลี่ยมจัตุรัสที่เชื่อมต่อกัน 16 ช่อง เกิดเป็นแผนภูมิแยกท่าเต้นเต็มรูปแบบสำหรับเพลงเต้นโอตาคุญี่ปุ่นชื่อดัง 極楽浄土 (Gokuraku Jodo) แต่ละช่องแสดงสาวไอดอลอนิเมะกึ่งสมจริงน่ารักคนเดิม (ผมทวินเทลสีชมพู ชุดนักเรียนไอดอลปกกะลาสี) กำลังทำท่าซิกเนเจอร์หนึ่งท่าจากการเต้น แบบเต็มตัว บนพื้นหลังสีชมพูพาสเทล พร้อมแถบคำบรรยายภาษาญี่ปุ่นเล็กๆ ที่ด้านล่างและวงกลมตัวเลขที่มุมบนซ้าย ออกแบบมาอย่างชัดเจนเพื่อเป็นชีตอ้างอิงท่าทางสำหรับการสร้างวิดีโอด้วย AI — ทุกเงาภาพคมชัดและไม่กำกวม ไม่มีเส้นแสดงการเคลื่อนไหวหรือพื้นหลังรกรุงรัง ปรับให้เหมาะกับ gpt-image-2 อัตราส่วน 2:3 หมวดหมู่: อินโฟกราฟิก',
  },
  'momotaro-explainer-slide-in-hybrid-style': {
    title: 'สไลด์อธิบายโมโมทาโร่ในสไตล์ผสมผสาน',
    summary:
      'พรอมต์ที่ผสมผสานความสวยงามเรียบง่ายอบอุ่นของภาพประกอบ Irasutoya เข้ากับความหนาแน่นของข้อมูลสูงอันเป็นเอกลักษณ์ของสไลด์หน่วยงานราชการญี่ปุ่น',
  },
  'notion-team-dashboard-live-artifact': {
    title: 'แดชบอร์ดทีมสไตล์ Notion (Live Artifact)',
    summary:
      'ภาพจำลองแดชบอร์ดทีมแบบ Notion-native หน้าจอเดียว — ตาราง KPI, สปาร์คไลน์ 7 วัน, ฟีดกิจกรรม และตารางงานที่เชื่อมโยงฐานข้อมูล เป็นภาพประกอบคู่กับสกิล live-artifact; จับคู่กับมันสำหรับการรันที่รีเฟรชได้ / รองรับคอนเนกเตอร์ หรือใช้แบบเดี่ยวเป็นภาพจำลองนิ่ง',
  },
  'profile-avatar-anime-girl-to-cinematic-photo': {
    title: 'โปรไฟล์ / อวตาร - สาวอนิเมะสู่ภาพถ่ายแบบภาพยนตร์',
    summary:
      'พรอมต์นี้แปลงภาพประกอบอ้างอิงตัวละครให้กลายเป็นภาพบุคคลภายในห้องสไตล์วินเทจโทนอบอุ่นที่สมจริง ขณะที่ยังคงรักษาเครื่องแต่งกาย ท่าทาง และแมวต้นฉบับไว้',
  },
  'profile-avatar-casual-fashion-grid-photoshoot': {
    title: 'โปรไฟล์ / อวตาร - การถ่ายภาพแฟชั่นลำลองแบบกริด',
    summary:
      'พรอมต์ JSON แบบมีโครงสร้างสำหรับภาพคอลลาจ 4 รูปของการถ่ายภาพแฟชั่นลำลอง พร้อมพารามิเตอร์ของตัวแบบและแสงโดยละเอียด',
  },
  'profile-avatar-cinematic-south-asian-male-portrait-with-vultures': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลชายเอเชียใต้แบบภาพยนตร์พร้อมแร้ง',
    summary:
      'ภาพบุคคลแบบภาพยนตร์ที่ละเอียดของชายหนุ่มเอเชียใต้ในฉากแฟนตาซีมืดหม่นชวนครุ่นคิด รายล้อมด้วยแร้งและกา',
  },
  'profile-avatar-cyberpunk-anime-portrait-with-neon-face-text': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลอนิเมะไซเบอร์พังก์พร้อมข้อความนีออนบนใบหน้า',
    summary:
      'ภาพบุคคลอนิเมะสไตล์เก๋อาบแสงนีออนสำหรับโปสเตอร์ งานอาร์ตโซเชียลมีเดีย หรือภาพแบรนด์ดิ้งล้ำอนาคต',
  },
  'profile-avatar-elegant-fantasy-girl-in-violet-garden': {
    title: 'โปรไฟล์ / อวตาร - สาวแฟนตาซีสง่างามในสวนสีม่วง',
    summary:
      'พรอมต์นี้สร้างภาพบุคคลแฟนตาซีสไตล์อนิเมะที่ประณีตของหญิงสาวสง่างามที่มีผมเงางามจัดทรง เสื้อผ้าสีม่วง-ดำอันวิจิตร และฉากสวนเวทมนตร์เต็มไปด้วยดอกไม้ เหมาะอย่างยิ่งสำหรับตัวละคร',
  },
  'profile-avatar-ethereal-blue-haired-fantasy-portrait': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลแฟนตาซีผมสีฟ้าเหนือโลก',
    summary:
      'พรอมต์นี้สร้างภาพบุคคลตัวละครแฟนตาซีสไตล์อนิเมะที่นุ่มนวลเปล่งประกาย เหมาะอย่างยิ่งสำหรับการสร้างคีย์อาร์ตแนวตั้งที่สง่างามหรือภาพประกอบตัวละครที่มีผมพลิ้วไหวและบรรยากาศฤดูใบไม้ผลิราวกับความฝัน',
  },
  'profile-avatar-glamorous-woman-in-black-portrait': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลหญิงสาวเย้ายวนในชุดดำ',
    summary:
      'พรอมต์นี้สร้างภาพบุคคลสไตล์หรูหราสมจริงเสมือนจริงของหญิงสาวสง่างามในชุดสีดำคอลึก เหมาะอย่างยิ่งสำหรับภาพแฟชั่นเอดิทอเรียลหรือภาพความงาม',
  },
  'profile-avatar-hyper-realistic-selfie-texture-prompts': {
    title: 'โปรไฟล์ / อวตาร - พรอมต์พื้นผิวเซลฟี่สมจริงเหนือจริง',
    summary:
      'ชิ้นส่วนพรอมต์ที่ละเอียดสำหรับการสร้างพื้นผิวผิวหนังสมจริงและการจัดเฟรมเซลฟี่จากโทรศัพท์ที่ดูเป็นธรรมชาติ โดยเน้นที่รูขุมขนที่มองเห็นได้และแสงธรรมชาติ',
  },
  'profile-avatar-lavender-fantasy-mage-portrait': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลจอมเวทแฟนตาซีสีลาเวนเดอร์',
    summary:
      'พรอมต์นี้สร้างภาพบุคคลแฟนตาซีสไตล์อนิเมะที่ประณีตของเจ้าหญิงจอมเวทสง่างามที่มีผมบลอนด์เงางาม ดอกไม้สีม่วง และเครื่องแต่งกายคริสตัลอันวิจิตร เหมาะอย่างยิ่งสำหรับงานอาร์ตตัวละครหรือภาพประกอบเวทมนตร์',
  },
  'profile-avatar-monochrome-studio-portrait': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลในสตูดิโอขาวดำ',
    summary:
      'พรอมต์การถ่ายภาพเชิงพาณิชย์ระดับไฮเอนด์สำหรับภาพบุคคลขาวดำที่มีพื้นหลังแบ่งครึ่งอันโดดเด่นและแสงสตูดิโอที่ดูดราม่า',
  },
  'profile-avatar-old-photo-restoration-to-dslr-portrait': {
    title: 'โปรไฟล์ / อวตาร - บูรณะภาพถ่ายเก่าสู่ภาพบุคคลคุณภาพ DSLR',
    summary:
      'พรอมต์นี้บูรณะภาพถ่ายครอบครัว 4 คนแบบวินเทจที่เสียหายให้กลายเป็นภาพบุคคลสมจริงที่สะอาด ลงสี และความละเอียดสูง สำหรับการซ่อมแซมและปรับปรุงภาพถ่าย',
  },
  'profile-avatar-poetic-woman-in-garden-portrait': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลหญิงสาวกวีในสวน',
    summary:
      'พรอมต์นี้สร้างภาพบุคคลสไตล์เอดิทอเรียลสมจริงของหญิงสาวรักการอ่านในสวนที่อาบแสงแดด เหมาะอย่างยิ่งสำหรับการถ่ายภาพไลฟ์สไตล์ การสร้างแบรนด์เชิงวรรณกรรม หรือภาพตัวละครที่สง่างาม',
  },
  'profile-avatar-professional-identity-portrait-wallpaper': {
    title: 'โปรไฟล์ / อวตาร - วอลเปเปอร์ภาพบุคคลแสดงตัวตนเชิงอาชีพ',
    summary:
      'สร้างวอลเปเปอร์ระดับพรีเมียมความละเอียดสูงที่แสดงตัวแบบในชุดทำงานมืออาชีพพร้อมกิจกรรมที่เกี่ยวข้องกับอาชีพและงานตัวอักษร',
  },
  'profile-avatar-realistically-imperfect-ai-selfie': {
    title: 'โปรไฟล์ / อวตาร - เซลฟี่ AI ที่ไม่สมบูรณ์แบบอย่างสมจริง',
    summary:
      'พรอมต์สร้างสรรค์ที่ใช้กับ GPT Image 2 เพื่อสร้างเซลฟี่ \'ที่ล้มเหลว\' ซึ่งดูเหมือนภาพสแน็ปช็อตจากสมาร์ทโฟนคุณภาพต่ำที่ถ่ายโดยบังเอิญ',
  },
  'profile-avatar-signed-marker-portrait-on-shikishi': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลสไตล์ปากกาเมจิกพร้อมลายเซ็นบนชิกิชิ',
    summary:
      'พรอมต์นี้สร้างภาพบุคคลสไตล์ปากกาเมจิกที่มีชีวิตชีวาพร้อมลายเซ็นบนแผ่นชิกิชิทรงสี่เหลี่ยมจัตุรัส มีประโยชน์สำหรับลายเซ็นแฟนอาร์ต โพสต์ภาพประกอบที่ระลึก และภาพขอบคุณส่วนบุคคล',
  },
  'profile-avatar-snow-rabbit-empress-portrait': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลจักรพรรดินีกระต่ายหิมะ',
    summary:
      'พรอมต์ภาพบุคคลแฟนตาซีสมจริงสำหรับสร้างหญิงสาวธีมกระต่ายผู้สง่างามในชุดฮั่นฝูฤดูหนาวอันวิจิตร ยืนอยู่ในฉากวัดบนภูเขาที่ปกคลุมด้วยหิมะ',
  },
  'profile-avatar-snow-rabbit-mask-hanfu-portrait': {
    title: 'โปรไฟล์ / อวตาร - ภาพบุคคลฮั่นฝูหน้ากากกระต่ายหิมะ',
    summary:
      'พรอมต์นี้สร้างภาพพอร์ตเทรตแฟนตาซีฤดูหนาวสไตล์ภาพยนตร์ของหญิงสาวสวมหน้ากากในชุดฮั่นฝูสีขาวธีมกระต่าย เหมาะอย่างยิ่งสำหรับงานคาแรกเตอร์อาร์ตที่ดูสง่างามและภาพโชว์เคส AI ที่มีบรรยากาศ',
  },
  'profile-avatar-snowy-rabbit-hanfu-portrait': {
    title: 'โปรไฟล์ / อวาตาร์ - ภาพพอร์ตเทรตฮั่นฝูกระต่ายหิมะ',
    summary:
      'พรอมต์นี้สร้างภาพพอร์ตเทรตหญิงงามแฟนตาซีที่มีรายละเอียดสูงมากของหญิงสาวหูกระต่ายในชุดฮั่นฝูปักลาย เหมาะอย่างยิ่งสำหรับงานคาแรกเตอร์อาร์ตที่ดูสง่างาม การออกแบบเครื่องแต่งกาย หรือโชว์เคสภาพพอร์ตเทรต AI สไตล์ภาพยนตร์',
  },
  'profile-avatar-snowy-rabbit-spirit-portrait': {
    title: 'โปรไฟล์ / อวาตาร์ - ภาพพอร์ตเทรตวิญญาณกระต่ายหิมะ',
    summary:
      'พรอมต์นี้สร้างภาพพอร์ตเทรตแฟนตาซีอันเงียบสงบของหญิงสาวหูกระต่ายนิรนามในฤดูหนาว เหมาะอย่างยิ่งสำหรับงานคาแรกเตอร์อาร์ตที่มีบรรยากาศและภาพประกอบโปรไฟล์สไตล์เฉพาะตัว',
  },
  'profile-avatar-song-dynasty-hanfu-portrait': {
    title: 'โปรไฟล์ / อวาตาร์ - ภาพพอร์ตเทรตฮั่นฝูราชวงศ์ซ่ง',
    summary:
      'พรอมต์ที่ปรับแต่งมาเพื่อสร้างภาพพอร์ตเทรตที่มีรายละเอียดและสมจริงของหญิงงามในชุดฮั่นฝูดั้งเดิมแห่งราชวงศ์ซ่งภายในลานบ้านโบราณ',
  },
  'social-media-post-anime-pokemon-shop-outfit-teaser-poster': {
    title: 'โพสต์โซเชียลมีเดีย - โปสเตอร์ทีเซอร์ชุดแต่งกายร้าน Pokémon สไตล์อนิเมะ',
    summary:
      'พรอมต์นี้สร้างโปสเตอร์ประกาศแฟชั่นอนิเมะโทนพาสเทลนุ่มนวลที่มีเด็กสาวเบลอใบหน้าในชุดเดรสสีฟ้าภายในร้าน Pokémon เหมาะอย่างยิ่งสำหรับทีเซอร์เปิดตัวชุดแต่งกายและภาพโปรโมตคาแรกเตอร์',
  },
  'social-media-post-cinematic-elevator-scene': {
    title: 'โพสต์โซเชียลมีเดีย - ฉากลิฟต์สไตล์ภาพยนตร์',
    summary:
      'พรอมต์สำหรับสร้างฉากสไตล์ภาพยนตร์อารมณ์เข้มของหญิงสาวภายในลิฟต์โลหะ พร้อมแสงและเงาสะท้อนที่สมจริง',
  },
  'social-media-post-confused-elf-girl-at-pastel-desk': {
    title: 'โพสต์โซเชียลมีเดีย - เด็กสาวเอลฟ์งงงวยที่โต๊ะโทนพาสเทล',
    summary:
      'พรอมต์นี้สร้างภาพประกอบอนิเมะโทนพาสเทลนุ่มนวลของเด็กสาวเอลฟ์กำลังพิมพ์ที่คอมพิวเตอร์ในมุมทำงานคาวาอี้แสนอบอุ่น เหมาะอย่างยิ่งสำหรับโพสต์โซเชียล วอลล์เปเปอร์ หรืองานอาร์ตธีมสตรีมเมอร์',
  },
  'social-media-post-editorial-fashion-photography': {
    title: 'โพสต์โซเชียลมีเดีย - การถ่ายภาพแฟชั่นสไตล์เอดิทอเรียล',
    summary:
      'พรอมต์อารมณ์เข้มที่เน้นแฟชั่นสำหรับฉากสตูดิโอมินิมอล พร้อมแสงนุ่มนวลและโทนสีอบอุ่น',
  },
  'social-media-post-fashion-editorial-collage': {
    title: 'โพสต์โซเชียลมีเดีย - คอลลาจแฟชั่นเอดิทอเรียล',
    summary:
      'พรอมต์คอลลาจภาพถ่าย 2x2 ที่มีรายละเอียดสูงมากสำหรับงานถ่ายภาพแฟชั่นเอดิทอเรียล เน้นการจัดสไตล์ที่สม่ำเสมอ แสงเฉพาะเจาะจง และลักษณะใบหน้าจากภาพอ้างอิง',
  },
  'social-media-post-psg-transfer-announcement-poster': {
    title: 'โพสต์โซเชียลมีเดีย - โปสเตอร์ประกาศการย้ายทีม PSG',
    summary:
      'โปสเตอร์เซ็นสัญญานักฟุตบอลที่ดูโดดเด่นและเป็นมืออาชีพ สำหรับประกาศการย้ายทีมของนักเตะไปสู่ Paris Saint-Germain บนโซเชียลมีเดียหรือกราฟิกโปรโมตกีฬา',
  },
  'social-media-post-sensational-girl-dance-storyboard-8-shots': {
    title: 'โพสต์โซเชียลมีเดีย - สตอรีบอร์ดเด็กสาวเต้นสุดฮอต (8 ช็อต)',
    summary:
      'ชุดพรอมต์สตอรีบอร์ดครบ 8 ช็อตสำหรับสร้างลำดับการเต้นแบบเฟรมต่อเฟรมที่ต่อเนื่องกันของคาแรกเตอร์สุดสไตล์ ประกอบด้วยโทเค็นสไตล์รวมที่ใช้ร่วมกัน เนกาทีฟพรอมต์ที่นำกลับมาใช้ได้ และพรอมต์แปดช็อตแยกตามช็อต (ท่าเปิด, ขยับสะโพก, คลื่นลำตัว, บิดเอวจังหวะดรอป, โยกสะโพกด้านข้าง, สะบัดผม, ท่าทรงพลัง, ท่าจบ) ปรับแต่งสำหรับโมเดลระดับ GPT-Image-2: คำศัพท์กระชับ ไม่มีถ้อยคำอ่อนไหว ภาษาการจัดเฟรมและแสงสม่ำเสมอตลอดทุกช็อต เพื่อให้เฟรมทั้งหมดรู้สึกเหมือนการออกแบบท่าเต้นที่ต่อเนื่องเป็นหนึ่งเดียว',
  },
  'social-media-post-showa-day-retro-culture-magazine-cover': {
    title: 'โพสต์โซเชียลมีเดีย - ปกนิตยสารวัฒนธรรมเรโทรวันโชวะ',
    summary:
      'หน้าฟีเจอร์วันหยุดญี่ปุ่นสไตล์เอดิทอเรียลแสนอบอุ่น ที่ผสมผสานงานคาแรกเตอร์อาร์ตอนิเมะ ภาพถนนยุคโชวะที่ชวนคิดถึง และเลย์เอาต์ให้ข้อมูลสไตล์นิตยสาร สำหรับการโปรโมตวัฒนธรรมตามฤดูกาล',
  },
  'social-media-post-social-media-fashion-outfit-generation': {
    title: 'โพสต์โซเชียลมีเดีย - การสร้างชุดแต่งกายแฟชั่นสำหรับโซเชียลมีเดีย',
    summary:
      'พรอมต์สำหรับสร้างคำแนะนำชุดแต่งกายสไตล์บล็อกเกอร์แฟชั่นครบหนึ่งสัปดาห์ โดยอ้างอิงจากโปรไฟล์คาแรกเตอร์ พร้อมป้ายชื่อสินค้าและราคาครบถ้วน',
  },
  'social-media-post-travel-snapshot-collage-prompt': {
    title: 'โพสต์โซเชียลมีเดีย - พรอมต์คอลลาจภาพถ่ายท่องเที่ยว',
    summary:
      'พรอมต์ที่มีรายละเอียดสำหรับสร้างคอลลาจ 12 เฟรมชวนคิดถึง ของภาพถ่ายท่องเที่ยวสไตล์สมาร์ตโฟนที่บอกเล่าการเดินทางลำพัง',
  },
  'social-media-post-vintage-sign-painter-sketch': {
    title: 'โพสต์โซเชียลมีเดีย - ภาพสเก็ตช์ป้ายวาดมือสไตล์วินเทจ',
    summary:
      'สร้างภาพสเก็ตช์มาร์กเกอร์วาดมือบนกระดาษ พร้อมรายละเอียดสมจริงอย่างเส้นกราไฟต์และหมึกซึม เหมาะอย่างยิ่งสำหรับสไตล์ตัวอักษรวินเทจ',
  },
  'vr-headset-exploded-view-poster': {
    title: 'โปสเตอร์ภาพแยกชิ้นส่วนชุดหูฟัง VR',
    summary:
      'สร้างไดอะแกรมภาพแยกชิ้นส่วนไฮเทคของชุดหูฟัง VR พร้อมคำอธิบายส่วนประกอบโดยละเอียดและข้อความโปรโมต',
  },
  '3d-animated-boy-building-lego': {
    title: 'เด็กชายแอนิเมชัน 3D กำลังต่อเลโก้',
    summary:
      'พรอมต์วิดีโอหลายช็อตในสไตล์แอนิเมชัน 3D บรรยายเด็กชายกำลังประกอบชิ้นส่วนเลโก้อย่างตั้งใจในห้อง พร้อมเอฟเฟกต์ไทม์แลปส์',
  },
  'a-decade-of-refinement-glow-up': {
    title: 'การเปลี่ยนแปลงครั้งใหญ่ตลอดทศวรรษแห่งการพัฒนา',
    summary:
      'พรอมต์การเปลี่ยนแปลงสำหรับ Seedance 2.0 ที่แสดงการเปลี่ยนผ่านของชายคนหนึ่งจากบรรยากาศลำลองปี 2016 สู่ไลฟ์สไตล์หรูหราในดูไบปี 2026 ขณะคงความสม่ำเสมอของคาแรกเตอร์ไว้',
  },
  'ancient-guardian-dragon-rescue': {
    title: 'การช่วยเหลือของมังกรผู้พิทักษ์โบราณ',
    summary:
      'พรอมต์สไตล์ภาพยนตร์หลายช็อตที่มีรายละเอียด สำหรับเรื่องราวของเด็กสาวในหมู่บ้านท่ามกลางสายฝนที่ได้รับการช่วยเหลือจากมังกรที่ปรากฏตัวขึ้น โดยเน้นที่ VFX และเสียงบรรยากาศ',
  },
  'ancient-indian-kingdom-fpv-video': {
    title: 'วิดีโอ FPV อาณาจักรอินเดียโบราณ',
    summary:
      'พรอมต์สไตล์ภาพยนตร์แบบโดรน FPV ที่รวดเร็วฉับไว บรรยายอาณาจักรอินเดียอันลึกลับที่มีวิหารและป่าดงดิบ',
  },
  'animation-transfer-and-camera-tracking-prompt': {
    title: 'พรอมต์การถ่ายโอนแอนิเมชันและการติดตามกล้อง',
    summary:
      'พรอมป์เชิงเทคนิคสำหรับ Seedance 2.0 ที่นำการอ้างอิงการเคลื่อนไหวแบบเฉพาะเจาะจงมาใช้กับตัวละคร พร้อมรักษาการติดตามกล้องแบบตายตัว',
  },
  'beat-synced-outfit-transformation-dance': {
    title: 'การเต้นเปลี่ยนชุดให้เข้าจังหวะเพลง',
    summary:
      'พรอมป์สำหรับ Seedance 2.0 ที่ประสานการเต้นของตัวละครให้เป็นไปตามเฟรมแบ่งจังหวะ พร้อมเปลี่ยนชุดให้เข้ากับจังหวะเพลง',
  },
  'character-intro-motion-graphics-sequence': {
    title: 'ลำดับโมชั่นกราฟิกแนะนำตัวละคร',
    summary:
      'พรอมป์โมชั่นกราฟิกหลายขั้นตอนที่ซับซ้อนสำหรับการแนะนำทีมตัวละคร พร้อมโอเวอร์เลย์ UI และการเปลี่ยนภาพแบบเฉพาะเจาะจง ออกแบบมาสำหรับโมเดล Seedance 2.0',
  },
  'cinematic-birthday-celebration-sequence': {
    title: 'ลำดับการฉลองวันเกิดแบบภาพยนตร์',
    summary:
      'พรอมป์วิดีโอแบบหลายช็อตที่มีรายละเอียดสูงสำหรับลำดับวันเกิด โดยมุ่งเน้นความสอดคล้องของตัวละครและการเล่าเรื่องเชิงอารมณ์',
  },
  'cinematic-dragon-interaction-flight': {
    title: 'การมีปฏิสัมพันธ์กับมังกรและการบินแบบภาพยนตร์',
    summary:
      'พรอมป์สไตล์สตอรีบอร์ดที่มีรายละเอียดสำหรับวิดีโอที่นำเสนอการมีปฏิสัมพันธ์เชิงอารมณ์ของหญิงสาวกับมังกร ตามด้วยลำดับการบินแบบภาพยนตร์',
  },
  'cinematic-east-asian-woman-hand-dance': {
    title: 'การเต้นด้วยมือของหญิงเอเชียตะวันออกแบบภาพยนตร์',
    summary:
      'พรอมป์วิดีโอแบบภาพยนตร์หลายช็อตที่มีรายละเอียดสูงสำหรับการเต้นด้วยมือในสไตล์เฉพาะ พร้อมคำสั่งที่ระบุเวลาสำหรับการเคลื่อนกล้องและการกระทำของตัวละคร',
  },
  'cinematic-emotional-face-close-up': {
    title: 'ภาพโคลสอัพใบหน้าเชิงอารมณ์แบบภาพยนตร์',
    summary:
      'พรอมป์เชิงเทคนิคที่มีรายละเอียดสูงสำหรับ Seedance 2.0 โดยมุ่งเน้นพื้นผิวผิวหนังที่สมจริงและชุดการเปลี่ยนสีหน้าเชิงอารมณ์ที่ซับซ้อน',
  },
  'cinematic-marine-biologist-exploration': {
    title: 'การสำรวจของนักชีววิทยาทางทะเลแบบภาพยนตร์',
    summary:
      'พรอมป์วิดีโอแบบภาพยนตร์ที่มีรายละเอียดสำหรับฉากใต้น้ำที่นำเสนอนักชีววิทยาทางทะเลค้นพบซากเรืออับปางโบราณในแนวปะการัง',
  },
  'cinematic-music-podcast-and-guitar-technique': {
    title: 'พ็อดแคสต์ดนตรีและเทคนิคกีตาร์แบบภาพยนตร์',
    summary:
      'พรอมป์แบบภาพยนตร์ขั้นสูงสำหรับการสร้างวิดีโอพ็อดแคสต์ดนตรี 4K โดยมุ่งเน้นเทคนิคกีตาร์ พินช์ฮาร์โมนิก และสุนทรียศาสตร์ของสตูดิโอเป็นพิเศษ',
  },
  'cinematic-route-navigation-guide': {
    title: 'คู่มือนำทางเส้นทางแบบภาพยนตร์',
    summary:
      'พรอมป์แบบมีโครงสร้างหลายฉากที่ออกแบบมาสำหรับ Seedance เพื่อสร้างวิดีโอนำทางการเดินที่สอดคล้องกัน นำเสนอตัวละครไกด์นำเที่ยวที่ปรากฏซ้ำและการเปลี่ยนภาพที่ราบรื่นระหว่างสถานที่จริง',
  },
  'cinematic-street-racing-sequence-for-seedance-2': {
    title: 'ลำดับการแข่งรถบนถนนแบบภาพยนตร์สำหรับ Seedance 2',
    summary:
      'พรอมป์หลายช็อตที่มีรายละเอียดออกแบบมาสำหรับ Seedance 2 เพื่อสร้างลำดับการแข่งรถบนถนนแบบภาพยนตร์ในยามค่ำคืน โดยมุ่งเน้นสมาธิอันเข้มข้นของผู้ขับขี่ การทำงานของกล้องที่ไดนามิก และการเร่งความเร็วอันรุนแรง struct',
  },
  'cinematic-vampire-alley-fight-sequence': {
    title: 'ลำดับฉากต่อสู้แวมไพร์ในตรอกแบบภาพยนตร์',
    summary:
      'พรอมป์แอ็กชันที่ครอบคลุมสำหรับฉากภาพยนตร์สั้นที่มีการเคลื่อนกล้องแบบไดนามิกและการต่อสู้ความเร็วสูงในตรอกที่มีแสงนีออน',
  },
  'crimson-horizon-sci-fi-cinematic-sequence': {
    title: 'ลำดับภาพยนตร์ไซไฟ Crimson Horizon',
    summary:
      'ลำดับวิดีโอแบบภาพยนตร์ 9 ช็อตที่ครอบคลุมสำหรับภาพยนตร์ไซไฟชื่อ \'Crimson Horizon\' โดยให้รายละเอียดทุกอย่างตั้งแต่การปล่อยจรวดไปจนถึงการเผชิญหน้ากับมนุษย์ต่างดาวอันน่าขนลุกบนดาวอังคาร',
  },
  'cyberpunk-game-trailer-script': {
    title: 'สคริปต์ตัวอย่างเกมไซเบอร์พังก์',
    summary:
      'พรอมป์สร้างวิดีโอที่ครอบคลุมสำหรับตัวอย่างเกมไซเบอร์พังก์ โดยให้รายละเอียดการออกแบบตัวละคร แอนิเมชัน UI และการเปลี่ยนสภาพแวดล้อมจากความว่างเปล่าสีขาวไปสู่ชุมชนแออัด',
  },
  'forbidden-city-cat-satire': {
    title: 'เสียดสีแมวในพระราชวังต้องห้าม',
    summary:
      'พรอมป์คอเมดีดาร์กที่ซับซ้อนสำหรับ Seedance 2.0 ที่นำเสนอแมวส้มที่เป็นขุนนางและไฮยีนาจักรพรรดิในฉากเสียดสีสมัยราชวงศ์ชิง',
  },
  'hollywood-haute-couture-fantasy-video-prompt': {
    title: 'พรอมป์วิดีโอแฟนตาซีโอตกูตูร์ฮอลลีวูด',
    summary:
      'พรอมป์สร้างวิดีโอหลายฉากที่มีรายละเอียดสำหรับ Seedance 2.0 ออกแบบมาเพื่อสร้างภาพยนตร์แฟนตาซีโอตกูตูร์ฮอลลีวูด พรอมป์นี้ระบุสไตล์ ความละเอียด (8K) เอนจินเรนเดอร์ (Unreal Engin',
  },
  'hunched-character-animation': {
    title: 'แอนิเมชันตัวละครหลังค่อม',
    summary:
      'คำสั่งสำหรับ Seedance 2 เพื่อสร้างแอนิเมชันการเดินอยู่กับที่สำหรับการอ้างอิงตัวละครแบบเฉพาะเจาะจง',
  },
  'hyperframes-html-in-canvas-iphone-device': {
    title: 'HyperFrames HTML-in-Canvas: เดโมผลิตภัณฑ์ 3D iPhone + MacBook',
    summary:
      'เดโมผลิตภัณฑ์ความยาว 15 วินาทีที่ iPhone 15 Pro Max และ MacBook Pro แบบ GLTF ของจริงลอยอยู่บนเวทีที่สะอาดตา พร้อม UI แอปจริงที่เรนเดอร์สดบนหน้าจอของอุปกรณ์ผ่าน drawElementImage มีเลนส์แฟลร์กระจกที่เปลี่ยนรูปและแท่นหมุน 360° สร้างขึ้นบนบล็อกแคตตาล็อก vfx-iphone-device',
  },
  'hyperframes-html-in-canvas-text-cursor': {
    title: 'HyperFrames HTML-in-Canvas: การเผยข้อความด้วยเคอร์เซอร์แบบภาพยนตร์',
    summary:
      'การเผยข้อความที่เร้าใจความยาว 8 วินาทีพร้อมแสงเรืองรองของเคอร์เซอร์ รังสีเงาแบบโครมาติก และแสงทิศทางบนเวทีสีดำ ตัวอักษร DOM ของจริงภายใต้การประมวลผลหลังเชเดอร์แบบสด สร้างขึ้นบนบล็อกแคตตาล็อก vfx-text-cursor',
  },
  'hyperframes-html-in-canvas-shatter': {
    title: 'HyperFrames HTML-in-Canvas: เอาต์โทรกระจกแตก',
    summary:
      'เอาต์โทร HTML กระจกแตกความยาว 12 วินาที — หน้าผลิตภัณฑ์จริงหรือการ์ดราคาค้างอยู่ชั่วครู่ จากนั้นระเบิดออกเป็นเศษกระจกที่หักเหแสงพร้อมการเบลอตามระยะลึกและการกระจายสีแบบโครมาติก สร้างขึ้นบนบล็อกแคตตาล็อก vfx-shatter ใช้เป็นการ์ดปิดท้ายหลังจากองค์ประกอบที่ยาวขึ้น',
  },
  'hyperframes-html-in-canvas-liquid-background': {
    title: 'HyperFrames HTML-in-Canvas: ฮีโร่พื้นหลังของเหลว',
    summary:
      'ฉาก hero ความยาว 12 วินาที ที่มีเนื้อหา HTML ลอยอยู่เหนือพื้นผิวของเหลวแบบออร์แกนิก — ระนาบที่ถูกแบ่งย่อยและเลื่อนตำแหน่ง vertex, ไดนามิกของคลื่นแบบเรียลไทม์, DOM ที่จับภาพมาวางอยู่ด้านบนอย่างคมชัดและอ่านง่าย สร้างบนบล็อกแคตตาล็อก vfx-liquid-background',
  },
  'hyperframes-html-in-canvas-liquid-glass': {
    title: 'HyperFrames HTML-in-Canvas: การเผยตัวหน้า Landing แบบ Liquid Glass',
    summary:
      'การเผยตัวหน้า landing ผลิตภัณฑ์จริงแบบ voronoi liquid-glass ความยาว 20 วินาที — DOM ถูกจับภาพแบบสดผ่าน drawElementImage, แตกออกเป็นเซลล์แก้วที่หักเหแสง แล้วค่อย ๆ ลงตัวเป็นภาพ hero ที่สะอาดตา สร้างบนบล็อกแคตตาล็อก vfx-liquid-glass',
  },
  'hyperframes-html-in-canvas-magnetic': {
    title: 'HyperFrames HTML-in-Canvas: การแสดงภาพสนามแม่เหล็ก',
    summary:
      'การแสดงภาพอนุภาคสนามแม่เหล็กความยาว 15 วินาที ที่ตอบสนองต่อ heatmap หรือแผนภูมิ DOM แบบสด — อนุภาคลากตามเส้นสนามที่โค้งรอบ HTML ที่จับภาพมา เหมาะสำหรับผลิตภัณฑ์ ML/ข้อมูล สร้างบนบล็อกแคตตาล็อก vfx-magnetic',
  },
  'hyperframes-html-in-canvas-portal-reveal': {
    title: 'HyperFrames HTML-in-Canvas: แดชบอร์ดเผยตัวแบบ Portal',
    summary:
      'พอร์ทัลมิติความยาว 10 วินาที เปิดออกสู่แดชบอร์ดข้อมูลแบบสด — DOM ถูกจับภาพแบบเรียลไทม์, แสงล้นแบบ volumetric, อนุภาคขอบพอร์ทัล สร้างบนบล็อกแคตตาล็อก vfx-portal ออกแบบมาสำหรับภาพ hero ข้อมูลสไตล์คีย์โน้ต',
  },
  'hyperframes-money-counter-hype': {
    title: 'HyperFrames: เคาน์เตอร์เงินสร้างกระแส $0 → $10K (9:16)',
    summary:
      'คลิปสร้างกระแส HyperFrames แนวตั้ง 1080×1920 ความยาว 6 วินาที — เคาน์เตอร์สไตล์ Apple $0 → $10,000 พร้อมแฟลชสีเขียว, อนุภาคเงินกระจาย, ไอคอนกองเงินสด, หัวข้อ kicker สร้างบนบล็อกแคตตาล็อก HyperFrames `apple-money-count`',
  },
  'hyperframes-app-showcase-three-phones': {
    title: 'HyperFrames: การโชว์เคสแอปความยาว 12 วินาที — โทรศัพท์ลอยสามเครื่อง',
    summary:
      'การจัดองค์ประกอบโชว์เคสแอป 16:9 ความยาว 12 วินาที — หน้าจอ iPhone ลอยสามเครื่องลอยอยู่ในพื้นที่ 3 มิติ แต่ละเครื่องหมุนทีละเครื่องเพื่อนำเสนอฟีเจอร์ที่ต่างกัน, label callout ที่ซิงค์กับจังหวะ, ล็อกอัพโลโก้ตอนจบ สร้างโดยตรงบนบล็อกแคตตาล็อก HyperFrames `app-showcase`',
  },
  'hyperframes-brand-sizzle-reel': {
    title: 'HyperFrames: รีลโปรโมตแบรนด์ความยาว 30 วินาที',
    summary:
      'รีลโปรโมต HyperFrames 16:9 ความยาว 30 วินาที — ตัดต่อรวดเร็ว, ตัวอักษรเคลื่อนไหวซิงค์จังหวะ, สเกลตอบสนองเสียงบนคำเด่น, ทรานซิชัน shader ระหว่างห้าฉาก, การ์ดจบพร้อมโลโก้เปล่งประกาย จำลองจากอาร์คีไทป์ aisoc-hype จากชุดสำหรับนักเรียน',
  },
  'hyperframes-saas-product-promo-30s': {
    title: 'HyperFrames: โปรโมตผลิตภัณฑ์ SaaS ความยาว 30 วินาที (สไตล์ Linear)',
    summary:
      'การจัดองค์ประกอบ HyperFrames ความยาว 30 วินาที จำลองจากภาพยนตร์ผลิตภัณฑ์สไตล์ Linear/ClickUp — การเผย UI แบบ 3 มิติ, ตัวอักษรเคลื่อนไหวซิงค์จังหวะ, ภาพหน้าจอ UI แบบเคลื่อนไหว, การ์ดจบพร้อมโลโก้ตอนจบ สร้างจากบล็อกแคตตาล็อก HF (ui-3d-reveal, app-showcase, logo-outro) พร้อมทรานซิชัน shader ระหว่างฉาก',
  },
  'hyperframes-logo-outro-cinematic': {
    title: 'HyperFrames: โลโก้ตอนจบแนวภาพยนตร์ความยาว 4 วินาที',
    summary:
      'โลโก้ตอนจบ 16:9 ความยาว 4 วินาที — การประกอบ wordmark ทีละชิ้นพร้อม bloom, การกวาดแสงระยิบระยับทั่วล็อกอัพสุดท้าย, เลเยอร์เกรนนุ่มนวล, CTA บรรทัดเดียว สร้างบนบล็อก HyperFrames `logo-outro`, `shimmer-sweep` และ `grain-overlay`',
  },
  'hyperframes-product-reveal-minimal': {
    title: 'HyperFrames: การเผยผลิตภัณฑ์แบบมินิมอลความยาว 5 วินาที',
    summary:
      'การจัดองค์ประกอบ HyperFrames ความยาว 5 วินาที สำหรับการเผยผลิตภัณฑ์ระดับไฮเอนด์ — แคนวาสมืด, สีเน้นโทนอุ่นสีเดียว, การ์ดชื่อค่อย ๆ ดันเข้าช้า ๆ, บรรทัด kicker เคลื่อนไหว, การเคลื่อนไหวที่ยับยั้งไว้ เอเจนต์เรนเดอร์ MP4 จาก HTML+GSAP ผ่าน puppeteer โดยไม่ต้องใช้ฟุตเทจสำเร็จรูป',
  },
  'hyperframes-social-overlay-stack': {
    title: 'HyperFrames: ชุดโอเวอร์เลย์โซเชียล 9:16 (X · Reddit · Spotify · Instagram)',
    summary:
      'การจัดองค์ประกอบ HyperFrames แนวตั้ง 1080×1920 ความยาว 15 วินาที ที่ซ้อนการ์ดโซเชียลเคลื่อนไหวสี่ใบบนลูป face-cam — โพสต์ X, รีแอ็กชัน Reddit, การ์ด now-playing ของ Spotify และ CTA ติดตาม Instagram ตอนจบ การ์ดแต่ละใบเป็นบล็อกแคตตาล็อก HyperFrames โดยการจัดวางท่วงท่าคือคุณค่าที่เพิ่มเข้ามา',
  },
  'hyperframes-tiktok-karaoke-talking-head': {
    title: 'HyperFrames: คลิป Talking-Head TikTok 9:16 พร้อมคำบรรยายแบบคาราโอเกะ',
    summary:
      'คลิปสั้น HyperFrames แนวตั้ง 1080×1920 — talking-head บรรยายด้วย TTS บนลูป face-cam พร้อมคำบรรยายซิงค์ทีละคำสไตล์คาราโอเกะ, lower third เคลื่อนไหว และโอเวอร์เลย์ติดตาม tiktok ตอนจบ สะท้อนอาร์คีไทป์ may-shorts-19 จากชุดสำหรับนักเรียน HyperFrames',
  },
  'hyperframes-data-bar-chart-race': {
    title: 'HyperFrames: การแข่งขันแผนภูมิแท่งเคลื่อนไหว (สไตล์ NYT)',
    summary:
      'อินโฟกราฟิกข้อมูล 16:9 ความยาว 12 วินาที — แผนภูมิแท่ง + เส้นเคลื่อนไหวพร้อมการเผยหมวดหมู่แบบเหลื่อมเวลา, หัวข้อแบบ serif สไตล์ NYT, แหล่งที่มาในเชิงอรรถ, label ค่าตัวเลขเคลื่อนไหว สร้างโดยตรงบนบล็อกแคตตาล็อก HyperFrames `data-chart`',
  },
  'hyperframes-flight-map-route': {
    title: 'HyperFrames: แผนที่เส้นทางบินสไตล์ Apple (ต้นทาง → ปลายทาง)',
    summary:
      'แผนที่เส้นทางบินแนวภาพยนตร์ 16:9 ความยาว 8 วินาที — ซูมภูมิประเทศสมจริง, เครื่องบินเคลื่อนไหวร่อนจากต้นทางสู่ปลายทางตามเส้นทางโค้ง, เมืองที่มีป้ายกำกับ, เคาน์เตอร์ระยะทางเคลื่อนไหว สร้างโดยตรงบนบล็อกแคตตาล็อก HyperFrames `nyc-paris-flight` นำกลับมาใช้ได้กับคู่เมืองใดก็ได้',
  },
  'hyperframes-website-to-video-promo': {
    title: 'HyperFrames: ไปป์ไลน์เว็บไซต์สู่วิดีโอ (คลิปการตลาดความยาว 15 วินาที)',
    summary:
      'การจัดองค์ประกอบ HyperFrames 16:9 ความยาว 15 วินาที ที่จับภาพเว็บไซต์แบบสดในขนาด viewport สามแบบ แล้วเคลื่อนไหวสลับระหว่างกันด้วยการแยกแบบ radial เชิงสีระหว่างฉาก สะท้อนอาร์คีไทป์ hyperframes-sizzle จากชุดสำหรับนักเรียน ที่เว็บไซต์เป็นแหล่งสินทรัพย์ต้นทาง',
  },
  'live-action-anime-adaptation-water-vs-thunder-breathing-duel': {
    title: 'การดัดแปลงอนิเมะเป็นแอ็กชันจริง: การดวลลมหายใจสายน้ำ ปะทะ สายฟ้า',
    summary:
      'พรอมต์รายละเอียดสูงความยาว 15 วินาที สำหรับสร้างการดัดแปลงแบบแอ็กชันจริงของการดวลสไตล์อนิเมะ นำเสนอ \'ลมหายใจสายน้ำ\' (มังกรน้ำสีฟ้า) ปะทะ \'ลมหายใจสายฟ้า\' (สายฟ้าสีทอง) The p',
  },
  'luxury-supercar-cinematic-narrative': {
    title: 'เรื่องราวแนวภาพยนตร์ของซูเปอร์คาร์หรู',
    summary:
      'พรอมต์แนวภาพยนตร์หลายช็อตที่มีรายละเอียดสูงสำหรับ Seedance 2.0 เกี่ยวกับชายผู้มีสไตล์, สุนัขพันธุ์โดเบอร์แมน และซูเปอร์คาร์วินเทจในฉากภูเขาที่ปกคลุมด้วยหมอก',
  },
  'magical-academy-storyboard-sequence': {
    title: 'ลำดับสตอรีบอร์ดสถาบันเวทมนตร์',
    summary:
      'พรอมต์สไตล์สตอรีบอร์ดที่มีรายละเอียดสำหรับลำดับภาพแนวภาพยนตร์ที่บรรยายสาวน้อยเวทมนตร์ในสถาบัน ครอบคลุมการมาถึง, การค้นพบพลัง และการดวลเวทมนตร์',
  },
  'modern-rural-aesthetics-healing-short-film-video-prompt': {
    title: 'พรอมต์วิดีโอภาพยนตร์สั้นเยียวยาใจสไตล์สุนทรียะชนบทสมัยใหม่',
    summary:
      'พรอมต์สามช็อตที่มีรายละเอียดสำหรับ Seedance 2.0 เพื่อสร้างภาพยนตร์สั้นแนวภาพยนตร์เยียวยาใจในสไตล์สุนทรียะชนบทสมัยใหม่ โดยระบุสไตล์ (Cinematic Commercial, 4K/8K, Extreme Macro, nat',
  },
  'nightclub-flyer-atmospheric-animation': {
    title: 'แอนิเมชันบรรยากาศใบปลิวไนต์คลับ',
    summary:
      'พรอมต์แอนิเมชันแบบละเอียดอ่อนสำหรับ Seedance 2.0 เพื่อทำให้องค์ประกอบพื้นหลังและแสงมีชีวิตชีวาในขณะที่ตรึงตัวแบบไว้นิ่ง',
  },
  'retro-hk-wuxia-film-aesthetic': {
    title: 'สุนทรียะภาพยนตร์กำลังภายในฮ่องกงย้อนยุค',
    summary:
      'พรอมต์วิดีโอแบบหลายส่วนที่ซับซ้อน สร้างสรรค์สุนทรียะของภาพยนตร์กำลังภายในฮ่องกงยุค 80-90 ขึ้นมาใหม่ นำเสนอการแปลงร่างของตัวละครจากแมวเป็นมนุษย์ด้วยช็อตที่มีสไตล์เฉพาะตัว',
  },
  'seedance-2-0-15-second-cinematic-japanese-romance-short-film': {
    title: 'Seedance 2.0: หนังสั้นโรแมนติกญี่ปุ่นแนวภาพยนตร์ความยาว 15 วินาที',
    summary:
      'พรอมต์แบบหลายฉากความยาว 15 วินาทีที่มีรายละเอียดสูงสำหรับ Seedance 2.0 ออกแบบมาเพื่อสร้างหนังสั้นรักบริสุทธิ์วัยมัธยมปลายแบบญี่ปุ่นที่สมจริงสุดขีดแนวภาพยนตร์ พรอมต์ระบุการจัดฉาก (ว่างเปล่า',
  },
  'seedance-2-0-80-year-old-rapper-mv': {
    title: 'Seedance 2.0: MV แร็ปเปอร์วัย 80 ปี',
    summary:
      'พรอมต์ความยาว 15 วินาทีที่มีรายละเอียดสำหรับ Seedance 2.0 เพื่อสร้างมิวสิกวิดีโอ (MV) แร็ปข้างถนนแนวนอนอัตราส่วน 16:9 ที่นำเสนอหญิงชราวัย 80 ปี พรอมต์ระบุสไตล์ (โทนสีเย็นม่วง/น้ำเงินนีออน, exp',
  },
  'sequence-and-movement-instruction-for-martial-arts-video': {
    title: 'คำสั่งลำดับและการเคลื่อนไหวสำหรับวิดีโอศิลปะการต่อสู้',
    summary:
      'พรอมต์วิดีโอสำหรับ Seedance 2.0 ที่สั่งให้โมเดลทำแอนิเมชันลำดับการเคลื่อนไหวตามชาร์ตตัวละคร โดยเน้นการเคลื่อนไหวและขั้นตอนที่เฉพาะเจาะจง',
  },
  'soul-switching-mirror-magic-sequence': {
    title: 'ลำดับเวทมนตร์สลับวิญญาณในกระจก',
    summary:
      'พรอมต์วิดีโอแบบเล่าเรื่องที่บรรยายเหตุการณ์สลับวิญญาณอันมหัศจรรย์ที่กระจก พร้อมคำสั่งกล้องและสัญญาณทางอารมณ์ที่เฉพาะเจาะจงสำหรับแต่ละช่วง',
  },
  'toaster-rocket-jumpscare': {
    title: 'เครื่องปิ้งขนมปังจรวดสะดุ้งตกใจ',
    summary:
      'พรอมต์สำหรับช็อตสไตล์วิดีโอโฮมเมดสมจริงของชายชราที่ถูกทำให้สะดุ้งตกใจโดยเครื่องปิ้งขนมปังที่ดีดขนมปังออกมาเหมือนจรวด',
  },
  'traditional-dance-performance': {
    title: 'การแสดงนาฏศิลป์ดั้งเดิม',
    summary:
      'พรอมต์วิดีโอที่ครอบคลุมสำหรับ Seedance 2.0 เพื่อสร้างการเต้นรำดั้งเดิมที่อ่อนช้อยตามท่าเต้นและภาพอ้างอิงอัตลักษณ์ตัวละคร',
  },
  'video-seedance-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'วิดีโอ - สามก๊ก ARPG - กวนอูสังหารงันเหลียง (Seedance 2.0)',
    summary:
      'ลำดับฉากแอ็กชันแนวภาพยนตร์ในเอนจินความยาวประมาณ 10 วินาที ที่ทำให้เทมเพลตภาพคู่กัน game-screenshot-three-kingdoms-guanyu-slaying-yanliang มีชีวิตขึ้นมา กวนอู (关羽) ขี่ม้าเซ็กเธาว์พุ่งตรงเข้าสู่แนวรบของศัตรู ยกง้าวมังกรเขียวขึ้น และฟันขุนพลฝ่ายตรงข้ามงันเหลียงด้วยการฟันครั้งเดียวที่สะอาดหมดจด ปรับแต่งสำหรับ Seedance 2.0 — การควบคุมกล้องที่แม่นยำ การโจมตีเด็ดขาดเพียงครั้งเดียว ฟิสิกส์ของม้าและง้าวที่สะอาด แสงสมจริงเหมือนภาพถ่าย ไม่มีความรุนแรงเลือดสาดบนจอเด็ดขาด (การโจมตีสื่อด้วยแสงวาบพลังฉี่สีทอง ไม่ใช่ด้วยเลือด) ออกแบบมาให้เป็นวิดีโอคู่กับเทมเพลตภาพที่เข้าชุดกันโดยตรง เพื่อให้ภาพนิ่งและคลิปสามารถนำเสนอเป็นคู่ได้ ภาพอ้างอิง: เทมเพลตภาพสกรีนช็อตกวนอูสังหารงันเหลียง',
  },
  'video-seedance-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'วิดีโอ - สามก๊ก ARPG - ลิโป้ยิงธนูประตูค่าย (Seedance 2.0)',
    summary:
      'ลำดับฉากแอ็กชันแนวภาพยนตร์ในเอนจินความยาวประมาณ 10 วินาที ที่ทำให้เทมเพลตภาพคู่กัน game-screenshot-three-kingdoms-lyubu-yuanmen-archery มีชีวิตขึ้นมา ลิโป้ (吕布) ยืนอยู่ตรงกลางค่ายทหารที่เต็มไปด้วยฝุ่นระหว่างกองทัพสองฝ่ายที่เผชิญหน้ากัน ง้างคันธนูยาวเคลือบรักสีแดง เล็งนิ่งขณะง้าง แล้วปล่อยลูกธนูเปล่งแสงพลังฉี่สีทองเพียงดอกเดียวพุ่งไปตามแนวสู่ทวนที่ปักอยู่บนพื้นในระยะไกล ปรับแต่งสำหรับ Seedance 2.0 — การควบคุมกล้องที่แม่นยำ จังหวะเด็ดขาดเพียงครั้งเดียว การจัดเฟรมที่คมชัดปลอดภัยสำหรับ HUD ฟิสิกส์ของคันธนู/ลูกธนูที่สะอาด การเคลื่อนไหวของลม + ฝุ่น + ธง และการเกรดสีแบบสกรีนช็อตในเกม ออกแบบมาให้เป็นวิดีโอคู่กับเทมเพลตภาพที่เข้าชุดกันโดยตรง เพื่อให้ภาพนิ่งและคลิปสามารถนำเสนอเป็นคู่ได้ ภาพอ้างอิง: เทมเพลตภาพสกรีนช็อตลิโป้ยิงธนูประตูค่าย',
  },
  'video-seedance-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'วิดีโอ - สามก๊ก ARPG - จูล่งฝ่าวงล้อมอุ้มทารก (Seedance 2.0)',
    summary:
      'ลำดับฉากแอ็กชันแนวภาพยนตร์ในเอนจินความยาวประมาณ 12 วินาที ที่ทำให้เทมเพลตภาพคู่กัน game-screenshot-three-kingdoms-zhaoyun-cradle-escape มีชีวิตขึ้นมา จูล่ง (赵云) ขี่ม้าศึกฝ่าสมรภูมิเตียงปันที่แตกหักยับเยิน โอบอุ้มทายาทน้อยอาเต๊าไว้ในวงแขนซ้ายและถือทวนในมือขวา ปัดป้องการโจมตีที่พุ่งเข้ามาด้วย PERFECT DODGE เพียงครั้งเดียว แล้วกระโจนข้ามรถศึกที่ล้มลงเพื่อเปิดทาง ปรับแต่งสำหรับ Seedance 2.0 — การควบคุมกล้องที่แม่นยำ จังหวะต่อเนื่องเพียงครั้งเดียว การใช้ทวนด้วยแขนข้างเดียวที่ดูสมจริง ฟิสิกส์ของม้าที่สะอาด และไม่มีอันตรายที่มองเห็นได้ต่อทารกเลยเด็ดขาด ออกแบบมาให้เป็นวิดีโอคู่กับเทมเพลตภาพที่เข้าชุดกันโดยตรง เพื่อให้ภาพนิ่งและคลิปสามารถนำเสนอเป็นคู่ได้ ภาพอ้างอิง: เทมเพลตภาพสกรีนช็อตจูล่งฝ่าวงล้อมอุ้มทารก',
  },
  'vintage-disney-style-pirate-crocodile-animation': {
    title: 'แอนิเมชันจระเข้โจรสลัดสไตล์ดิสนีย์วินเทจ',
    summary:
      'พรอมต์เล่าเรื่องแบบหลายฉากสำหรับแอนิเมชันสไตล์ดิสนีย์วินเทจคลาสสิก ที่นำเสนอจระเข้โจรสลัดและนกโจรสลัดบนเรือ',
  },
  'viral-k-pop-dance-choreography': {
    title: 'ท่าเต้นคอริโอกราฟี K-pop สุดไวรัล',
    summary:
      'พรอมต์ที่มีรายละเอียดสำหรับ Seedance 2.0 เพื่อทำแอนิเมชันตัวละครที่กำลังเต้นรำตามภาพอ้างอิงสตอรีบอร์ด 16 ช่อง',
  },
  'wasteland-factory-chase': {
    title: 'การไล่ล่าในโรงงานดินแดนรกร้าง',
    summary:
      'พรอมต์แนวภาพยนตร์สำหรับฉากดินแดนทะเลทรายรกร้างความเร็วสูง ที่นำเสนอโรงงานอุตสาหกรรมเคลื่อนที่ได้บนขา และการไล่ล่าด้วยมอเตอร์ไซค์ของกลุ่มกบฏ',
  },
};
